import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  printStackTrace18lnx7a39cni as printStackTrace,
  Unit_instanceat14thlj150z as Unit_instance,
  CancellationException3b36o9qz53rgr as CancellationException,
  ArrayList3it5z8td81qkl as ArrayList,
  addAll1k27qatfgp3k5 as addAll,
  toSet2orjxp16sotqu as toSet,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  addAll21mdhg523wnoa as addAll_0,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  VOID7hggqo3abtya as VOID,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__hashCode_impl_u4exz629330ogi7dvp as Duration__hashCode_impl_u4exz6,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  toHexString5bhtjxqec7ow as toHexString,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  sorted354mfsiv4s7x5 as sorted,
  toString30pk9tzaqopn as toString_0,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  RuntimeException1r3t0zl97011n as RuntimeException,
  captureStack1fzi4aczwc4hg as captureStack,
  KProperty02ce7r476m8633 as KProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  to2cs3ny02qtbcb as to,
  toMap1vec9topfei08 as toMap,
  Enum3alwj03lh1n41 as Enum,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  Long2qws0ah9gnpki as Long,
  toLongw1zpgk99d84b as toLong,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  numberToLong1a4cndvg6c52s as numberToLong,
  toDurationba1nlt78o6vu as toDuration_0,
  mapOf1xd03cq9cnmy8 as mapOf,
  toInt2q8uldh7sc951 as toInt,
  getOrNullef5jbxih7r4f as getOrNull,
  _UByteArray___init__impl__ip4y9n3sp5zyufbcv0v as _UByteArray___init__impl__ip4y9n,
  UByteArray__get_impl_t5f3hv1encpe8trq9zx as UByteArray__get_impl_t5f3hv,
  _UByte___get_data__impl__jof9qr1jhbnu489etgz as _UByte___get_data__impl__jof9qr,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  _Duration___get_inWholeNanoseconds__impl__r5x4mr3elpl3cwdan58 as _Duration___get_inWholeNanoseconds__impl__r5x4mr,
  copyOf39s58md6y6rn6 as copyOf,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  println2shhhgwwt4c61 as println,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toShort36kaw0zjdq3ex as toShort,
  _UByte___init__impl__g9hnc43i8t7wecfr79w as _UByte___init__impl__g9hnc4,
  UBytep4j7r1t64gz1 as UByte,
  UByte__hashCode_impl_mmczcb2bk1orv63vhkp as UByte__hashCode_impl_mmczcb,
  createThis2j2avj17cvnv2 as createThis,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  fill3lmv1pckd4inv as fill,
  fill34ox8qmmmh3u3 as fill_0,
  until1jbpn0z3f8lbg as until,
  step18s9qzr5xwxat as step,
  _UInt___init__impl__l7qpdl2x2ja0qtrydmg as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw1wfqgh301wggv as _UInt___get_data__impl__f0vqqw,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  getOrNull1d60i0672n7ns as getOrNull_0,
  get_lastIndexx0qsydpfv3mu as get_lastIndex,
  compareTo3ankvs086tmwq as compareTo,
  boxApply1qmzdb3dh90hg as boxApply,
  KProperty1ca4yb4wlo496 as KProperty1,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
} from './kotlin-kotlin-stdlib.mjs';
import { Mixin3lmkm5hum2vdj as Mixin } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  get_milliseconds20vru1dkca6bq as get_milliseconds,
  get_secondsjblpw5qd4dzj as get_seconds,
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_0,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  get_niceStr3crhxydmlnaoj as get_niceStr,
  extract2vhru1ihy4ogl as extract,
  hasFlagsibfubl68mj8u as hasFlags,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  withContext3ioifgw29h7cj as withContext,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  delay1blitpytzu6gr as delay,
  yield17af0dtgvr9x7 as yield_0,
  delay1f60wyf8ua1gc as delay_0,
  CoroutineScopelux7s7zphw7e as CoroutineScope_0,
  launch1c91vkjzdi9sd as launch,
} from './kotlinx-coroutines-core.mjs';
import {
  readBytesUpTo2jsx0o5buj2sw as readBytesUpTo,
  readStream3f0dxaq1c55fg as readStream,
  toSyncOrNull2d7etdx5kh7ns as toSyncOrNull,
  readBytesUpTo1px2t44z4b9v7 as readBytesUpTo_0,
  openSync2m3qn99fqytu0 as openSync,
  readString20u8kjncp0xlx as readString,
  readString3h14fm47a2tde as readString_0,
  readBytesExact305h8zdeltghk as readBytesExact,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  readS16LE3rt2utyxlgw3g as readS16LE,
  readS32LE2r371m40u4y6y as readS32LE,
  readU32LE31t9li7x6s60w as readU32LE,
  MemorySyncStreamw5bwb9yy0cam as MemorySyncStream,
  toAsyncc87ncfb6nti7 as toAsync,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import {
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  binarySearch1lxbagta5e4q4 as binarySearch,
  _BSearchResult___get_nearIndex__impl__s8nq431w00iur5bsqs2 as _BSearchResult___get_nearIndex__impl__s8nq43,
  ByteArrayDeque2dezgzzyyl6zm as ByteArrayDeque,
  ShortArrayDeque13dn2tr6asm80 as ShortArrayDeque,
  ConcurrentPool3ky1e4r5za9ab as ConcurrentPool,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  _UByteArrayInt___init__impl__xif7bu3la1vncefaitd as _UByteArrayInt___init__impl__xif7bu,
  _UByteArrayInt___get_bytes__impl__pj0ilcub6wlvph43r as _UByteArrayInt___get_bytes__impl__pj0ilc,
  UByteArrayInt__get_impl_px6q8a2tesw5a6a7pt2 as UByteArrayInt__get_impl_px6q8a,
  getU83agrw8yj0shar as getU8,
  indexOf1wbggs5i7ilsw as indexOf,
  _UByteArrayInt___init__impl__xif7bu29rfv0s29knch as _UByteArrayInt___init__impl__xif7bu_0,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  _UByteArrayInt___init__impl__xif7bu3qwnn3s49fymk as _UByteArrayInt___init__impl__xif7bu_1,
  UByteArrayInt__set_impl_gn45323mc9aqt29pp9p as UByteArrayInt__set_impl_gn4532,
  arraycopy52dxe7vhzf14 as arraycopy,
  arraycopy3n78tfzvkl4kg as arraycopy_0,
  UByteArrayInt__set_impl_gn45321v79kdhd4y5qt as UByteArrayInt__set_impl_gn4532_0,
  UByteArrayInt__fill$default_impl_mdydxi1wz00ttbtxw3z as UByteArrayInt__fill$default_impl_mdydxi,
  getS16LE39jsuv9u9gi4y as getS16LE,
  getS24LE1b229asvs5i3l as getS24LE,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  Charsets_instance2e55bmt8joybi as Charsets_instance,
  readStringzinkjpjt71hyo as readStringz,
} from './korlibs-string-root-korlibs-string.mjs';
import {
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  invalidOp1stebxh2m3n07 as invalidOp,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  _AudioSampleArray___init__impl__qpxoq02y04g82w4ty79 as _AudioSampleArray___init__impl__qpxoq0,
  _AudioSample___init__impl__s54gd52xugxuumb5p5l as _AudioSample___init__impl__s54gd5,
  AudioSampleArray__set_impl_tqgfwk2e4yme6xw91vg as AudioSampleArray__set_impl_tqgfwk,
  _AudioSample___get_short__impl__uk8ygu25qxorykipf8f as _AudioSample___get_short__impl__uk8ygu,
  AudioSampleArray__asShortArray_impl_iyd0md153iqk9vsos7c as AudioSampleArray__asShortArray_impl_iyd0md,
  AudioSampleArray__get_impl_w0l0xc3ifihtwr00dm3 as AudioSampleArray__get_impl_w0l0xc,
  _AudioSampleArray___get_size__impl__8l8tm8x01vap0727wl as _AudioSampleArray___get_size__impl__8l8tm8,
  AudioSampleArray262uyoodhuuvf as AudioSampleArray,
  AudioSamples3pmkh9en9mrjs as AudioSamples,
  AudioData3ewbxcbopprh8 as AudioData,
  ReadonlySoundProps270enpa6r4amt as ReadonlySoundProps,
  SoundProps3stqh6vq4ra4p as SoundProps,
  get_nativeSoundProvider1b6rsunmfcp5k as get_nativeSoundProvider,
  Companion_getInstance2wrvcuzneq6bn as Companion_getInstance_1,
  AudioSampleArray__fill$default_impl_gh9lh0607zwvqcotvv as AudioSampleArray__fill$default_impl_gh9lh0,
  Companion_instance1o81m7d7a4ex as Companion_instance,
} from './korlibs-audio-core-root-korlibs-audio-core.mjs';
import {
  getUnderlyingUnscapedFilej1r5tpfxb7a7 as getUnderlyingUnscapedFile,
  get_baseName2yf63efofm8te as get_baseName,
} from './korlibs-io-vfs-root-korlibs-io-vfs.mjs';
import { Companion_getInstance1yq7a1f60lp2k as Companion_getInstance_2 } from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  onCancel134048q5p9j85 as onCancel,
  Lock5n7hh3dgcidl as Lock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class Companion {
  z5t(formats) {
    return (new AudioFormats()).d5u(formats.slice());
  }
}
class AudioFormat {
  constructor(exts) {
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.audio.format.AudioFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.lowercase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.h(tmp$ret$3);
    }
    tmp.e5u_1 = toSet(destination);
  }
  j5u() {
    return this.e5u_1;
  }
  f5u(data, props, $completion) {
    return null;
  }
  k5u(data, props, $completion) {
    return null;
  }
  i5u(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStream__ydjika.bind(VOID, this, data, props), $completion);
  }
  l5u(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamOrError__s0emn1.bind(VOID, this, data, props), $completion);
  }
  l3() {
    return 'AudioFormat';
  }
  toString() {
    return this.l3() + '(' + toString(sorted(this.j5u())) + ')';
  }
}
class AudioFormats extends AudioFormat {
  constructor() {
    super([]);
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.b5u_1 = ArrayList.i1();
    this.c5u_1 = null;
  }
  j5u() {
    if (this.c5u_1 == null) {
      var tmp = this;
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.b5u_1;
      var destination = ArrayList.i1();
      var tmp0_iterator = this_0.a1();
      while (tmp0_iterator.b1()) {
        var element = tmp0_iterator.c1();
        // Inline function 'korlibs.audio.format.AudioFormats.<get-extensions>.<anonymous>' call
        var list = element.j5u();
        addAll(destination, list);
      }
      tmp.c5u_1 = toSet(destination);
    }
    return ensureNotNull(this.c5u_1);
  }
  d5u(formats) {
    // Inline function 'kotlin.apply' call
    var this_0 = invalidate(this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.AudioFormats.register.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this_0.b5u_1;
    addAll_0(this_1, formats);
    return this_0;
  }
  f5u(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh.bind(VOID, this, data, props), $completion);
  }
  k5u(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamInternal__hls877.bind(VOID, this, data, props), $completion);
  }
}
class Info {
  constructor(duration, channels, decodingTime) {
    var tmp;
    if (duration === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = duration;
    }
    duration = tmp;
    channels = channels === VOID ? 2 : channels;
    decodingTime = decodingTime === VOID ? null : decodingTime;
    this.m5u_1 = new Mixin();
    this.n5u_1 = duration;
    this.o5u_1 = channels;
    this.p5u_1 = decodingTime;
  }
  cz(_set____db54di) {
    this.m5u_1.cz(_set____db54di);
  }
  dz() {
    return this.m5u_1.dz();
  }
  q5u() {
    var tmp0_elvis_lhs = this.n5u_1;
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'Info(duration=' + get_niceStr(get_milliseconds(this.q5u())) + 'ms, channels=' + this.o5u_1 + ')';
  }
  hashCode() {
    var tmp;
    var tmp_0 = this.n5u_1;
    if ((tmp_0 == null ? null : new Duration(tmp_0)) == null) {
      tmp = 0;
    } else {
      tmp = Duration__hashCode_impl_u4exz6(this.n5u_1);
    }
    var result = tmp;
    result = imul(result, 31) + this.o5u_1 | 0;
    var tmp_1 = imul(result, 31);
    var tmp_2;
    var tmp_3 = this.p5u_1;
    if ((tmp_3 == null ? null : new Duration(tmp_3)) == null) {
      tmp_2 = 0;
    } else {
      tmp_2 = Duration__hashCode_impl_u4exz6(this.p5u_1);
    }
    result = tmp_1 + tmp_2 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Info))
      return false;
    var tmp0_other_with_cast = other instanceof Info ? other : THROW_CCE();
    var tmp = this.n5u_1;
    var tmp_0 = tmp == null ? null : new Duration(tmp);
    var tmp_1 = tmp0_other_with_cast.n5u_1;
    if (!equals(tmp_0, tmp_1 == null ? null : new Duration(tmp_1)))
      return false;
    if (!(this.o5u_1 === tmp0_other_with_cast.o5u_1))
      return false;
    var tmp_2 = this.p5u_1;
    var tmp_3 = tmp_2 == null ? null : new Duration(tmp_2);
    var tmp_4 = tmp0_other_with_cast.p5u_1;
    if (!equals(tmp_3, tmp_4 == null ? null : new Duration(tmp_4)))
      return false;
    return true;
  }
}
class AudioFormat$decodeStream$slambda {
  constructor(this$0, $data, $props) {
    this.x5u_1 = this$0;
    this.y5u_1 = $data;
    this.z5u_1 = $props;
  }
  h1p($this$withContext, $completion) {
    return this.x5u_1.k5u(this.y5u_1, this.z5u_1, $completion);
  }
  wd(p1, $completion) {
    return this.h1p((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_1 = this;
    this.g5u_1 = new AudioDecodingProps();
    this.h5u_1 = new AudioDecodingProps(false, false);
  }
}
class AudioDecodingProps {
  constructor(exactTimings, readInMemory, formats, maxSamples, dispatcher) {
    Companion_getInstance_4();
    exactTimings = exactTimings === VOID ? null : exactTimings;
    readInMemory = readInMemory === VOID ? true : readInMemory;
    formats = formats === VOID ? null : formats;
    maxSamples = maxSamples === VOID ? 39690000 : maxSamples;
    dispatcher = dispatcher === VOID ? null : dispatcher;
    this.r5u_1 = new Mixin();
    this.s5u_1 = exactTimings;
    this.t5u_1 = readInMemory;
    this.u5u_1 = formats;
    this.v5u_1 = maxSamples;
    this.w5u_1 = dispatcher;
  }
  cz(_set____db54di) {
    this.r5u_1.cz(_set____db54di);
  }
  dz() {
    return this.r5u_1.dz();
  }
  toString() {
    return 'AudioDecodingProps(exactTimings=' + this.s5u_1 + ', readInMemory=' + this.t5u_1 + ', formats=' + toString_0(this.u5u_1) + ', maxSamples=' + this.v5u_1 + ', dispatcher=' + toString_0(this.w5u_1) + ')';
  }
  hashCode() {
    var result = this.s5u_1 == null ? 0 : getBooleanHashCode(this.s5u_1);
    result = imul(result, 31) + getBooleanHashCode(this.t5u_1) | 0;
    result = imul(result, 31) + (this.u5u_1 == null ? 0 : hashCode(this.u5u_1)) | 0;
    result = imul(result, 31) + this.v5u_1 | 0;
    result = imul(result, 31) + (this.w5u_1 == null ? 0 : hashCode(this.w5u_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AudioDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof AudioDecodingProps ? other : THROW_CCE();
    if (!(this.s5u_1 == tmp0_other_with_cast.s5u_1))
      return false;
    if (!(this.t5u_1 === tmp0_other_with_cast.t5u_1))
      return false;
    if (!equals(this.u5u_1, tmp0_other_with_cast.u5u_1))
      return false;
    if (!(this.v5u_1 === tmp0_other_with_cast.v5u_1))
      return false;
    if (!equals(this.w5u_1, tmp0_other_with_cast.w5u_1))
      return false;
    return true;
  }
}
class InvalidAudioFormatException extends RuntimeException {
  static d5v(message) {
    var $this = this.pa(message);
    captureStack($this, $this.c5v_1);
    return $this;
  }
}
class MP3Base extends AudioFormat {
  constructor() {
    super(['mp3']);
  }
  f5u(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh_0.bind(VOID, this, data, props), $completion);
  }
}
class MP3 extends MP3Base {
  constructor() {
    Companion_getInstance_5();
    super();
  }
}
class Companion_1 extends MP3 {
  constructor() {
    Companion_instance_2 = null;
    super();
    Companion_instance_2 = this;
  }
}
class Companion_2 {
  constructor() {
    Companion_instance_3 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = values();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(this_0.length);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var item = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.audio.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = to(item.h5v_1, item);
      destination.h(tmp$ret$0);
    }
    tmp.j5v_1 = toMap(destination);
  }
}
class ChannelMode extends Enum {
  constructor(name, ordinal, id, channels) {
    super(name, ordinal);
    this.h5v_1 = id;
    this.i5v_1 = channels;
  }
}
class Mp3Info {
  constructor(version, layer, bitrate, samplingRate, channelMode, frameSize, samples) {
    this.k5v_1 = version;
    this.l5v_1 = layer;
    this.m5v_1 = bitrate;
    this.n5v_1 = samplingRate;
    this.o5v_1 = channelMode;
    this.p5v_1 = frameSize;
    this.q5v_1 = samples;
  }
  toString() {
    return 'Mp3Info(version=' + this.k5v_1 + ', layer=' + this.l5v_1 + ', bitrate=' + this.m5v_1 + ', samplingRate=' + this.n5v_1 + ', channelMode=' + this.o5v_1.toString() + ', frameSize=' + this.p5v_1 + ', samples=' + this.q5v_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.k5v_1);
    result = imul(result, 31) + this.l5v_1 | 0;
    result = imul(result, 31) + this.m5v_1 | 0;
    result = imul(result, 31) + this.n5v_1 | 0;
    result = imul(result, 31) + this.o5v_1.hashCode() | 0;
    result = imul(result, 31) + this.p5v_1 | 0;
    result = imul(result, 31) + this.q5v_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Mp3Info))
      return false;
    var tmp0_other_with_cast = other instanceof Mp3Info ? other : THROW_CCE();
    if (!(this.k5v_1 === tmp0_other_with_cast.k5v_1))
      return false;
    if (!(this.l5v_1 === tmp0_other_with_cast.l5v_1))
      return false;
    if (!(this.m5v_1 === tmp0_other_with_cast.m5v_1))
      return false;
    if (!(this.n5v_1 === tmp0_other_with_cast.n5v_1))
      return false;
    if (!this.o5v_1.equals(tmp0_other_with_cast.o5v_1))
      return false;
    if (!(this.p5v_1 === tmp0_other_with_cast.p5v_1))
      return false;
    if (!(this.q5v_1 === tmp0_other_with_cast.q5v_1))
      return false;
    return true;
  }
}
class Companion_3 {
  constructor() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.u5v_1 = ['2.5', 'x', '2', '1'];
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.v5v_1 = new Int32Array([-1, 3, 2, 1]);
    var tmp_1 = this;
    var tmp_2 = this.a5w(1, 1);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$4 = new Int32Array([0, 32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448]);
    var tmp_3 = to(tmp_2, tmp$ret$4);
    var tmp_4 = this.a5w(1, 2);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$5 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384]);
    var tmp_5 = to(tmp_4, tmp$ret$5);
    var tmp_6 = this.a5w(1, 3);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$6 = new Int32Array([0, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320]);
    var tmp_7 = to(tmp_6, tmp$ret$6);
    var tmp_8 = this.a5w(2, 1);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$7 = new Int32Array([0, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256]);
    var tmp_9 = to(tmp_8, tmp$ret$7);
    var tmp_10 = this.a5w(2, 2);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$8 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    var tmp_11 = to(tmp_10, tmp$ret$8);
    var tmp_12 = this.a5w(2, 3);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$9 = new Int32Array([0, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160]);
    tmp_1.w5v_1 = mapOf([tmp_3, tmp_5, tmp_7, tmp_9, tmp_11, to(tmp_12, tmp$ret$9)]);
    var tmp_13 = this;
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$10 = new Int32Array([44100, 48000, 32000]);
    var tmp_14 = to('1', tmp$ret$10);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$11 = new Int32Array([22050, 24000, 16000]);
    var tmp_15 = to('2', tmp$ret$11);
    // Inline function 'kotlin.intArrayOf' call
    var tmp$ret$12 = new Int32Array([11025, 12000, 8000]);
    tmp_13.x5v_1 = mapOf([tmp_14, tmp_15, to('2.5', tmp$ret$12)]);
    this.y5v_1 = mapOf([to(1, mapOf([to(1, 384), to(2, 1152), to(3, 1152)])), to(2, mapOf([to(1, 384), to(2, 1152), to(3, 576)]))]);
  }
  a5w(version, layer) {
    return imul(version, 10) + layer | 0;
  }
  z5v(f4) {
    var b0 = UByteArrayInt__get_impl_px6q8a(f4, 0);
    var b1 = UByteArrayInt__get_impl_px6q8a(f4, 1);
    var b2 = UByteArrayInt__get_impl_px6q8a(f4, 2);
    var b3 = UByteArrayInt__get_impl_px6q8a(f4, 3);
    if (!(b0 === 255)) {
      get_invalidOp();
    }
    var version = this.u5v_1[extract(b1, 3, 2)];
    var simple_version = version === '2.5' ? 2 : toInt(version);
    var layer = this.v5v_1[extract(b1, 1, 2)];
    var protection_bit = extract(b1, 0, 1);
    var bitrate_key = this.a5w(simple_version, layer);
    var bitrate_idx = extract(b2, 4, 4);
    var tmp6_safe_receiver = this.w5v_1.z2(bitrate_key);
    var tmp0_elvis_lhs = tmp6_safe_receiver == null ? null : getOrNull(tmp6_safe_receiver, bitrate_idx);
    var bitrate = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp7_safe_receiver = this.x5v_1.z2(version);
    var tmp1_elvis_lhs = tmp7_safe_receiver == null ? null : getOrNull(tmp7_safe_receiver, extract(b2, 2, 2));
    var sample_rate = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var padding_bit = extract(b2, 1, 1);
    var private_bit = extract(b2, 0, 1);
    var channelMode = ensureNotNull(Companion_getInstance_6().j5v_1.z2(extract(b3, 6, 2)));
    var mode_extension_bits = extract(b3, 4, 2);
    var copyright_bit = extract(b3, 3, 1);
    var original_bit = extract(b3, 2, 1);
    var emphasis = extract(b3, 0, 2);
    var tmp = framesize(this, layer, bitrate, sample_rate, padding_bit);
    var tmp8_safe_receiver = this.y5v_1.z2(simple_version);
    var tmp2_elvis_lhs = tmp8_safe_receiver == null ? null : tmp8_safe_receiver.z2(layer);
    return new Mp3Info(version, layer, bitrate, sample_rate, channelMode, tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
  }
}
class SeekingTable {
  constructor(microseconds, filePositions) {
    this.d5w_1 = microseconds;
    this.e5w_1 = filePositions;
  }
  f5w() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = this.d5w_1.d1(this.d5w_1.e1() - 1 | 0);
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  g5w(rate) {
    return numberToLong(get_seconds(this.f5w()) * rate);
  }
  h5w(time) {
    // Inline function 'korlibs.time.microseconds' call
    var searchMicro = _Duration___get_inWholeNanoseconds__impl__r5x4mr(time).g4() / 1000.0;
    var result = binarySearch(this.d5w_1, searchMicro);
    return numberToLong(this.e5w_1.d1(_BSearchResult___get_nearIndex__impl__s8nq43(result)));
  }
}
class Parser {
  constructor(data, dataLength) {
    Companion_getInstance_7();
    this.r5v_1 = data;
    this.s5v_1 = dataLength;
    this.t5v_1 = null;
  }
  c5w($completion) {
    return _getDuration$default(this, true, VOID, $completion);
  }
  b5w($completion) {
    return _getDuration$default(this, false, VOID, $completion);
  }
  i5w($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_getSeekingTable__ywx4sa.bind(VOID, this), $completion);
  }
}
class MP3Decoder extends AudioFormat {
  constructor() {
    Companion_getInstance_8();
    super(['mp3']);
    this.k5w_1 = Minimp3AudioFormat_getInstance();
  }
  f5u(data, props, $completion) {
    return this.k5w_1.f5u(data, props, $completion);
  }
  k5u(data, props, $completion) {
    return this.k5w_1.i5u(data, props, $completion);
  }
  toString() {
    return 'NativeMp3DecoderFormat';
  }
}
class Companion_4 extends MP3Decoder {
  constructor() {
    Companion_instance_5 = null;
    super();
    Companion_instance_5 = this;
  }
}
class MiniMp3Program {
  constructor() {
    Companion_getInstance_10();
    this.e5x_1 = new Int32Array(3);
    this.f5x_1 = new Float32Array(9);
    this.g5x_1 = new Float32Array(9);
    this.h5x_1 = new Float32Array(4);
    this.i5x_1 = new Float32Array(4);
    this.j5x_1 = Mp3Scratch.k63();
    this.k5x_1 = new Bs();
  }
  k5y(dst, src, size) {
    arraycopy(src.s63_1, src.t63_1, dst.s63_1, dst.t63_1, size);
  }
  l5y(dst, src, size) {
    arraycopy_0(src.o63_1, src.p63_1, dst.o63_1, dst.p63_1, size);
  }
  m5y(bs, data, bytes) {
    bs.z62_1 = data;
    bs.a63_1 = 0;
    bs.b63_1 = imul(bytes, 8);
  }
  n5y(bs, n) {
    var cache = 0;
    var s = bs.a63_1 & 7;
    var shl = n + s | 0;
    var p = bs.z62_1.n63(bs.a63_1 >>> 3 | 0);
    bs.a63_1 = bs.a63_1 + n | 0;
    if (bs.a63_1 > bs.b63_1)
      return 0;
    var next = p.n1() & (255 >>> s | 0);
    p = p.v3();
    $l$loop: while (true) {
      shl = shl - 8 | 0;
      if (shl <= 0)
        break $l$loop;
      cache = cache | next << shl;
      next = p.n1();
      p = p.v3();
    }
    return cache | (next >>> (-shl | 0) | 0);
  }
  o5y(h) {
    var h0 = h.d1(0);
    var h1 = h.d1(1);
    var h2 = h.d1(2);
    return h0 === 255 && ((h1 & 240) === 240 || (h1 & 254) === 226) && !((h1 >> 1 & 3) === 0) && !(h2 >> 4 === 15) && !((h2 >> 2 & 3) === 3);
  }
  p5y(h1, h2) {
    return toInt_0(this.o5y(h2) && ((h1.d1(1) ^ h2.d1(1)) & 254) === 0 && ((h1.d1(2) ^ h2.d1(2)) & 12) === 0 && (toInt_0((h1.d1(2) & 240) === 0, this) ^ toInt_0((h2.d1(2) & 240) === 0, this)) === 0, this);
  }
  q5y(h) {
    return imul(2, UByteArrayInt__get_impl_px6q8a(Companion_getInstance_10().c62_1[toInt_0(!((h.d1(1) & 8) === 0), this)][(h.d1(1) >> 1 & 3) - 1 | 0].g13_1, h.d1(2) >> 4));
  }
  r5y(h) {
    var g_hz = Companion_getInstance_10().b62_1;
    return g_hz[h.d1(2) >> 2 & 3] >> toInt_0((h.d1(1) & 8) === 0, this) >> toInt_0((h.d1(1) & 16) === 0, this);
  }
  s5y(h) {
    return (h.d1(1) & 6) === 6 ? 384 : 1152 >> toInt_0((h.d1(1) & 14) === 2, this);
  }
  t5y(h, free_format_size) {
    var frame_bytes = imul(imul(this.s5y(h), this.q5y(h)), 125) / this.r5y(h) | 0;
    if ((h.d1(1) & 6) === 6) {
      frame_bytes = frame_bytes & -4;
    }
    return !(frame_bytes === 0) ? frame_bytes : free_format_size;
  }
  u5y(h) {
    return !((h.d1(2) & 2) === 0) ? (h.d1(1) & 6) === 6 ? 4 : 1 : 0;
  }
  v5y(hdr, sci) {
    var alloc = Companion_getInstance_10().q62_1;
    var mode = hdr.d1(3) >> 6 & 3;
    var nbands;
    var stereo_bands;
    switch (mode) {
      case 3:
        stereo_bands = 0;
        break;
      case 1:
        stereo_bands = ((hdr.d1(3) >> 4 & 3) << 2) + 4 | 0;
        break;
      default:
        stereo_bands = 32;
        break;
    }
    if ((hdr.d1(1) & 6) === 6) {
      alloc = Companion_getInstance_10().q62_1;
      nbands = 32;
    } else if ((hdr.d1(1) & 8) === 0) {
      alloc = Companion_getInstance_10().r62_1;
      nbands = 30;
    } else {
      var sample_rate_idx = hdr.d1(2) >> 2 & 3;
      var kbps = this.q5y(hdr) >> toInt_0(!(mode === 3), this);
      if (kbps === 0)
        kbps = 192;
      alloc = Companion_getInstance_10().s62_1;
      nbands = 27;
      if (kbps < 56) {
        alloc = Companion_getInstance_10().t62_1;
        nbands = sample_rate_idx === 2 ? 12 : 8;
      } else if (kbps >= 96 && !(sample_rate_idx === 1)) {
        nbands = 30;
      }
    }
    sci.s64_1 = nbands;
    sci.t64_1 = stereo_bands > nbands ? nbands : stereo_bands;
    return alloc;
  }
  w5y(bs, pba, scfcod, bands, scf) {
    var scfOffset = 0;
    var g_deq_L12 = Companion_getInstance_10().a62_1;
    var inductionVariable = 0;
    if (inductionVariable < bands)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var s = 0.0;
        var ba = UByteArrayInt__get_impl_px6q8a(pba, i);
        var mask = !(ba === 0) ? 4 + (19 >> UByteArrayInt__get_impl_px6q8a(scfcod, i) & 3) | 0 : 0;
        var m = 4;
        while (!(m === 0)) {
          if (!((mask & m) === 0)) {
            var b = this.n5y(bs, 6);
            s = g_deq_L12[(imul(ba, 3) - 6 | 0) + (b % 3 | 0) | 0] * (2097152 >> (b / 3 | 0));
          }
          scf.v63(scfOffset, s);
          m = m >> 1;
          scfOffset = scfOffset + 1 | 0;
        }
      }
       while (inductionVariable < bands);
  }
  x5y(hdr, bs, sci) {
    var g_bitalloc_code_tab = new UByteArrayIntPtr(Companion_getInstance_10().l62_1);
    var subband_alloc = this.v5y(hdr, sci);
    var subband_alloc_n = 0;
    var k = 0;
    var ba_bits = 0;
    var ba_code_tab = g_bitalloc_code_tab;
    var inductionVariable = 0;
    var last = sci.s64_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ba = 0;
        if (i === k) {
          var tmp = k;
          // Inline function 'kotlin.UByte.toInt' call
          var this_0 = subband_alloc[subband_alloc_n].x62_1;
          k = tmp + (_UByte___get_data__impl__jof9qr(this_0) & 255) | 0;
          // Inline function 'kotlin.UByte.toInt' call
          var this_1 = subband_alloc[subband_alloc_n].w62_1;
          ba_bits = _UByte___get_data__impl__jof9qr(this_1) & 255;
          // Inline function 'kotlin.UByte.toInt' call
          var this_2 = subband_alloc[subband_alloc_n].v62_1;
          var tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_2) & 255;
          ba_code_tab = g_bitalloc_code_tab.n63(tmp$ret$2);
          subband_alloc_n = subband_alloc_n + 1 | 0;
        }
        ba = ba_code_tab.d1(this.n5y(bs, ba_bits));
        UByteArrayInt__set_impl_gn4532(sci.u64_1, imul(2, i), ba);
        if (i < sci.t64_1) {
          ba = ba_code_tab.d1(this.n5y(bs, ba_bits));
        }
        UByteArrayInt__set_impl_gn4532(sci.u64_1, imul(2, i) + 1 | 0, !(sci.t64_1 === 0) ? ba : 0);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = 0;
    var last_0 = imul(2, sci.s64_1);
    if (inductionVariable_0 < last_0)
      do {
        var i_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        UByteArrayInt__set_impl_gn4532(sci.v64_1, i_0, !(UByteArrayInt__get_impl_px6q8a(sci.u64_1, i_0) === 0) ? (hdr.d1(1) & 6) === 6 ? 2 : this.n5y(bs, 2) : 6);
      }
       while (inductionVariable_0 < last_0);
    this.w5y(bs, sci.u64_1, sci.v64_1, imul(sci.s64_1, 2), new FloatArrayPtr(sci.r64_1));
    var inductionVariable_1 = sci.t64_1;
    var last_1 = sci.s64_1;
    if (inductionVariable_1 < last_1)
      do {
        var i_1 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        UByteArrayInt__set_impl_gn4532(sci.u64_1, imul(2, i_1) + 1 | 0, 0);
      }
       while (inductionVariable_1 < last_1);
  }
  y5y(grbuf, bs, sci, group_size) {
    var choff = 576;
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dst = grbuf.n63(imul(group_size, j));
        var inductionVariable_0 = 0;
        var last = imul(2, sci.s64_1);
        if (inductionVariable_0 < last)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var ba = UByteArrayInt__get_impl_px6q8a(sci.u64_1, i);
            if (!(ba === 0)) {
              if (ba < 17) {
                var half = (1 << (ba - 1 | 0)) - 1 | 0;
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < group_size)
                  do {
                    var k = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    dst.v63(k, this.n5y(bs, ba) - half | 0);
                  }
                   while (inductionVariable_1 < group_size);
              } else {
                var mod = (2 << (ba - 17 | 0)) + 1 | 0;
                var code = this.n5y(bs, (mod + 2 | 0) - (mod >> 3) | 0);
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < group_size)
                  do {
                    var k_0 = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    dst.v63(k_0, (code % mod | 0) - (mod / 2 | 0) | 0);
                    code = code / mod | 0;
                  }
                   while (inductionVariable_2 < group_size);
              }
            }
            dst = dst.n63(choff);
            choff = 18 - choff | 0;
          }
           while (inductionVariable_0 < last);
      }
       while (inductionVariable < 4);
    return imul(group_size, 4);
  }
  z5y(sci, scf, dst) {
    var scf_0 = scf;
    var dst_0 = dst;
    this.k5y(dst_0.n63(576).n63(imul(sci.t64_1, 18)), dst_0.n63(imul(sci.t64_1, 18)), imul(sci.s64_1 - sci.t64_1 | 0, 18));
    var inductionVariable = 0;
    var last = sci.s64_1;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 12)
          do {
            var k = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            dst_0.v63(k + 0 | 0, dst_0.d1(k + 0 | 0) * scf_0.d1(0));
            dst_0.v63(k + 576 | 0, dst_0.d1(k + 576 | 0) * scf_0.d1(3));
          }
           while (inductionVariable_0 < 12);
        dst_0 = dst_0.n63(18);
        scf_0 = scf_0.n63(6);
      }
       while (inductionVariable < last);
  }
  a5z(bs, gr, hdr) {
    var gr_0 = gr;
    var g_scf_long = Companion_getInstance_10().m62_1;
    var g_scf_short = Companion_getInstance_10().n62_1;
    var g_scf_mixed = Companion_getInstance_10().o62_1;
    var tables;
    var scfsi = 0;
    var main_data_begin;
    var part_23_sum = 0;
    var sr_idx = (hdr.d1(2) >> 2 & 3) + imul((hdr.d1(1) >> 3 & 1) + (hdr.d1(1) >> 4 & 1) | 0, 3) | 0;
    sr_idx = sr_idx - toInt_0(!(sr_idx === 0), this) | 0;
    var gr_count = (hdr.d1(3) & 192) === 192 ? 1 : 2;
    if (!((hdr.d1(1) & 8) === 0)) {
      gr_count = imul(gr_count, 2);
      main_data_begin = this.n5y(bs, 9);
      scfsi = this.n5y(bs, 7 + gr_count | 0);
    } else {
      main_data_begin = this.n5y(bs, 8 + gr_count | 0) >> gr_count;
    }
    $l$1: do {
      $l$0: do {
        if ((hdr.d1(3) & 192) === 192) {
          scfsi = scfsi << 4;
        }
        gr_0.n1().c64_1 = this.n5y(bs, 12);
        part_23_sum = part_23_sum + gr_0.n1().c64_1 | 0;
        gr_0.n1().d64_1 = this.n5y(bs, 9);
        if (gr_0.n1().d64_1 > 288)
          return -1;
        gr_0.n1().f64_1 = this.n5y(bs, 8);
        gr_0.n1().e64_1 = this.n5y(bs, !((hdr.d1(1) & 8) === 0) ? 4 : 9);
        gr_0.n1().b64_1 = new UByteArrayIntPtr(g_scf_long[sr_idx].g13_1);
        gr_0.n1().i64_1 = 22;
        gr_0.n1().j64_1 = 0;
        if (!(this.n5y(bs, 1) === 0)) {
          gr_0.n1().g64_1 = this.n5y(bs, 2);
          if (gr_0.n1().g64_1 === 0)
            return -1;
          gr_0.n1().h64_1 = this.n5y(bs, 1);
          UByteArrayInt__set_impl_gn4532_0(gr_0.n1().l64_1, 0, _UByte___init__impl__g9hnc4(7));
          UByteArrayInt__set_impl_gn4532(gr_0.n1().l64_1, 1, 255);
          if (gr_0.n1().g64_1 === 2) {
            scfsi = scfsi & 3855;
            if (gr_0.n1().h64_1 === 0) {
              UByteArrayInt__set_impl_gn4532(gr_0.n1().l64_1, 0, 8);
              gr_0.n1().b64_1 = new UByteArrayIntPtr(g_scf_short[sr_idx].g13_1);
              gr_0.n1().i64_1 = 0;
              gr_0.n1().j64_1 = 39;
            } else {
              gr_0.n1().b64_1 = new UByteArrayIntPtr(g_scf_mixed[sr_idx].g13_1);
              gr_0.n1().i64_1 = !((hdr.d1(1) & 8) === 0) ? 8 : 6;
              gr_0.n1().j64_1 = 30;
            }
          }
          tables = this.n5y(bs, 10);
          tables = tables << 5;
          UByteArrayInt__set_impl_gn4532(gr_0.n1().m64_1, 0, this.n5y(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.n1().m64_1, 1, this.n5y(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.n1().m64_1, 2, this.n5y(bs, 3));
        } else {
          gr_0.n1().g64_1 = 0;
          gr_0.n1().h64_1 = 0;
          tables = this.n5y(bs, 15);
          UByteArrayInt__set_impl_gn4532(gr_0.n1().l64_1, 0, this.n5y(bs, 4));
          UByteArrayInt__set_impl_gn4532(gr_0.n1().l64_1, 1, this.n5y(bs, 3));
          UByteArrayInt__set_impl_gn4532(gr_0.n1().l64_1, 2, 255);
        }
        UByteArrayInt__set_impl_gn4532(gr_0.n1().k64_1, 0, tables >> 10);
        UByteArrayInt__set_impl_gn4532(gr_0.n1().k64_1, 1, tables >> 5 & 31);
        UByteArrayInt__set_impl_gn4532(gr_0.n1().k64_1, 2, tables & 31);
        gr_0.n1().n64_1 = !((hdr.d1(1) & 8) === 0) ? this.n5y(bs, 1) : toInt_0(gr_0.n1().e64_1 >= 500, this);
        gr_0.n1().o64_1 = this.n5y(bs, 1);
        gr_0.n1().p64_1 = this.n5y(bs, 1);
        gr_0.n1().q64_1 = scfsi >> 12 & 15;
        scfsi = scfsi << 4;
        gr_0 = gr_0.v3();
      }
       while (false);
      gr_count = gr_count - 1 | 0;
    }
     while (!(gr_count === 0));
    if ((part_23_sum + bs.a63_1 | 0) > (bs.b63_1 + imul(main_data_begin, 8) | 0))
      return -1;
    return main_data_begin;
  }
  b5z(scf, ist_pos, scf_size, scf_count, bitbuf, scfsi) {
    var scf_0 = scf;
    var ist_pos_0 = new UByteArrayIntPtr(ist_pos);
    var scfsi_0 = scfsi;
    var inductionVariable = 0;
    if (inductionVariable < 4)
      $l$loop: do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (scf_count.d1(i) === 0)
          break $l$loop;
        var cnt = scf_count.d1(i);
        if (!((scfsi_0 & 8) === 0)) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < cnt)
            do {
              var n = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              scf_0.e2o(n, ist_pos_0.d1(n));
            }
             while (inductionVariable_0 < cnt);
        } else {
          var bits = UByteArrayInt__get_impl_px6q8a(scf_size, i);
          if (bits === 0) {
            scf_0.r63(_UByte___init__impl__g9hnc4(0), 0, cnt);
            ist_pos_0.r63(_UByte___init__impl__g9hnc4(0), 0, cnt);
          } else {
            var max_scf = (scfsi_0 < 0 ? toLong((1 << bits) - 1 | 0) : new Long(-1, -1)).e2();
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < cnt)
              do {
                var k = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var s = this.n5y(bitbuf, bits);
                ist_pos_0.e2o(k, (s === max_scf ? new Long(-1, -1) : toLong(s)).e2());
                scf_0.e2o(k, s);
              }
               while (inductionVariable_1 < cnt);
          }
        }
        ist_pos_0 = ist_pos_0.n63(cnt);
        scf_0 = scf_0.n63(cnt);
        scfsi_0 = imul(scfsi_0, 2);
      }
       while (inductionVariable < 4);
    scf_0.e2o(0, 0);
    scf_0.e2o(1, 0);
    scf_0.e2o(2, 0);
  }
  c5z(y, exp_q2) {
    var y_0 = y;
    var exp_q2_0 = exp_q2;
    var g_expfrac = Companion_getInstance_10().z61_1;
    do {
      var e = 120 > exp_q2_0 ? exp_q2_0 : 120;
      y_0 = y_0 * (g_expfrac[e & 3] * (1073741824 >> (e >> 2)));
      exp_q2_0 = exp_q2_0 - e | 0;
    }
     while (exp_q2_0 > 0);
    return y_0;
  }
  d5z(hdr, ist_pos, bs, gr, scf, ch) {
    var g_scf_partitions = Companion_getInstance_10().p62_1;
    var scf_partition = new UByteArrayIntPtr(g_scf_partitions[toInt_0(!(gr.n1().j64_1 === 0), this) + toInt_0(gr.n1().i64_1 === 0, this) | 0].g13_1);
    var scf_size = _UByteArrayInt___init__impl__xif7bu_1(4);
    var iscf = _UByteArrayInt___init__impl__xif7bu_1(40);
    var scf_shift = gr.n1().o64_1 + 1 | 0;
    var scfsi = gr.n1().q64_1;
    if (!((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0)) {
      var g_scfc_decode = Companion_getInstance_10().d62_1;
      var part = UByteArrayInt__get_impl_px6q8a(g_scfc_decode, gr.n1().e64_1);
      UByteArrayInt__set_impl_gn4532(scf_size, 0, part >> 2);
      UByteArrayInt__set_impl_gn4532(scf_size, 1, UByteArrayInt__get_impl_px6q8a(scf_size, 0));
      UByteArrayInt__set_impl_gn4532(scf_size, 2, part & 3);
      UByteArrayInt__set_impl_gn4532(scf_size, 3, UByteArrayInt__get_impl_px6q8a(scf_size, 2));
    } else {
      var g_mod = Companion_getInstance_10().e62_1;
      var ist = toInt_0(!((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 16) === 0) && !(ch === 0), this);
      var sfc = gr.n1().e64_1 >> ist;
      var k = imul(imul(ist, 3), 4);
      while (sfc >= 0) {
        var modprod = 1;
        var inductionVariable = 3;
        if (0 <= inductionVariable)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            UByteArrayInt__set_impl_gn4532(scf_size, i, (sfc / modprod | 0) % UByteArrayInt__get_impl_px6q8a(g_mod, k + i | 0) | 0);
            modprod = imul(modprod, UByteArrayInt__get_impl_px6q8a(g_mod, k + i | 0));
          }
           while (0 <= inductionVariable);
        sfc = sfc - modprod | 0;
        k = k + 4 | 0;
      }
      scf_partition = scf_partition.n63(k);
      scfsi = -16;
    }
    this.b5z(new UByteArrayIntPtr(iscf), ist_pos, scf_size, scf_partition, bs, scfsi);
    if (!(gr.n1().j64_1 === 0)) {
      var sh = 3 - scf_shift | 0;
      var progression = step(until(0, gr.n1().j64_1), 3);
      var inductionVariable_0 = progression.w1_1;
      var last = progression.x1_1;
      var step_0 = progression.y1_1;
      if (step_0 > 0 && inductionVariable_0 <= last || (step_0 < 0 && last <= inductionVariable_0))
        do {
          var i_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + step_0 | 0;
          UByteArrayInt__set_impl_gn4532(iscf, (gr.n1().i64_1 + i_0 | 0) + 0 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.n1().i64_1 + i_0 | 0) + 0 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.n1().m64_1, 0) << sh) | 0);
          UByteArrayInt__set_impl_gn4532(iscf, (gr.n1().i64_1 + i_0 | 0) + 1 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.n1().i64_1 + i_0 | 0) + 1 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.n1().m64_1, 1) << sh) | 0);
          UByteArrayInt__set_impl_gn4532(iscf, (gr.n1().i64_1 + i_0 | 0) + 2 | 0, UByteArrayInt__get_impl_px6q8a(iscf, (gr.n1().i64_1 + i_0 | 0) + 2 | 0) + (UByteArrayInt__get_impl_px6q8a(gr.n1().m64_1, 2) << sh) | 0);
        }
         while (!(i_0 === last));
    } else {
      if (!(gr.n1().n64_1 === 0)) {
        var g_preamp = Companion_getInstance_10().f62_1;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 10)
          do {
            var i_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(iscf, 11 + i_1 | 0, UByteArrayInt__get_impl_px6q8a(iscf, 11 + i_1 | 0) + UByteArrayInt__get_impl_px6q8a(g_preamp, i_1) | 0);
          }
           while (inductionVariable_1 < 10);
      }
    }
    var gain_exp = (numberToLong(gr.n1().f64_1).r3(new Long(-4, -1)).e2() - 210 | 0) - ((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 224) === 96 ? 2 : 0) | 0;
    var gain = this.c5z(2048, (new Long(44, 0)).t1(toLong(gain_exp)).e2());
    var inductionVariable_2 = 0;
    var last_0 = gr.n1().i64_1 + gr.n1().j64_1 | 0;
    if (inductionVariable_2 < last_0)
      do {
        var i_2 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        scf.v63(i_2, this.c5z(gain, UByteArrayInt__get_impl_px6q8a(iscf, i_2) << scf_shift));
      }
       while (inductionVariable_2 < last_0);
  }
  e5z(x) {
    var x_0 = x;
    var mult = 256;
    if (x_0 < 129)
      return Companion_getInstance_10().u62_1[16 + x_0 | 0];
    if (x_0 < 1024) {
      mult = 16;
      x_0 = x_0 << 3;
    }
    var sign = imul(2, x_0) & 64;
    var frac = ((x_0 & 63) - sign | 0) / ((x_0 & -64) + sign | 0);
    return Companion_getInstance_10().u62_1[16 + ((x_0 + sign | 0) >> 6) | 0] * (1.0 + frac * (4.0 / 3.0 + frac * (2.0 / 9.0))) * mult;
  }
  f5z(dst, bs, gr_info, scf, layer3gr_limit) {
    var dst_0 = dst;
    var scf_0 = scf;
    var tabs = Companion_getInstance_10().g62_1;
    var tab32 = Companion_getInstance_10().h62_1;
    var tab33 = Companion_getInstance_10().i62_1;
    var tabindex = Companion_getInstance_10().j62_1;
    var g_linbits = Companion_getInstance_10().k62_1;
    var one = 0.0;
    var ireg = 0;
    var big_val_cnt = gr_info.n1().d64_1;
    var sfb = gr_info.n1().b64_1;
    var bs_next_ptr = bs.z62_1.n63(bs.a63_1 / 8 | 0);
    // Inline function 'kotlin.toUInt' call
    var this_0 = (imul(imul(imul(bs_next_ptr.d1(0), 256) + bs_next_ptr.d1(1) | 0, 256) + bs_next_ptr.d1(2) | 0, 256) + bs_next_ptr.d1(3) | 0) << (bs.a63_1 & 7);
    var bs_cache = _UInt___init__impl__l7qpdl(this_0);
    var pairs_to_decode = 0;
    var np = 0;
    var bs_sh = (bs.a63_1 & 7) - 8 | 0;
    bs_next_ptr = bs_next_ptr.n63(4);
    while (big_val_cnt > 0) {
      var tab_num = UByteArrayInt__get_impl_px6q8a(gr_info.n1().k64_1, ireg);
      var tmp = gr_info.n1().l64_1;
      var _unary__edvuaz = ireg;
      ireg = _unary__edvuaz + 1 | 0;
      var sfb_cnt = UByteArrayInt__get_impl_px6q8a(tmp, _unary__edvuaz);
      var codebook = tabindex[tab_num];
      var linbits = UByteArrayInt__get_impl_px6q8a(g_linbits, tab_num);
      if (!(linbits === 0)) {
        $l$3: do {
          $l$2: do {
            np = sfb.n1() / 2 | 0;
            sfb = sfb.v3();
            pairs_to_decode = big_val_cnt > np ? np : big_val_cnt;
            var _unary__edvuaz_0 = scf_0;
            scf_0 = _unary__edvuaz_0.v3();
            one = _unary__edvuaz_0.n1();
            $l$1: do {
              $l$0: do {
                var w = 5;
                // Inline function 'kotlin.UInt.toInt' call
                // Inline function 'kotlin.UInt.shr' call
                var this_1 = bs_cache;
                var bitCount = 32 - w | 0;
                var this_2 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_1) >>> bitCount | 0);
                var leaf = tabs[codebook + _UInt___get_data__impl__f0vqqw(this_2) | 0];
                while (leaf < 0) {
                  // Inline function 'kotlin.UInt.shl' call
                  var this_3 = bs_cache;
                  var bitCount_0 = w;
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_3) << bitCount_0);
                  bs_sh = bs_sh + w | 0;
                  w = leaf & 7;
                  // Inline function 'kotlin.UInt.toInt' call
                  // Inline function 'kotlin.UInt.shr' call
                  var this_4 = bs_cache;
                  var bitCount_1 = 32 - w | 0;
                  var this_5 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_4) >>> bitCount_1 | 0);
                  leaf = tabs[(codebook + _UInt___get_data__impl__f0vqqw(this_5) | 0) - (leaf >> 3) | 0];
                }
                // Inline function 'kotlin.UInt.shl' call
                var this_6 = bs_cache;
                var bitCount_2 = leaf >> 8;
                bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_6) << bitCount_2);
                bs_sh = bs_sh + (leaf >> 8) | 0;
                var inductionVariable = 0;
                if (inductionVariable < 2)
                  do {
                    var j = inductionVariable;
                    inductionVariable = inductionVariable + 1 | 0;
                    var lsb = leaf & 15;
                    if (lsb === 15) {
                      var tmp_0 = lsb;
                      // Inline function 'kotlin.UInt.toInt' call
                      // Inline function 'kotlin.UInt.shr' call
                      var this_7 = bs_cache;
                      var bitCount_3 = 32 - linbits | 0;
                      var this_8 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_7) >>> bitCount_3 | 0);
                      lsb = tmp_0 + _UInt___get_data__impl__f0vqqw(this_8) | 0;
                      // Inline function 'kotlin.UInt.shl' call
                      var this_9 = bs_cache;
                      bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_9) << linbits);
                      bs_sh = bs_sh + linbits | 0;
                      while (bs_sh >= 0) {
                        // Inline function 'kotlin.UInt.or' call
                        var this_10 = bs_cache;
                        // Inline function 'kotlin.toUInt' call
                        var this_11 = bs_next_ptr.n1() << bs_sh;
                        var other = _UInt___init__impl__l7qpdl(this_11);
                        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_10) | _UInt___get_data__impl__f0vqqw(other));
                        bs_next_ptr = bs_next_ptr.v3();
                        bs_sh = bs_sh - 8 | 0;
                      }
                      var tmp_1 = dst_0;
                      var tmp_2 = one * this.e5z(lsb);
                      var tmp_3;
                      // Inline function 'kotlin.UInt.toInt' call
                      var this_12 = bs_cache;
                      if (_UInt___get_data__impl__f0vqqw(this_12) < 0) {
                        tmp_3 = new Long(-1, -1);
                      } else {
                        tmp_3 = new Long(1, 0);
                      }
                      tmp_1.u63(tmp_2 * tmp_3.f4());
                    } else {
                      var tmp_4 = dst_0;
                      var tmp_5 = Companion_getInstance_10().u62_1;
                      var tmp_6 = 16 + lsb | 0;
                      // Inline function 'kotlin.UInt.toInt' call
                      // Inline function 'kotlin.UInt.shr' call
                      var this_13 = bs_cache;
                      var this_14 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_13) >>> 31 | 0);
                      var tmp$ret$14 = _UInt___get_data__impl__f0vqqw(this_14);
                      tmp_4.u63(tmp_5[tmp_6 - imul(16, tmp$ret$14) | 0] * one);
                    }
                    // Inline function 'kotlin.UInt.shl' call
                    var this_15 = bs_cache;
                    var bitCount_4 = !(lsb === 0) ? 1 : 0;
                    bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_15) << bitCount_4);
                    bs_sh = bs_sh + (!(lsb === 0) ? 1 : 0) | 0;
                    dst_0 = dst_0.v3();
                    leaf = leaf >> 4;
                  }
                   while (inductionVariable < 2);
                while (bs_sh >= 0) {
                  // Inline function 'kotlin.UInt.or' call
                  var this_16 = bs_cache;
                  // Inline function 'kotlin.toUInt' call
                  var this_17 = bs_next_ptr.n1() << bs_sh;
                  var other_0 = _UInt___init__impl__l7qpdl(this_17);
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_16) | _UInt___get_data__impl__f0vqqw(other_0));
                  bs_next_ptr = bs_next_ptr.v3();
                  bs_sh = bs_sh - 8 | 0;
                }
              }
               while (false);
              pairs_to_decode = pairs_to_decode - 1 | 0;
            }
             while (!(pairs_to_decode === 0));
            big_val_cnt = big_val_cnt - np | 0;
          }
           while (false);
          var tmp_7;
          if (big_val_cnt > 0) {
            sfb_cnt = sfb_cnt - 1 | 0;
            tmp_7 = sfb_cnt >= 0;
          } else {
            tmp_7 = false;
          }
        }
         while (tmp_7);
      } else {
        $l$7: do {
          $l$6: do {
            np = sfb.n1() / 2 | 0;
            sfb = sfb.v3();
            pairs_to_decode = big_val_cnt > np ? np : big_val_cnt;
            var _unary__edvuaz_1 = scf_0;
            scf_0 = _unary__edvuaz_1.v3();
            one = _unary__edvuaz_1.n1();
            $l$5: do {
              $l$4: do {
                var w_0 = 5;
                // Inline function 'kotlin.UInt.toInt' call
                // Inline function 'kotlin.UInt.shr' call
                var this_18 = bs_cache;
                var bitCount_5 = 32 - w_0 | 0;
                var this_19 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_18) >>> bitCount_5 | 0);
                var leaf_0 = tabs[codebook + _UInt___get_data__impl__f0vqqw(this_19) | 0];
                while (leaf_0 < 0) {
                  // Inline function 'kotlin.UInt.shl' call
                  var this_20 = bs_cache;
                  var bitCount_6 = w_0;
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_20) << bitCount_6);
                  bs_sh = bs_sh + w_0 | 0;
                  w_0 = leaf_0 & 7;
                  // Inline function 'kotlin.UInt.toInt' call
                  // Inline function 'kotlin.UInt.shr' call
                  var this_21 = bs_cache;
                  var bitCount_7 = 32 - w_0 | 0;
                  var this_22 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_21) >>> bitCount_7 | 0);
                  leaf_0 = tabs[(codebook + _UInt___get_data__impl__f0vqqw(this_22) | 0) - (leaf_0 >> 3) | 0];
                }
                // Inline function 'kotlin.UInt.shl' call
                var this_23 = bs_cache;
                var bitCount_8 = leaf_0 >> 8;
                bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_23) << bitCount_8);
                bs_sh = bs_sh + (leaf_0 >> 8) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < 2)
                  do {
                    var j_0 = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    var lsb_0 = leaf_0 & 15;
                    var tmp_8 = dst_0;
                    var tmp_9 = Companion_getInstance_10().u62_1;
                    var tmp_10 = 16 + lsb_0 | 0;
                    // Inline function 'kotlin.UInt.toInt' call
                    // Inline function 'kotlin.UInt.shr' call
                    var this_24 = bs_cache;
                    var this_25 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_24) >>> 31 | 0);
                    var tmp$ret$25 = _UInt___get_data__impl__f0vqqw(this_25);
                    tmp_8.u63(tmp_9[tmp_10 - imul(16, tmp$ret$25) | 0] * one);
                    // Inline function 'kotlin.UInt.shl' call
                    var this_26 = bs_cache;
                    var bitCount_9 = !(lsb_0 === 0) ? 1 : 0;
                    bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_26) << bitCount_9);
                    bs_sh = bs_sh + (!(lsb_0 === 0) ? 1 : 0) | 0;
                    dst_0 = dst_0.v3();
                    leaf_0 = leaf_0 >> 4;
                  }
                   while (inductionVariable_0 < 2);
                while (bs_sh >= 0) {
                  // Inline function 'kotlin.UInt.or' call
                  var this_27 = bs_cache;
                  // Inline function 'kotlin.toUInt' call
                  var this_28 = bs_next_ptr.n1() << bs_sh;
                  var other_1 = _UInt___init__impl__l7qpdl(this_28);
                  bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_27) | _UInt___get_data__impl__f0vqqw(other_1));
                  bs_next_ptr = bs_next_ptr.v3();
                  bs_sh = bs_sh - 8 | 0;
                }
              }
               while (false);
              pairs_to_decode = pairs_to_decode - 1 | 0;
            }
             while (!(pairs_to_decode === 0));
            big_val_cnt = big_val_cnt - np | 0;
          }
           while (false);
          var tmp_11;
          if (big_val_cnt > 0) {
            sfb_cnt = sfb_cnt - 1 | 0;
            tmp_11 = sfb_cnt >= 0;
          } else {
            tmp_11 = false;
          }
        }
         while (tmp_11);
      }
    }
    np = 1 - big_val_cnt | 0;
    $l$loop_1: while (true) {
      var codebook_count1 = !(gr_info.n1().p64_1 === 0) ? tab33 : tab32;
      // Inline function 'kotlin.UInt.toInt' call
      // Inline function 'kotlin.UInt.shr' call
      var this_29 = bs_cache;
      var this_30 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_29) >>> 28 | 0);
      var tmp$ret$30 = _UInt___get_data__impl__f0vqqw(this_30);
      var leaf_1 = UByteArrayInt__get_impl_px6q8a(codebook_count1, tmp$ret$30);
      if ((leaf_1 & 8) === 0) {
        var tmp_12 = leaf_1 >> 3;
        // Inline function 'kotlin.UInt.toInt' call
        // Inline function 'kotlin.UInt.shr' call
        // Inline function 'kotlin.UInt.shl' call
        var this_31 = bs_cache;
        var this_32 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_31) << 4);
        var bitCount_10 = 32 - (leaf_1 & 3) | 0;
        var this_33 = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_32) >>> bitCount_10 | 0);
        var tmp$ret$33 = _UInt___get_data__impl__f0vqqw(this_33);
        leaf_1 = UByteArrayInt__get_impl_px6q8a(codebook_count1, tmp_12 + tmp$ret$33 | 0);
      }
      // Inline function 'kotlin.UInt.shl' call
      var this_34 = bs_cache;
      var bitCount_11 = leaf_1 & 7;
      bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_34) << bitCount_11);
      bs_sh = bs_sh + (leaf_1 & 7) | 0;
      if (((imul(bs_next_ptr.q63(bs.z62_1), 8) - 24 | 0) + bs_sh | 0) > layer3gr_limit) {
        break $l$loop_1;
      }
      np = np - 1 | 0;
      if (np === 0) {
        np = sfb.n1() / 2 | 0;
        sfb = sfb.v3();
        if (np === 0)
          break $l$loop_1;
        var _unary__edvuaz_2 = scf_0;
        scf_0 = _unary__edvuaz_2.v3();
        one = _unary__edvuaz_2.n1();
      }
      if (!((leaf_1 & 128) === 0)) {
        var tmp_13 = dst_0;
        var tmp_14;
        // Inline function 'kotlin.UInt.toInt' call
        var this_35 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_35) < 0) {
          tmp_14 = -one;
        } else {
          tmp_14 = one;
        }
        tmp_13.v63(0, tmp_14);
        // Inline function 'kotlin.UInt.shl' call
        var this_36 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_36) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      if (!((leaf_1 & 64) === 0)) {
        var tmp_15 = dst_0;
        var tmp_16;
        // Inline function 'kotlin.UInt.toInt' call
        var this_37 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_37) < 0) {
          tmp_16 = -one;
        } else {
          tmp_16 = one;
        }
        tmp_15.v63(1, tmp_16);
        // Inline function 'kotlin.UInt.shl' call
        var this_38 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_38) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      np = np - 1 | 0;
      if (np === 0) {
        np = sfb.n1() / 2 | 0;
        sfb = sfb.v3();
        if (np === 0)
          break $l$loop_1;
        var _unary__edvuaz_3 = scf_0;
        scf_0 = _unary__edvuaz_3.v3();
        one = _unary__edvuaz_3.n1();
      }
      if (!((leaf_1 & 32) === 0)) {
        var tmp_17 = dst_0;
        var tmp_18;
        // Inline function 'kotlin.UInt.toInt' call
        var this_39 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_39) < 0) {
          tmp_18 = -one;
        } else {
          tmp_18 = one;
        }
        tmp_17.v63(2, tmp_18);
        // Inline function 'kotlin.UInt.shl' call
        var this_40 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_40) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      if (!((leaf_1 & 16) === 0)) {
        var tmp_19 = dst_0;
        var tmp_20;
        // Inline function 'kotlin.UInt.toInt' call
        var this_41 = bs_cache;
        if (_UInt___get_data__impl__f0vqqw(this_41) < 0) {
          tmp_20 = -one;
        } else {
          tmp_20 = one;
        }
        tmp_19.v63(3, tmp_20);
        // Inline function 'kotlin.UInt.shl' call
        var this_42 = bs_cache;
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_42) << 1);
        bs_sh = bs_sh + 1 | 0;
      }
      while (bs_sh >= 0) {
        // Inline function 'kotlin.UInt.or' call
        var this_43 = bs_cache;
        // Inline function 'kotlin.toUInt' call
        var this_44 = bs_next_ptr.n1() << bs_sh;
        var other_2 = _UInt___init__impl__l7qpdl(this_44);
        bs_cache = _UInt___init__impl__l7qpdl(_UInt___get_data__impl__f0vqqw(this_43) | _UInt___get_data__impl__f0vqqw(other_2));
        bs_next_ptr = bs_next_ptr.v3();
        bs_sh = bs_sh - 8 | 0;
      }
      dst_0 = dst_0.n63(4);
    }
    bs.a63_1 = layer3gr_limit;
  }
  g5z(left, n) {
    var right = left.n63(576);
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var a = left.d1(i);
        var b = right.d1(i);
        left.v63(i, a + b);
        right.v63(i, a - b);
      }
       while (inductionVariable < n);
  }
  h5z(left, n, kl, kr) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        left.v63(i + 576 | 0, left.d1(i) * kr);
        left.v63(i, left.d1(i) * kl);
      }
       while (inductionVariable < n);
  }
  i5z(right, sfb, nbands, max_band) {
    var right_0 = right;
    max_band[0] = -1;
    max_band[1] = -1;
    max_band[2] = -1;
    var inductionVariable = 0;
    if (inductionVariable < nbands)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var k = 0;
        $l$loop: while (k < sfb.d1(i)) {
          if (!(right_0.d1(k) === 0.0) || !(right_0.d1(k + 1 | 0) === 0.0)) {
            max_band[i % 3 | 0] = i;
            break $l$loop;
          }
          k = k + 2 | 0;
        }
        right_0 = right_0.n63(sfb.d1(i));
      }
       while (inductionVariable < nbands);
  }
  j5z(left, ist_pos, sfb, hdr, max_band, mpeg2_sh) {
    var left_0 = left;
    var g_pan = Companion_getInstance_10().v61_1;
    var max_pos = !((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0) ? 7 : 64;
    var i = 0;
    while (!(sfb.d1(i) === 0)) {
      var ipos = UByteArrayInt__get_impl_px6q8a(ist_pos, i);
      if (i > max_band[i % 3 | 0] && ipos < max_pos) {
        var kl;
        var kr;
        var s = !((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 32) === 0) ? 1.4142135 : 1.0;
        if (!((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0)) {
          kl = g_pan[imul(2, ipos) + 0 | 0];
          kr = g_pan[imul(2, ipos) + 1 | 0];
        } else {
          kl = 1.0;
          kr = this.c5z(1.0, (ipos + 1 | 0) >> 1 << mpeg2_sh);
          if (!((ipos & 1) === 0)) {
            kl = kr;
            kr = 1.0;
          }
        }
        this.h5z(left_0, sfb.d1(i), kl * s, kr * s);
      } else {
        if (!((UByteArrayInt__get_impl_px6q8a(hdr, 3) & 32) === 0)) {
          this.g5z(left_0, sfb.d1(i));
        }
      }
      left_0 = left_0.n63(sfb.d1(i));
      i = i + 1 | 0;
    }
  }
  k5z(left, ist_pos, gr, hdr) {
    var max_band = this.e5x_1;
    var n_sfb = gr.n1().i64_1 + gr.n1().j64_1 | 0;
    var max_blocks = !(gr.n1().j64_1 === 0) ? 3 : 1;
    this.i5z(left.n63(576), gr.n1().b64_1, n_sfb, max_band);
    if (!(gr.n1().i64_1 === 0)) {
      // Inline function 'kotlin.math.max' call
      // Inline function 'kotlin.math.max' call
      var a = max_band[0];
      var b = max_band[1];
      var a_0 = Math.max(a, b);
      var b_0 = max_band[2];
      var v = Math.max(a_0, b_0);
      max_band[0] = v;
      max_band[1] = v;
      max_band[2] = v;
    }
    var inductionVariable = 0;
    if (inductionVariable < max_blocks)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var default_pos = !((UByteArrayInt__get_impl_px6q8a(hdr, 1) & 8) === 0) ? 3 : 0;
        var itop = (n_sfb - max_blocks | 0) + i | 0;
        var prev = itop - max_blocks | 0;
        UByteArrayInt__set_impl_gn4532(ist_pos, itop, max_band[i] >= prev ? default_pos : UByteArrayInt__get_impl_px6q8a(ist_pos, prev));
      }
       while (inductionVariable < max_blocks);
    this.j5z(left, ist_pos, gr.n1().b64_1, hdr, max_band, gr.d1(1).e64_1 & 1);
  }
  l5z(grbuf, scratch, sfb) {
    var sfb_0 = sfb;
    var i = 0;
    var len = 0;
    var src = grbuf;
    var dst = scratch;
    $l$loop: while (true) {
      len = sfb_0.n1();
      if (len === 0)
        break $l$loop;
      i = 0;
      while (i < len) {
        var _unary__edvuaz = dst;
        dst = _unary__edvuaz.v3();
        _unary__edvuaz.u63(src.d1(imul(0, len)));
        var _unary__edvuaz_0 = dst;
        dst = _unary__edvuaz_0.v3();
        _unary__edvuaz_0.u63(src.d1(imul(1, len)));
        var _unary__edvuaz_1 = dst;
        dst = _unary__edvuaz_1.v3();
        _unary__edvuaz_1.u63(src.d1(imul(2, len)));
        i = i + 1 | 0;
        src = src.v3();
      }
      sfb_0 = sfb_0.n63(3);
      src = src.n63(imul(2, len));
    }
    this.k5y(grbuf, scratch, dst.w63(scratch));
  }
  m5z(grbuf, nbands) {
    var grbuf_0 = grbuf;
    var nbands_0 = nbands;
    var g_aa = Companion_getInstance_10().x61_1;
    while (nbands_0 > 0) {
      var inductionVariable = 0;
      if (inductionVariable < 8)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var u = grbuf_0.d1(18 + i | 0);
          var d = grbuf_0.d1(17 - i | 0);
          grbuf_0.v63(18 + i | 0, u * g_aa[0][i] - d * g_aa[1][i]);
          grbuf_0.v63(17 - i | 0, u * g_aa[1][i] + d * g_aa[0][i]);
        }
         while (inductionVariable < 8);
      nbands_0 = nbands_0 - 1 | 0;
      grbuf_0 = grbuf_0.n63(18);
    }
  }
  n5z(y) {
    var s0 = y[0];
    var s2 = y[2];
    var s4 = y[4];
    var s6 = y[6];
    var s8 = y[8];
    var t0 = s0 + s6 * 0.5;
    s0 = s0 - s6;
    var t4 = (s4 + s2) * 0.9396926;
    var t2 = (s8 + s2) * 0.76604444;
    s6 = (s4 - s8) * 0.17364818;
    s4 = s4 + (s8 - s2);
    s2 = s0 - s4 * 0.5;
    y[4] = s4 + s0;
    s8 = t0 - t2 + s6;
    s0 = t0 - t4 + t2;
    s4 = t0 + t4 - s6;
    var s1 = y[1];
    var s3 = y[3];
    var s5 = y[5];
    var s7 = y[7];
    s3 = s3 * 0.8660254;
    t0 = (s5 + s1) * 0.9848077;
    t4 = (s5 - s7) * 0.34202015;
    t2 = (s1 + s7) * 0.64278764;
    s1 = (s1 - s5 - s7) * 0.8660254;
    s5 = t0 - s3 - t2;
    s7 = t4 - s3 - t0;
    s3 = t4 + s3 - t2;
    y[0] = s4 - s7;
    y[1] = s2 + s1;
    y[2] = s0 - s3;
    y[3] = s8 + s5;
    y[5] = s8 - s5;
    y[6] = s0 + s3;
    y[7] = s2 - s1;
    y[8] = s4 + s7;
  }
  o5z(grbuf, overlap, window_0, nbands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var g_twid9 = Companion_getInstance_10().s61_1;
    var inductionVariable = 0;
    if (inductionVariable < nbands)
      do {
        var j = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var co = this.f5x_1;
        var si = this.g5x_1;
        co[0] = -grbuf_0.d1(0);
        si[0] = grbuf_0.d1(17);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            si[8 - imul(2, i) | 0] = grbuf_0.d1(imul(4, i) + 1 | 0) - grbuf_0.d1(imul(4, i) + 2 | 0);
            co[1 + imul(2, i) | 0] = grbuf_0.d1(imul(4, i) + 1 | 0) + grbuf_0.d1(imul(4, i) + 2 | 0);
            si[7 - imul(2, i) | 0] = grbuf_0.d1(imul(4, i) + 4 | 0) - grbuf_0.d1(imul(4, i) + 3 | 0);
            co[2 + imul(2, i) | 0] = -(grbuf_0.d1(imul(4, i) + 3 | 0) + grbuf_0.d1(imul(4, i) + 4 | 0));
          }
           while (inductionVariable_0 < 4);
        this.n5z(co);
        this.n5z(si);
        si[1] = -si[1];
        si[3] = -si[3];
        si[5] = -si[5];
        si[7] = -si[7];
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 9)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var ovl = overlap_0.d1(i_0);
            var sum = co[i_0] * g_twid9[9 + i_0 | 0] + si[i_0] * g_twid9[0 + i_0 | 0];
            overlap_0.v63(i_0, co[i_0] * g_twid9[0 + i_0 | 0] - si[i_0] * g_twid9[9 + i_0 | 0]);
            grbuf_0.v63(i_0, ovl * window_0[0 + i_0 | 0] - sum * window_0[9 + i_0 | 0]);
            grbuf_0.v63(17 - i_0 | 0, ovl * window_0[9 + i_0 | 0] + sum * window_0[0 + i_0 | 0]);
          }
           while (inductionVariable_1 < 9);
        grbuf_0 = grbuf_0.n63(18);
        overlap_0 = overlap_0.n63(9);
      }
       while (inductionVariable < nbands);
  }
  p5z(x0, x1, x2, dst) {
    var m1 = x1 * 0.8660254;
    var a1 = x0 - x2 * 0.5;
    dst[1] = x0 + x2;
    dst[0] = a1 + m1;
    dst[2] = a1 - m1;
  }
  q5z(x, dst, overlap) {
    var g_twid3 = Companion_getInstance_10().t61_1;
    var co = this.h5x_1;
    var si = this.i5x_1;
    this.p5z(-x.d1(0), x.d1(6) + x.d1(3), x.d1(12) + x.d1(9), co);
    this.p5z(x.d1(15), x.d1(12) - x.d1(9), x.d1(6) - x.d1(3), si);
    si[1] = -si[1];
    var inductionVariable = 0;
    if (inductionVariable < 3)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var ovl = overlap.d1(i);
        var sum = co[i] * g_twid3[3 + i | 0] + si[i] * g_twid3[0 + i | 0];
        overlap.v63(i, co[i] * g_twid3[0 + i | 0] - si[i] * g_twid3[3 + i | 0]);
        dst.v63(i, ovl * g_twid3[2 - i | 0] - sum * g_twid3[5 - i | 0]);
        dst.v63(5 - i | 0, ovl * g_twid3[5 - i | 0] + sum * g_twid3[2 - i | 0]);
      }
       while (inductionVariable < 3);
  }
  r5z(grbuf, overlap, nbands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var nbands_0 = nbands;
    while (nbands_0 > 0) {
      var tmp = new FloatArrayPtr(new Float32Array(18));
      this.k5y(tmp, grbuf_0, 18);
      this.k5y(grbuf_0, overlap_0, 6);
      this.q5z(tmp, grbuf_0.n63(6), overlap_0.n63(6));
      this.q5z(tmp.n63(1), grbuf_0.n63(12), overlap_0.n63(6));
      this.q5z(tmp.n63(2), overlap_0, overlap_0.n63(6));
      nbands_0 = nbands_0 - 1 | 0;
      overlap_0 = overlap_0.n63(9);
      grbuf_0 = grbuf_0.n63(18);
    }
  }
  s5z(grbuf) {
    var p = 18;
    var progression = step(until(0, 32), 2);
    var inductionVariable = progression.w1_1;
    var last = progression.x1_1;
    var step_0 = progression.y1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var b = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var progression_0 = step(until(1, 18), 2);
        var inductionVariable_0 = progression_0.w1_1;
        var last_0 = progression_0.x1_1;
        var step_1 = progression_0.y1_1;
        if (step_1 > 0 && inductionVariable_0 <= last_0 || (step_1 < 0 && last_0 <= inductionVariable_0))
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + step_1 | 0;
            var index = p + i | 0;
            grbuf.v63(index, -grbuf.d1(index));
          }
           while (!(i === last_0));
        p = p + 36 | 0;
      }
       while (!(b === last));
  }
  t5z(grbuf, overlap, block_type, n_long_bands) {
    var grbuf_0 = grbuf;
    var overlap_0 = overlap;
    var g_mdct_window = Companion_getInstance_10().y61_1;
    if (!(n_long_bands === 0)) {
      this.o5z(grbuf_0, overlap_0, g_mdct_window[0], n_long_bands);
      grbuf_0 = grbuf_0.n63(imul(18, n_long_bands));
      overlap_0 = overlap_0.n63(imul(9, n_long_bands));
    }
    if (block_type === 2) {
      this.r5z(grbuf_0, overlap_0, 32 - n_long_bands | 0);
    } else {
      this.o5z(grbuf_0, overlap_0, g_mdct_window[toInt_0(block_type === 3, this)], 32 - n_long_bands | 0);
    }
  }
  u5z(h, s) {
    var pos = (s.c63_1.a63_1 + 7 | 0) / 8 | 0;
    var remains = (s.c63_1.b63_1 / 8 | 0) - pos | 0;
    if (remains > 511) {
      pos = pos + (remains - 511 | 0) | 0;
      remains = 511;
    }
    if (remains > 0) {
      this.l5y(new UByteArrayIntPtr(h.c5x_1), s.d63_1.n63(pos), remains);
    }
    h.z5w_1 = remains;
  }
  v5z(h, bs, s, main_data_begin) {
    var frame_bytes = (bs.b63_1 - bs.a63_1 | 0) / 8 | 0;
    var bytes_have = h.z5w_1 > main_data_begin ? main_data_begin : h.z5w_1;
    this.l5y(s.d63_1, (new UByteArrayIntPtr(h.c5x_1)).n63(0 < (h.z5w_1 - main_data_begin | 0) ? h.z5w_1 - main_data_begin | 0 : 0), h.z5w_1 > main_data_begin ? main_data_begin : h.z5w_1);
    this.l5y(s.d63_1.n63(bytes_have), bs.z62_1.n63(bs.a63_1 / 8 | 0), frame_bytes);
    this.m5y(s.c63_1, s.d63_1, bytes_have + frame_bytes | 0);
    return toInt_0(h.z5w_1 >= main_data_begin, this);
  }
  w5z(h, s, gr_info, nch) {
    var gr_info_0 = gr_info;
    var inductionVariable = 0;
    if (inductionVariable < nch)
      do {
        var ch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var layer3gr_limit = s.c63_1.a63_1 + gr_info_0.d1(ch).c64_1 | 0;
        this.d5z(h.b5x_1, s.i63_1[ch].g13_1, s.c63_1, gr_info_0.n63(ch), s.g63_1, ch);
        this.f5z(s.f63_1[ch], s.c63_1, gr_info_0.n63(ch), s.g63_1, layer3gr_limit);
      }
       while (inductionVariable < nch);
    if (!((UByteArrayInt__get_impl_px6q8a(h.b5x_1, 3) & 16) === 0)) {
      this.k5z(s.f63_1[0], s.i63_1[1].g13_1, gr_info_0, h.b5x_1);
    } else if ((UByteArrayInt__get_impl_px6q8a(h.b5x_1, 3) & 224) === 96) {
      this.g5z(s.f63_1[0], 576);
    }
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < nch)
      do {
        var ch_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var aa_bands = 31;
        var n_long_bands = (!(gr_info_0.n1().h64_1 === 0) ? 2 : 0) << toInt_0(((UByteArrayInt__get_impl_px6q8a(h.b5x_1, 2) >> 2 & 3) + imul((UByteArrayInt__get_impl_px6q8a(h.b5x_1, 1) >> 3 & 1) + (UByteArrayInt__get_impl_px6q8a(h.b5x_1, 1) >> 4 & 1) | 0, 3) | 0) === 2, this);
        if (!(gr_info_0.n1().j64_1 === 0)) {
          aa_bands = n_long_bands - 1 | 0;
          this.l5z(s.f63_1[ch_0].n63(imul(n_long_bands, 18)), s.h63_1[0], gr_info_0.n1().b64_1.n63(gr_info_0.n1().i64_1));
        }
        this.m5z(s.f63_1[ch_0], aa_bands);
        this.t5z(s.f63_1[ch_0], new FloatArrayPtr(h.x5w_1[ch_0]), gr_info_0.n1().g64_1, n_long_bands);
        this.s5z(s.f63_1[ch_0]);
        gr_info_0 = gr_info_0.n63(1);
      }
       while (inductionVariable_0 < nch);
  }
  x5z(grbuf, n) {
    var g_sec = Companion_getInstance_10().u61_1;
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(4), null);
    while (tmp < 4) {
      tmp_0[tmp] = new Float32Array(8);
      tmp = tmp + 1 | 0;
    }
    var t = tmp_0;
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var k = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = grbuf.n63(k);
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 8)
          do {
            var i = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var x0 = y.d1(imul(i, 18));
            var x1 = y.d1(imul(15 - i | 0, 18));
            var x2 = y.d1(imul(16 + i | 0, 18));
            var x3 = y.d1(imul(31 - i | 0, 18));
            var t0 = x0 + x3;
            var t1 = x1 + x2;
            var t2 = (x1 - x2) * g_sec[imul(3, i) + 0 | 0];
            var t3 = (x0 - x3) * g_sec[imul(3, i) + 1 | 0];
            t[0][i] = t0 + t1;
            t[1][i] = (t0 - t1) * g_sec[imul(3, i) + 2 | 0];
            t[2][i] = t3 + t2;
            t[3][i] = (t3 - t2) * g_sec[imul(3, i) + 2 | 0];
          }
           while (inductionVariable_0 < 8);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 4)
          do {
            var i_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var x = t[i_0];
            var x0_0 = x[0];
            var x1_0 = x[1];
            var x2_0 = x[2];
            var x3_0 = x[3];
            var x4 = x[4];
            var x5 = x[5];
            var x6 = x[6];
            var x7 = x[7];
            var xt = x0_0 - x7;
            x0_0 = x0_0 + x7;
            x7 = x1_0 - x6;
            x1_0 = x1_0 + x6;
            x6 = x2_0 - x5;
            x2_0 = x2_0 + x5;
            x5 = x3_0 - x4;
            x3_0 = x3_0 + x4;
            x4 = x0_0 - x3_0;
            x0_0 = x0_0 + x3_0;
            x3_0 = x1_0 - x2_0;
            x1_0 = x1_0 + x2_0;
            x[0] = x0_0 + x1_0;
            x[4] = (x0_0 - x1_0) * 0.70710677;
            x5 = x5 + x6;
            x6 = (x6 + x7) * 0.70710677;
            x7 = x7 + xt;
            x3_0 = (x3_0 + x4) * 0.70710677;
            x5 = x5 - x7 * 0.19891237;
            x7 = x7 + x5 * 0.38268343;
            x5 = x5 - x7 * 0.19891237;
            x0_0 = xt - x6;
            xt = xt + x6;
            x[1] = (xt + x7) * 0.5097956;
            x[2] = (x4 + x3_0) * 0.5411961;
            x[3] = (x0_0 - x5) * 0.6013449;
            x[5] = (x0_0 + x5) * 0.8999762;
            x[6] = (x4 - x3_0) * 1.306563;
            x[7] = (xt - x7) * 2.5629156;
          }
           while (inductionVariable_1 < 4);
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < 7)
          do {
            var i_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            y.v63(0, t[0][i_1]);
            y.v63(18, t[2][i_1] + t[3][i_1] + t[3][i_1 + 1 | 0]);
            y.v63(36, t[1][i_1] + t[1][i_1 + 1 | 0]);
            y.v63(54, t[2][i_1 + 1 | 0] + t[3][i_1] + t[3][i_1 + 1 | 0]);
            y = y.n63(72);
          }
           while (inductionVariable_2 < 7);
        y.v63(0, t[0][7]);
        y.v63(18, t[2][7] + t[3][7]);
        y.v63(36, t[1][7]);
        y.v63(54, t[3][7]);
      }
       while (inductionVariable < n);
  }
  y5z(sample) {
    if (sample >= 32766.5)
      return 32767;
    if (sample <= -32767.5)
      return -32768;
    var s = toShort(numberToInt(sample + 0.5));
    return toShort(s - toInt_0(s < 0, this) | 0);
  }
  z5z(pcm, nch, z) {
    var z_0 = z;
    var a = 0.0;
    a = a + (z_0.d1(896) - z_0.d1(0)) * 29.0;
    a = a + (z_0.d1(64) + z_0.d1(832)) * 213.0;
    a = a + (z_0.d1(768) - z_0.d1(128)) * 459.0;
    a = a + (z_0.d1(192) + z_0.d1(704)) * 2037.0;
    a = a + (z_0.d1(640) - z_0.d1(256)) * 5153.0;
    a = a + (z_0.d1(320) + z_0.d1(576)) * 6574.0;
    a = a + (z_0.d1(512) - z_0.d1(384)) * 37489.0;
    a = a + z_0.d1(448) * 75038.0;
    pcm.a64(0, this.y5z(a));
    z_0 = z_0.n63(2);
    a = z_0.d1(896) * 104.0;
    a = a + z_0.d1(768) * 1567.0;
    a = a + z_0.d1(640) * 9727.0;
    a = a + z_0.d1(512) * 64019.0;
    a = a + z_0.d1(384) * -9975.0;
    a = a + z_0.d1(256) * -45.0;
    a = a + z_0.d1(128) * 146.0;
    a = a + z_0.d1(0) * -5.0;
    pcm.a64(imul(16, nch), this.y5z(a));
  }
  a60(xl, dstl, nch, lins) {
    var xr = xl.n63(imul(576, nch - 1 | 0));
    var dstr = dstl.n63(nch - 1 | 0);
    var g_win = Companion_getInstance_10().w61_1;
    var zlin = lins.n63(960);
    var w = 0;
    zlin.v63(60, xl.d1(288));
    zlin.v63(61, xr.d1(288));
    zlin.v63(62, xl.d1(0));
    zlin.v63(63, xr.d1(0));
    zlin.v63(124, xl.d1(289));
    zlin.v63(125, xr.d1(289));
    zlin.v63(126, xl.d1(1));
    zlin.v63(127, xr.d1(1));
    this.z5z(dstr, nch, lins.n63(60).n63(1));
    this.z5z(dstr.n63(imul(32, nch)), nch, lins.n63(60).n63(64).n63(1));
    this.z5z(dstl, nch, lins.n63(60));
    this.z5z(dstl.n63(imul(32, nch)), nch, lins.n63(60).n63(64));
    var inductionVariable = 14;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var a = this.h5x_1;
        var b = this.i5x_1;
        zlin.v63(imul(4, i), xl.d1(imul(18, 31 - i | 0)));
        zlin.v63(imul(4, i) + 1 | 0, xr.d1(imul(18, 31 - i | 0)));
        zlin.v63(imul(4, i) + 2 | 0, xl.d1(1 + imul(18, 31 - i | 0) | 0));
        zlin.v63(imul(4, i) + 3 | 0, xr.d1(1 + imul(18, 31 - i | 0) | 0));
        zlin.v63(imul(4, i + 16 | 0), xl.d1(1 + imul(18, 1 + i | 0) | 0));
        zlin.v63(imul(4, i + 16 | 0) + 1 | 0, xr.d1(1 + imul(18, 1 + i | 0) | 0));
        zlin.v63(imul(4, i - 16 | 0) + 2 | 0, xl.d1(imul(18, 1 + i | 0)));
        zlin.v63(imul(4, i - 16 | 0) + 3 | 0, xr.d1(imul(18, 1 + i | 0)));
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var j = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            b[j] = 0.0;
            a[j] = 0.0;
          }
           while (inductionVariable_0 < 4);
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < 8)
          do {
            var n = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var _unary__edvuaz = w;
            w = _unary__edvuaz + 1 | 0;
            var w0 = g_win[_unary__edvuaz];
            var _unary__edvuaz_0 = w;
            w = _unary__edvuaz_0 + 1 | 0;
            var w1 = g_win[_unary__edvuaz_0];
            var vz = zlin.n63(imul(4, i) - imul(n, 64) | 0);
            var vy = zlin.n63(imul(4, i) - imul(15 - n | 0, 64) | 0);
            if ((n % 2 | 0) === 0) {
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < 4)
                do {
                  var j_0 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  b[j_0] = b[j_0] + vz.d1(j_0) * w1 + vy.d1(j_0) * w0;
                  a[j_0] = a[j_0] + vz.d1(j_0) * w0 - vy.d1(j_0) * w1;
                }
                 while (inductionVariable_2 < 4);
            } else {
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < 4)
                do {
                  var j_1 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  b[j_1] = b[j_1] + (vz.d1(j_1) * w1 + vy.d1(j_1) * w0);
                  a[j_1] = a[j_1] + (vy.d1(j_1) * w1 - vz.d1(j_1) * w0);
                }
                 while (inductionVariable_3 < 4);
            }
          }
           while (inductionVariable_1 < 8);
        dstr.a64(imul(15 - i | 0, nch), this.y5z(a[1]));
        dstr.a64(imul(17 + i | 0, nch), this.y5z(b[1]));
        dstl.a64(imul(15 - i | 0, nch), this.y5z(a[0]));
        dstl.a64(imul(17 + i | 0, nch), this.y5z(b[0]));
        dstr.a64(imul(47 - i | 0, nch), this.y5z(a[3]));
        dstr.a64(imul(49 + i | 0, nch), this.y5z(b[3]));
        dstl.a64(imul(47 - i | 0, nch), this.y5z(a[2]));
        dstl.a64(imul(49 + i | 0, nch), this.y5z(b[2]));
      }
       while (0 <= inductionVariable);
  }
  b60(qmf_state, grbuf, nbands, nch, pcm, lins) {
    var i = 0;
    i = 0;
    while (i < nch) {
      this.x5z(grbuf.n63(imul(576, i)), nbands);
      i = i + 1 | 0;
    }
    this.k5y(lins, qmf_state, 960);
    i = 0;
    while (i < nbands) {
      this.a60(grbuf.n63(i), pcm.n63(imul(32, imul(nch, i))), nch, lins.n63(imul(i, 64)));
      i = i + 2 | 0;
    }
    if (nch === 1) {
      i = 0;
      while (i < 960) {
        qmf_state.v63(i, lins.d1(imul(nbands, 64) + i | 0));
        i = i + 2 | 0;
      }
    } else {
      this.k5y(qmf_state, lins.n63(imul(nbands, 64)), 960);
    }
  }
  c60(hdr, mp3_bytes, frame_bytes) {
    var i = 0;
    var inductionVariable = 0;
    if (inductionVariable < 10)
      do {
        var nmatch = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        i = i + (this.t5y(hdr.n63(i), frame_bytes) + this.u5y(hdr.n63(i)) | 0) | 0;
        if ((i + 4 | 0) > mp3_bytes)
          return toInt_0(nmatch > 0, this);
        if (this.p5y(hdr, hdr.n63(i)) === 0)
          return 0;
      }
       while (inductionVariable < 10);
    return 1;
  }
  d60(mp3, mp3_bytes, free_format_bytes, ptr_frame_bytes) {
    var mp3_0 = mp3;
    var i = 0;
    var k = 0;
    i = 0;
    while (i < (mp3_bytes - 4 | 0)) {
      if (this.o5y(mp3_0)) {
        var frame_bytes = this.t5y(mp3_0, free_format_bytes[0]);
        var frame_and_padding = frame_bytes + this.u5y(mp3_0) | 0;
        k = 4;
        $l$loop: while (frame_bytes === 0 && k < 2304 && !((i + imul(2, toInt_0(k < (mp3_bytes - 4 | 0), this)) | 0) === 0)) {
          if (!(this.p5y(mp3_0, mp3_0.n63(k)) === 0)) {
            var fb = k - this.u5y(mp3_0) | 0;
            var nextfb = fb + this.u5y(mp3_0.n63(k)) | 0;
            if ((((i + k | 0) + nextfb | 0) + 4 | 0) > mp3_bytes || this.p5y(mp3_0, mp3_0.n63(k).n63(nextfb)) === 0) {
              k = k + 1 | 0;
              continue $l$loop;
            }
            frame_and_padding = k;
            frame_bytes = fb;
            free_format_bytes[0] = fb;
          }
          k = k + 1 | 0;
        }
        if (!(frame_bytes === 0) && !((i + toInt_0(frame_and_padding <= mp3_bytes, this) | 0) === 0) && !(this.c60(mp3_0, mp3_bytes - i | 0, frame_bytes) === 0) || (i === 0 && frame_and_padding === mp3_bytes)) {
          ptr_frame_bytes[0] = frame_and_padding;
          return i;
        }
        free_format_bytes[0] = 0;
      }
      i = i + 1 | 0;
      mp3_0 = mp3_0.n63(1);
    }
    ptr_frame_bytes[0] = 0;
    return mp3_bytes;
  }
  l5x(dec) {
    UByteArrayInt__set_impl_gn4532(dec.b5x_1, 0, 0);
  }
  d5y(dec, mp3, mp3_bytes, pcm, info) {
    var pcm_0 = pcm;
    var i = 0;
    var frame_size = new Int32Array(1);
    var success = 1;
    var bs_frame = this.k5x_1;
    var scratch = this.j5x_1;
    if (mp3_bytes > 4 && UByteArrayInt__get_impl_px6q8a(dec.b5x_1, 0) === 255 && !(this.p5y(new UByteArrayIntPtr(dec.b5x_1), mp3) === 0)) {
      frame_size[0] = this.t5y(mp3, dec.a5x_1[0]) + this.u5y(mp3) | 0;
      if (!(frame_size[0] === mp3_bytes) && ((frame_size[0] + 4 | 0) > mp3_bytes || this.p5y(mp3, mp3.n63(frame_size[0])) === 0)) {
        frame_size[0] = 0;
      }
    }
    if (frame_size[0] === 0) {
      dec.z5w_1 = 0;
      dec.a5x_1[0] = 0;
      UByteArrayInt__fill$default_impl_mdydxi(dec.c5x_1, 0);
      UByteArrayInt__fill$default_impl_mdydxi(dec.b5x_1, 0);
      fill_0(dec.y5w_1, 0.0);
      fill_0(dec.x5w_1[0], 0.0);
      fill_0(dec.x5w_1[1], 0.0);
      i = this.d60(mp3, mp3_bytes, dec.a5x_1, frame_size);
      if (frame_size[0] === 0 || !((i + toInt_0(frame_size[0] > mp3_bytes, this) | 0) === 0)) {
        info.n1().e5y_1 = i;
        return 0;
      }
    }
    var hdr = mp3.n63(i);
    this.l5y(new UByteArrayIntPtr(dec.b5x_1), hdr, 4);
    info.n1().e5y_1 = i + frame_size[0] | 0;
    info.n1().f5y_1 = i;
    info.n1().g5y_1 = (hdr.d1(3) & 192) === 192 ? 1 : 2;
    info.n1().h5y_1 = this.r5y(hdr);
    info.n1().i5y_1 = 4 - (hdr.d1(1) >> 1 & 3) | 0;
    info.n1().j5y_1 = this.q5y(hdr);
    // Inline function 'kotlin.collections.isEmpty' call
    if (pcm_0.y63_1.length === 0) {
      return this.s5y(hdr);
    }
    this.m5y(bs_frame, hdr.n63(4), frame_size[0] - 4 | 0);
    if ((hdr.d1(1) & 1) === 0) {
      this.n5y(bs_frame, 16);
    }
    if (info.n1().i5y_1 === 3) {
      var main_data_begin = this.a5z(bs_frame, scratch.e63_1, hdr);
      if (main_data_begin < 0 || bs_frame.a63_1 > bs_frame.b63_1) {
        this.l5x(dec);
        return 0;
      }
      success = this.v5z(dec, bs_frame, scratch, main_data_begin);
      if (!(success === 0)) {
        var igr = 0;
        while (igr < (!((hdr.d1(1) & 8) === 0) ? 2 : 1)) {
          scratch.f63_1[0].x63(0.0, 0, 1152);
          this.w5z(dec, scratch, scratch.e63_1.n63(imul(igr, info.n1().g5y_1)), info.n1().g5y_1);
          this.b60(new FloatArrayPtr(dec.y5w_1), scratch.f63_1[0], 18, info.n1().g5y_1, pcm_0, scratch.h63_1[0]);
          igr = igr + 1 | 0;
          pcm_0 = pcm_0.n63(imul(576, info.n1().g5y_1));
        }
      }
      this.u5z(dec, scratch);
    } else {
      var sci = new ScaleInfo();
      this.x5y(hdr, bs_frame, sci);
      scratch.f63_1[0].x63(0.0, 0, 1152);
      i = 0;
      var igr_0 = 0;
      while (igr_0 < 3) {
        i = i + this.y5y(scratch.f63_1[0].n63(i), bs_frame, sci, info.n1().i5y_1 | 1) | 0;
        if (12 === i) {
          i = 0;
          this.z5y(sci, (new FloatArrayPtr(sci.r64_1)).n63(igr_0), scratch.f63_1[0]);
          this.b60(new FloatArrayPtr(dec.y5w_1), scratch.f63_1[0], 12, info.n1().g5y_1, pcm_0, scratch.h63_1[0]);
          scratch.f63_1[0].x63(0.0, 0, 1152);
          pcm_0 = pcm_0.n63(imul(384, info.n1().g5y_1));
        }
        if (bs_frame.a63_1 > bs_frame.b63_1) {
          this.l5x(dec);
          return 0;
        }
        igr_0 = igr_0 + 1 | 0;
      }
    }
    return imul(success, this.s5y(new UByteArrayIntPtr(dec.b5x_1)));
  }
}
class Minimp3Decoder extends MiniMp3Program {
  constructor() {
    super();
    this.t5w_1 = new Int16Array(9216);
    this.u5w_1 = Mp3Dec.d5x();
    this.v5w_1 = new Mp3FrameInfo();
    this.l5x(this.u5w_1);
    this.w5w_1 = new BaseMp3DecoderInfo();
  }
  m5x() {
    return this.w5w_1;
  }
  n5x(availablePeek) {
    var samples = this.d5y(this.u5w_1, new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu(this.w5w_1.o5x_1)), availablePeek, new ShortArrayPtr(this.t5w_1), this.v5w_1);
    var struct = this.v5w_1;
    this.w5w_1.t5x_1 = struct.g5y_1;
    this.w5w_1.r5x_1 = struct.h5y_1;
    this.w5w_1.s5x_1 = struct.j5y_1;
    this.w5w_1.v5x_1 = struct.e5y_1;
    this.w5w_1.u5x_1 = samples;
    if (this.w5w_1.t5x_1 === 0 || samples <= 0)
      return null;
    return copyOf(this.t5w_1, imul(samples, this.w5w_1.t5x_1));
  }
  g6() {
  }
}
class BaseMinimp3AudioFormat extends AudioFormat {
  constructor() {
    Companion_getInstance_9();
    super(['mp3']);
  }
  f5u(data, props, $completion) {
    return Companion_getInstance_5().f5u(data, props, $completion);
  }
  k5u(data, props, $completion) {
    return createDecoderStream(this, data, props, null, $completion);
  }
}
class Minimp3AudioFormat extends BaseMinimp3AudioFormat {
  constructor() {
    Minimp3AudioFormat_instance = null;
    super();
    Minimp3AudioFormat_instance = this;
  }
  f60() {
    return new Minimp3Decoder();
  }
}
class BaseMp3DecoderInfo {
  constructor() {
    this.o5x_1 = new Int8Array(4608);
    this.p5x_1 = new ByteArrayDeque();
    this.q5x_1 = null;
    this.r5x_1 = 0;
    this.s5x_1 = 0;
    this.t5x_1 = 0;
    this.u5x_1 = 0;
    this.v5x_1 = 0;
    this.w5x_1 = 0;
    this.x5x_1 = 0;
    this.y5x_1 = 0;
    this.z5x_1 = 0;
    this.a5y_1 = 0;
    this.b5y_1 = 0;
    this.c5y_1 = 0;
  }
  v2t() {
    var tmp11_safe_receiver = this.q5x_1;
    if (tmp11_safe_receiver == null)
      null;
    else {
      tmp11_safe_receiver.e3();
    }
    this.p5x_1.e3();
    this.w5x_1 = 0;
    this.x5x_1 = -1;
    this.z5x_1 = 0;
  }
  g61(decoder) {
    var availablePeek = this.p5x_1.l15(this.o5x_1, 0, this.o5x_1.length);
    // Inline function 'kotlin.takeIf' call
    var this_0 = indexOf(this.o5x_1, Companion_getInstance_9().h61_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.audio.format.BaseMp3DecoderInfo.step.<anonymous>' call
    if (this_0 >= 0) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    var tmp0_elvis_lhs = tmp;
    var xingIndex = tmp0_elvis_lhs == null ? this.o5x_1.length : tmp0_elvis_lhs;
    // Inline function 'kotlin.takeIf' call
    var this_1 = indexOf(this.o5x_1, Companion_getInstance_9().i61_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.audio.format.BaseMp3DecoderInfo.step.<anonymous>' call
    if (this_1 >= 0) {
      tmp_0 = this_1;
    } else {
      tmp_0 = null;
    }
    var tmp1_elvis_lhs = tmp_0;
    var infoIndex = tmp1_elvis_lhs == null ? this.o5x_1.length : tmp1_elvis_lhs;
    if (xingIndex < this.o5x_1.length || infoIndex < this.o5x_1.length) {
      try {
        // Inline function 'kotlin.math.min' call
        var index = Math.min(xingIndex, infoIndex);
        var data = new FastByteArrayInputStream(this.o5x_1, index);
        data.ox(7);
        if (data.dx() >= 1) {
          var flags = data.n1r();
          var FRAMES_FLAG = 1;
          var BYTES_FLAG = 2;
          var TOC_FLAG = 4;
          var VBR_SCALE_FLAG = 8;
          if (hasFlags(flags, FRAMES_FLAG) && data.dx() >= 4) {
            this.a5y_1 = data.r1r();
            if (hasFlags(flags, BYTES_FLAG)) {
              data.ox(4);
            }
            if (hasFlags(flags, TOC_FLAG)) {
              data.ox(100);
            }
            if (hasFlags(flags, VBR_SCALE_FLAG)) {
              data.ox(4);
            }
            if (data.dx() >= 1) {
              var info = data.n1r();
              if (!(info === 0)) {
                data.ox(20);
                if (data.dx() >= 3) {
                  var t0 = data.n1r();
                  var t1 = data.n1r();
                  var t2 = data.n1r();
                  this.b5y_1 = (t0 << 4 | (t1 >>> 4 | 0)) + 529 | 0;
                  this.c5y_1 = ((t1 & 15) << 8 | t2) - 529 | 0;
                }
              }
            }
          }
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
    }
    var buf = decoder.n5x(availablePeek);
    if (!(this.t5x_1 === 0) && (!(this.a5y_1 === 0) || !(this.b5y_1 === 0) || !(this.c5y_1 === 0))) {
      var rpadding = imul(this.c5y_1, this.t5x_1);
      var to_skip = imul(this.b5y_1, this.t5x_1);
      var detected_samples = imul(imul(this.u5x_1, this.a5y_1), this.t5x_1);
      if (detected_samples >= to_skip)
        detected_samples = detected_samples - to_skip | 0;
      if (1 <= rpadding ? rpadding <= detected_samples : false)
        detected_samples = detected_samples - rpadding | 0;
      this.w5x_1 = to_skip + imul(this.u5x_1, this.t5x_1) | 0;
      this.x5x_1 = detected_samples;
      this.y5x_1 = detected_samples / this.t5x_1 | 0;
      this.a5y_1 = 0;
      this.b5y_1 = 0;
      this.c5y_1 = 0;
    }
    if (!(this.t5x_1 === 0) && this.q5x_1 == null) {
      this.q5x_1 = new AudioSamplesDeque(this.t5x_1);
    }
    if (this.u5x_1 > 0) {
      var offset = 0;
      var toRead = imul(this.u5x_1, this.t5x_1);
      if (this.w5x_1 > 0) {
        // Inline function 'kotlin.math.min' call
        var a = this.w5x_1;
        var b = toRead;
        var skipNow = Math.min(a, b);
        offset = offset + skipNow | 0;
        toRead = toRead - skipNow | 0;
        this.w5x_1 = this.w5x_1 - skipNow | 0;
      }
      if (this.x5x_1 >= 0) {
        // Inline function 'kotlin.math.min' call
        var a_0 = toRead;
        var b_0 = this.x5x_1;
        toRead = Math.min(a_0, b_0);
        this.x5x_1 = this.x5x_1 - toRead | 0;
      }
      ensureNotNull(this.q5x_1).j61(_AudioSampleArray___init__impl__qpxoq0(ensureNotNull(buf)), offset, toRead);
    }
    this.p5x_1.m15(this.v5x_1);
    if (this.v5x_1 === 0 && this.u5x_1 === 0) {
      return false;
    }
    if (!(this.q5x_1 == null) && ensureNotNull(this.q5x_1).w14() > 0) {
      return true;
    }
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_6 = this;
    var tmp = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp.h61_1 = new Int8Array([88, 105, 110, 103]);
    var tmp_0 = this;
    // Inline function 'kotlin.byteArrayOf' call
    tmp_0.i61_1 = new Int8Array([73, 110, 102, 111]);
  }
}
class AudioStream {
  constructor(rate, channels, name, $box) {
    name = name === VOID ? null : name;
    boxApply(this, $box);
    this.w60_1 = rate;
    this.x60_1 = channels;
    this.y60_1 = name;
    this.z60_1 = false;
    this.a61_1 = null;
    this.b61_1 = new Long(0, 0);
  }
  k61() {
    return this.z60_1;
  }
  l61() {
    return this.a61_1;
  }
  p61() {
    // Inline function 'korlibs.time.seconds' call
    var tmp0_elvis_lhs = this.l61();
    var this_0 = (tmp0_elvis_lhs == null ? new Long(0, 0) : tmp0_elvis_lhs).g4() / this.w60_1;
    return toDuration(this_0, DurationUnit_SECONDS_getInstance());
  }
  c61(time) {
    return numberToLong(get_seconds(time) * this.w60_1);
  }
  n61(out, offset, length, $completion) {
    return 0;
  }
  g6() {
    return Unit_instance;
  }
}
class BaseMinimp3AudioFormat$createDecoderStream$2 extends AudioStream {
  constructor($decoder, $mp3SeekingTable, $data, $table, this$0, $dataStartPosition, $props, $box) {
    if ($box === VOID)
      $box = {};
    $box.p60_1 = $decoder;
    $box.q60_1 = $mp3SeekingTable;
    $box.r60_1 = $data;
    $box.s60_1 = $table;
    $box.t60_1 = this$0;
    $box.u60_1 = $dataStartPosition;
    $box.v60_1 = $props;
    super($decoder.m5x().r5x_1, $decoder.m5x().t5x_1, VOID, $box);
    this.m60_1 = false;
    var tmp = this;
    // Inline function 'kotlin.takeIf' call
    var this_0 = toLong($decoder.m5x().y5x_1);
    // Inline function 'kotlin.contracts.contract' call
    var tmp_0;
    // Inline function 'korlibs.audio.format.<no name provided>.totalLengthInSamples.<anonymous>' call
    if (!this_0.equals(new Long(0, 0))) {
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    var tmp0_elvis_lhs = tmp_0;
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      var tmp10_safe_receiver = $mp3SeekingTable._v;
      tmp_1 = tmp10_safe_receiver == null ? null : tmp10_safe_receiver.g5w($decoder.m5x().r5x_1);
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    tmp.n60_1 = tmp_1;
    this.o60_1 = new Long(0, 0);
  }
  k61() {
    return this.m60_1;
  }
  l61() {
    return this.n60_1;
  }
  m61(position, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_seek__qhx6y8.bind(VOID, this, position), $completion);
  }
  n61(out, offset, length, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe.bind(VOID, this, out, offset, length), $completion);
  }
  g6() {
    this.p60_1.g6();
  }
  o61($completion) {
    // Inline function 'kotlin.also' call
    var this_0 = this.r60_1.b1v();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.<no name provided>.clone.<anonymous>' call
    this_0.d1u_1 = this.u60_1;
    return createDecoderStream(this.t60_1, this_0, this.v60_1, this.s60_1, $completion);
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_7 = this;
    this.q61_1 = 2304;
    this.r61_1 = 511;
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.s61_1 = new Float32Array([0.7372773, 0.7933533, 0.8433915, 0.8870108, 0.9238795, 0.95371693, 0.976296, 0.9914449, 0.99904823, 0.6755902, 0.6087614, 0.53729963, 0.4617486, 0.38268343, 0.3007058, 0.2164396, 0.13052619, 0.04361938]);
    var tmp_0 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_0.t61_1 = new Float32Array([0.7933533, 0.9238795, 0.9914449, 0.6087614, 0.38268343, 0.13052619]);
    var tmp_1 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_1.u61_1 = new Float32Array([10.190008, 0.500603, 0.5024193, 3.4076085, 0.50547093, 0.5224986, 2.057781, 0.5154473, 0.56694406, 1.4841646, 0.5310426, 0.6468218, 1.1694399, 0.5531039, 0.7881546, 0.9725682, 0.582935, 1.0606776, 0.8393496, 0.6225041, 1.7224472, 0.7445363, 0.6748083, 5.1011486]);
    var tmp_2 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_2.v61_1 = new Float32Array([0.0, 1.0, 0.21132487, 0.7886751, 0.3660254, 0.6339746, 0.5, 0.5, 0.6339746, 0.3660254, 0.7886751, 0.21132487, 1.0, 0.0]);
    var tmp_3 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_3.w61_1 = new Float32Array([-1.0, 26.0, -31.0, 208.0, 218.0, 401.0, -519.0, 2063.0, 2000.0, 4788.0, -5517.0, 7134.0, 5959.0, 35640.0, -39336.0, 74992.0, -1.0, 24.0, -35.0, 202.0, 222.0, 347.0, -581.0, 2080.0, 1952.0, 4425.0, -5879.0, 7640.0, 5288.0, 33791.0, -41176.0, 74856.0, -1.0, 21.0, -38.0, 196.0, 225.0, 294.0, -645.0, 2087.0, 1893.0, 4063.0, -6237.0, 8092.0, 4561.0, 31947.0, -43006.0, 74630.0, -1.0, 19.0, -41.0, 190.0, 227.0, 244.0, -711.0, 2085.0, 1822.0, 3705.0, -6589.0, 8492.0, 3776.0, 30112.0, -44821.0, 74313.0, -1.0, 17.0, -45.0, 183.0, 228.0, 197.0, -779.0, 2075.0, 1739.0, 3351.0, -6935.0, 8840.0, 2935.0, 28289.0, -46617.0, 73908.0, -1.0, 16.0, -49.0, 176.0, 228.0, 153.0, -848.0, 2057.0, 1644.0, 3004.0, -7271.0, 9139.0, 2037.0, 26482.0, -48390.0, 73415.0, -2.0, 14.0, -53.0, 169.0, 227.0, 111.0, -919.0, 2032.0, 1535.0, 2663.0, -7597.0, 9389.0, 1082.0, 24694.0, -50137.0, 72835.0, -2.0, 13.0, -58.0, 161.0, 224.0, 72.0, -991.0, 2001.0, 1414.0, 2330.0, -7910.0, 9592.0, 70.0, 22929.0, -51853.0, 72169.0, -2.0, 11.0, -63.0, 154.0, 221.0, 36.0, -1064.0, 1962.0, 1280.0, 2006.0, -8209.0, 9750.0, -998.0, 21189.0, -53534.0, 71420.0, -2.0, 10.0, -68.0, 147.0, 215.0, 2.0, -1137.0, 1919.0, 1131.0, 1692.0, -8491.0, 9863.0, -2122.0, 19478.0, -55178.0, 70590.0, -3.0, 9.0, -73.0, 139.0, 208.0, -29.0, -1210.0, 1870.0, 970.0, 1388.0, -8755.0, 9935.0, -3300.0, 17799.0, -56778.0, 69679.0, -3.0, 8.0, -79.0, 132.0, 200.0, -57.0, -1283.0, 1817.0, 794.0, 1095.0, -8998.0, 9966.0, -4533.0, 16155.0, -58333.0, 68692.0, -4.0, 7.0, -85.0, 125.0, 189.0, -83.0, -1356.0, 1759.0, 605.0, 814.0, -9219.0, 9959.0, -5818.0, 14548.0, -59838.0, 67629.0, -4.0, 7.0, -91.0, 117.0, 177.0, -106.0, -1428.0, 1698.0, 402.0, 545.0, -9416.0, 9916.0, -7154.0, 12980.0, -61289.0, 66494.0, -5.0, 6.0, -97.0, 111.0, 163.0, -127.0, -1498.0, 1634.0, 185.0, 288.0, -9585.0, 9838.0, -8540.0, 11455.0, -62684.0, 65290.0]);
    var tmp_4 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.floatArrayOf' call
    var tmp_5 = new Float32Array([0.8574929, 0.881742, 0.94962865, 0.9833146, 0.9955178, 0.9991606, 0.9998992, 0.99999315]);
    // Inline function 'kotlin.floatArrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_4.x61_1 = [tmp_5, new Float32Array([0.51449573, 0.47173196, 0.31337744, 0.1819132, 0.09457419, 0.04096558, 0.01419856, 0.00369997])];
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.floatArrayOf' call
    var tmp_7 = new Float32Array([0.99904823, 0.9914449, 0.976296, 0.95371693, 0.9238795, 0.8870108, 0.8433915, 0.7933533, 0.7372773, 0.04361938, 0.13052619, 0.2164396, 0.3007058, 0.38268343, 0.4617486, 0.53729963, 0.6087614, 0.6755902]);
    // Inline function 'kotlin.floatArrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_6.y61_1 = [tmp_7, new Float32Array([1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 0.9914449, 0.9238795, 0.7933533, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.13052619, 0.38268343, 0.6087614])];
    var tmp_8 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_8.z61_1 = new Float32Array([9.313226E-10, 7.831458E-10, 6.585445E-10, 5.537677E-10]);
    var tmp_9 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_9.a62_1 = new Float32Array([9.536743E-7 / 3.0, 7.569318E-7 / 3.0, 6.007772E-7 / 3.0, 9.536743E-7 / 7.0, 7.569318E-7 / 7.0, 6.007772E-7 / 7.0, 9.536743E-7 / 15.0, 7.569318E-7 / 15.0, 6.007772E-7 / 15.0, 9.536743E-7 / 31.0, 7.569318E-7 / 31.0, 6.007772E-7 / 31.0, 9.536743E-7 / 63.0, 7.569318E-7 / 63.0, 6.007772E-7 / 63.0, 9.536743E-7 / 127.0, 7.569318E-7 / 127.0, 6.007772E-7 / 127.0, 9.536743E-7 / 255.0, 7.569318E-7 / 255.0, 6.007772E-7 / 255.0, 9.536743E-7 / 511.0, 7.569318E-7 / 511.0, 6.007772E-7 / 511.0, 9.536743E-7 / 1023.0, 7.569318E-7 / 1023.0, 6.007772E-7 / 1023.0, 9.536743E-7 / 2047.0, 7.569318E-7 / 2047.0, 6.007772E-7 / 2047.0, 9.536743E-7 / 4095.0, 7.569318E-7 / 4095.0, 6.007772E-7 / 4095.0, 9.536743E-7 / 8191.0, 7.569318E-7 / 8191.0, 6.007772E-7 / 8191.0, 9.536743E-7 / 16383.0, 7.569318E-7 / 16383.0, 6.007772E-7 / 16383.0, 9.536743E-7 / 32767.0, 7.569318E-7 / 32767.0, 6.007772E-7 / 32767.0, 9.536743E-7 / 65535.0, 7.569318E-7 / 65535.0, 6.007772E-7 / 65535.0, 9.536743E-7 / 3.0, 7.569318E-7 / 3.0, 6.007772E-7 / 3.0, 9.536743E-7 / 5.0, 7.569318E-7 / 5.0, 6.007772E-7 / 5.0, 9.536743E-7 / 9.0, 7.569318E-7 / 9.0, 6.007772E-7 / 9.0]);
    var tmp_10 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_10.b62_1 = new Int32Array([44100, 48000, 32000]);
    var tmp_11 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_12 = [new UByteArrayInt(arrayOfUByte$default(this, '\x00\x04\b\f\x10\x14\x18\x1C (08@HP')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x04\b\f\x10\x14\x18\x1C (08@HP')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x18\x1C (08@HPX`p\x80'))];
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_11.c62_1 = [tmp_12, [new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x14\x18\x1C (08@P`p\x80\xA0')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10\x18\x1C (08@P`p\x80\xA0\xC0')), new UByteArrayInt(arrayOfUByte$default(this, '\x00\x10 0@P`p\x80\x90\xA0\xB0\xC0\xD0\xE0'))]];
    this.d62_1 = arrayOfUByte$default(this, '\x00\x01\x02\x03\f\x05\x06\x07\t\n\x0B\r\x0E\x0F\x12\x13');
    this.e62_1 = arrayOfUByte$default(this, '\x05\x05\x04\x04\x05\x05\x04\x01\x04\x03\x01\x01\x05\x06\x06\x01\x04\x04\x04\x01\x04\x03\x01\x01');
    this.f62_1 = arrayOfUByte$default(this, '\x01\x01\x01\x01\x02\x02\x03\x03\x03\x02');
    this.g62_1 = arrayOfShort$default(this, '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0201\u0201\u0201\u0201\u0201\u0201\u0201\u0201\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFF01\u0521\u0512\u0502\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0122\u0120\uFF01\u0521\u0512\u0502\u0301\u0301\u0301\u0301\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0210\u0210\u0210\u0210\u0210\u0210\u0210\u0210\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0122\u0120\uFF03\uFEC2\uFEA1\uFE91\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0333\u0332\u0223\u0223\u0113\u0113\u0113\u0113\u0231\u0230\u0203\u0222\u0121\u0112\u0120\u0102\uFF02\uFEE1\u0531\u0513\u0522\u0520\u0421\u0421\u0412\u0412\u0402\u0402\u0310\u0310\u0310\u0310\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0301\u0301\u0301\u0301\u0300\u0300\u0300\u0300\u0233\u0230\u0132\u0132\u0123\u0103\uFF04\uFE63\uFE23\uFDE2\u0512\uFDC1\u0411\u0411\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE81\uFE71\u0453\u0444\u0452\u0425\u0351\u0351\u0315\u0315\u0450\u0443\u0305\u0305\u0434\u0433\u0155\u0154\u0145\u0135\u0342\u0324\u0241\u0241\u0214\u0214\u0204\u0204\u0340\u0332\u0323\u0330\u0231\u0231\u0213\u0213\u0203\u0222\u0121\u0121\u0120\u0102\uFF04\uFE53\uFE13\uFDD1\u0421\u0421\u0412\u0412\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0211\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\uFE82\u0435\uFE61\u0452\u0425\u0450\u0351\u0351\u0315\u0315\u0443\u0434\u0405\u0433\u0342\u0342\u0255\u0245\u0154\u0154\u0153\u0144\u0324\u0341\u0214\u0214\u0340\u0304\u0332\u0323\u0331\u0313\u0330\u0303\u0122\u0122\u0122\u0122\u0120\u0102\uFF03\uFEA3\uFE62\uFE41\uFE31\u0531\u0513\uFE21\u0522\u0520\u0421\u0421\u0412\u0412\u0402\u0402\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0300\u0300\u0300\u0300\uFEC1\u0353\u0335\uFEB1\u0344\u0352\u0325\u0351\u0155\u0154\u0145\u0150\u0215\u0215\u0243\u0243\u0234\u0234\u0305\u0340\u0242\u0224\u0233\u0204\u0141\u0114\u0132\u0123\u0130\u0103\uFF05\uFDC4\uFD23\uFCC2\uFCA1\uFC91\u0411\u0411\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE01\uFDF1\uFDE1\u0574\u0547\u0565\u0556\u0573\u0537\u0564\uFDD1\u0536\u0472\u0472\u0427\u0427\u0546\u0570\u0407\u0407\u0426\u0426\u0554\u0553\u0460\u0460\u0535\u0544\u0371\u0371\u0371\u0371\u0177\u0176\u0167\u0175\u0157\u0166\u0155\u0145\u0317\u0317\u0463\u0462\uFD41\u0451\u0415\uFD31\u0361\u0361\u0316\u0316\u0306\u0306\u0450\u0405\u0152\u0125\u0143\u0134\uFCE1\uFCD1\u0341\u0314\u0304\u0332\u0323\u0330\u0142\u0124\u0133\u0140\u0231\u0213\u0203\u0222\u0121\u0112\u0120\u0102\uFF05\uFDF3\uFDA3\uFD53\uFD03\uFCC1\uFCB2\u0512\u0421\u0421\u0520\u0502\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0200\u0577\u0576\u0567\u0557\u0566\u0574\u0547\uFE01\u0565\u0556\u0473\u0473\u0437\u0437\u0464\u0464\u0554\u0545\u0553\u0535\u0372\u0372\u0372\u0372\u0327\u0327\u0327\u0327\u0446\u0446\u0470\u0470\u0175\u0155\u0217\u0217\u0371\u0307\u0363\u0336\u0306\uFDB1\u0144\u0152\uFD61\u0351\u0226\u0226\u0362\u0360\u0261\u0261\u0125\u0150\u0216\u0216\u0315\u0343\u0305\uFD11\u0342\u0324\u0134\u0133\u0341\u0314\u0340\u0304\u0232\u0232\u0223\u0223\u0131\u0113\u0230\u0203\u0122\u0122\uFF04\uFE73\uFE23\uFDD3\uFD92\uFD73\uFD31\uFD21\uFD12\u0531\u0513\u0522\u0421\u0421\u0412\u0412\u0520\u0502\u0400\u0400\u0311\u0311\u0311\u0311\u0310\u0310\u0310\u0310\u0301\u0301\u0301\u0301\uFE81\u0467\u0475\u0457\u0466\u0474\u0447\u0456\u0365\u0365\u0373\u0373\u0437\u0455\u0372\u0372\u0177\u0176\u0327\u0364\u0346\u0371\u0317\uFE31\u0363\u0336\u0170\u0107\u0354\u0345\u0344\uFDE1\u0262\u0262\u0226\u0226\u0160\u0150\u0216\u0216\u0361\u0306\u0353\u0335\u0352\u0325\u0251\u0215\u0243\u0234\u0305\u0340\u0242\u0242\u0224\u0224\u0241\u0241\u0133\u0114\u0132\u0123\u0204\u0230\u0103\u0103\uFF06\uF7C5\uF635\uF534\uF4A3\uF462\uF441\uF431\u0411\u0411\u0410\u0410\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFD01\uFBE4\uFB43\uFB03\uFAB2\uFA83\uFA43\uFA01\uF9F2\uF9D2\uF9B2\uF991\uF982\uF962\uF942\uF921\uF912\uF8F1\uF8E2\uF8C2\uF8A2\u061D\uF881\uF871\uF861\uF851\u06C3\u06C2\u062C\u06B5\uF841\u06C1\u061C\uF831\u060C\uF821\uF811\u06B3\u063B\uF801\u06B2\uF7F1\u064A\uF7E1\u0649\uF7D1\u052B\u052B\u05B1\u05B1\u051B\u051B\u06B0\u060B\u0669\u06A4\u06A3\u063A\u0695\u0659\u05A2\u05A2\u052A\u052A\uFCF4\uFC33\uFC72\u04FF\u04FE\u04FD\u04EE\u04FC\u04ED\u04FB\u04BF\u04EC\u04CD\uFC41\u03CE\u03CE\u03DD\u03DD\uFC51\u02DF\u01DE\u01DE\u01EF\u01CF\u01FA\u019E\uFBF1\u03EB\u03BE\u03F9\u039F\u03AE\u03DB\u03BD\u01AF\u01DC\u04F8\u048F\u04CC\uFB61\u04E8\uFB51\u037F\u037F\u03AD\u03AD\u04DA\u04CB\u04BC\u046F\u03F6\u03F6\u01EA\u01E9\u01F7\u01E7\u038E\u03F5\u03D9\u039D\u035F\u037E\u03CA\u03BB\u03F4\u034F\uFAC1\u033F\u02F3\u02F3\u03D8\u038D\u01AC\u016E\u02F2\u022F\uFA91\u02F0\u01E6\u01C9\u039C\u03E5\u02BA\u02BA\u03D7\u037D\u02E4\u02E4\u038C\u036D\u02E3\u02E3\u029B\u029B\u03B9\u03AA\u01F1\u011F\u010F\u010F\u02AB\u025E\u024E\u02C8\u02D6\u023E\u012E\u012E\u02E2\u02E0\u01E1\u011E\u020E\u02D5\u025D\u02C7\u027C\u02D4\u02B8\u028B\u024D\u02A9\u029A\u02C6\u016C\u01D3\u023D\u02B7\u01D2\u01D2\u012D\u01D1\u017B\u017B\u02C5\u025C\u0299\u02A7\u013C\u013C\u027A\u0279\u01B4\u01B4\u01D0\u010D\u01A8\u018A\u01C4\u014C\u01B6\u016B\u015B\u0198\u0189\u01C0\u014B\u01A6\u016A\u0197\u0188\u01A5\u015A\u0196\u0187\u0178\u0177\u0167\u05A1\u051A\uF6C1\u050A\uF6B1\u0539\uF6A1\uF691\u0592\u0529\uF681\u0583\u0538\uF671\uF661\uF651\u0491\u0491\u0419\u0419\u0590\u0509\u0584\u0548\u0527\uF641\u0482\u0482\u0428\u0428\u0481\u0481\u01A0\u0186\u0168\u0194\u0193\u0185\u0158\u0176\u0175\u0157\u0166\u0174\u0147\u0165\u0156\u0137\u0164\u0146\u0573\u0572\u0471\u0471\u0417\u0417\u0555\u0570\u0507\u0563\u0536\u0554\u0545\u0562\u0526\u0553\u0318\u0318\u0318\u0318\u0480\u0480\u0408\u0408\u0461\u0461\u0416\u0416\u0460\u0460\u0406\u0406\uF4B1\u0452\u0425\u0450\u0351\u0351\u0315\u0315\u0443\u0434\u0405\u0442\u0424\u0433\u0341\u0341\u0135\u0144\u0214\u0214\u0340\u0304\u0332\u0323\u0231\u0231\u0213\u0230\u0203\u0222\u0121\u0112\u0120\u0102\uFF06\uFB65\uF9D5\uF8D4\uF834\uF7B4\uF733\uF6E3\uF693\uF653\uF612\uF5F2\uF5D1\uF5C2\uF5A1\u0522\u0521\u0512\u0520\u0502\u0311\u0311\u0311\u0311\u0410\u0410\u0401\u0401\u0300\u0300\u0300\u0300\uFD02\uFCE2\uFCC2\uFCA2\uFC81\uFC71\uFC61\uFC51\uFC41\uFC31\uFC21\uFC11\uFC01\uFBF1\uFBE1\uFBD2\u06BC\u066F\uFBB1\uFBA1\u065F\u06E7\u067E\u06CA\u06AC\u06BB\uFB91\u06F4\u064F\u06F3\u063F\u068D\u066E\u06F2\u062F\uFB81\u06F1\u061F\u06C9\u069C\u06E5\u06BA\u06AB\u065E\u06D7\u067D\u06E4\u064E\u06C8\u068C\u06E3\u06D6\u066D\u063E\u06B9\u069B\u06E2\u06AA\u062E\u06E1\u061E\uFB71\u06D5\u065D\u02FF\u02FE\u02EF\u02FD\u01EE\u01EE\u02DF\u02FC\u02CF\u02ED\u02DE\u02FB\u01BF\u01BF\u02EC\u02CE\u01DD\u01FA\u01AF\u01EB\u01BE\u01DC\u01CD\u01F9\u019F\u01AE\u01DB\u01BD\u01F8\u018F\u01CC\u01E9\u019E\u01F7\u017F\u01DA\u01AD\u01CB\u01F6\u01F6\u02EA\u02F0\u01E8\u018E\u01F5\u01D9\u019D\u01D8\u01E6\u010F\u01E0\u010E\uFA61\uFA51\u054D\uFA41\uFA31\uFA21\u053D\u052D\uFA11\u05D1\u05B7\u057B\u051D\uFA01\u055C\u05A8\u058A\u05C4\u054C\u05B6\u056B\uF9F1\u05C3\u053C\u05A7\u057A\u056A\uF9E1\u042C\u042C\u05C2\u05B5\u01C7\u017C\u01D4\u01B8\u018B\u01A9\u019A\u01C6\u016C\u01D3\u01D2\u01D0\u01C5\u010D\u0199\u01C0\u010C\u01B0\u055B\u05C1\u0598\u0589\u051C\u05B4\u054B\u05A6\u05B3\u0597\u043B\u043B\u0579\u0588\u05B2\u05A5\u042B\u042B\u055A\u05B1\u041B\u041B\u050B\u0596\u0569\u05A4\u054A\u0587\u0578\u05A3\u043A\u043A\u0495\u0459\u04A2\u042A\u04A1\u041A\uF851\u0486\u0468\u0494\u0449\u0493\u0439\uF841\u0485\u0458\u01A0\u010A\u0177\u0190\u0492\u0476\u0467\u0429\u0319\u0319\u0491\u0409\u0484\u0448\u0475\u0457\u0483\u0438\u0466\u0474\u0382\u0382\u0328\u0328\u0381\u0381\u0318\u0318\u0447\u0480\u0408\u0465\u0456\u0473\u0437\u0464\u0372\u0327\u0346\u0371\u0355\u0317\uF6F1\u0363\u0170\u0107\u0336\u0354\u0345\u0362\u0326\u0361\uF6A1\u0353\u0160\u0106\u0216\u0216\u0335\u0344\u0252\u0252\u0225\u0225\u0251\u0251\u0215\u0215\u0350\u0305\u0243\u0243\u0234\u0242\u0224\u0233\u0114\u0114\u0241\u0240\u0132\u0123\u0204\u0230\u0131\u0131\u0113\u0103\uFF05\uFC84\uF7F6\uF5C4\uF4F4\uF473\uF431\uF421\u0411\u0411\u0410\u0410\u0301\u0301\u0301\u0301\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\u0100\uFE01\uFDF1\uFDE1\uFDD1\u05FA\uFDC1\uFDB1\u05F8\u05F7\u057F\u05F6\u056F\u03FF\u03FF\u03FF\u03FF\u05F5\u055F\u04F4\u04F4\u044F\u044F\u043F\u043F\u040F\u040F\u05F3\uFDA4\u032F\u032F\u032F\u032F\u01FE\u01EF\u01FD\u01DF\u01FC\u01CF\u01FB\u01BF\u01AF\u01F9\u019F\u018F\uFD22\uFCF2\u04EE\uFCD1\u04EB\u04DC\uFCC1\u04EA\u04CC\uFCB1\uFCA1\u04AC\uFC91\u04E5\u03DB\u03DB\u02EC\uFD01\u01ED\u01ED\u01CE\u01DD\u019E\u019E\u02AE\u029D\u01DE\u01BE\u01CD\u01BD\u01DA\u01AD\u01E7\u01CA\u019C\u01D7\u04F2\u04F0\u03F1\u03F1\u031F\u031F\uFC05\uFB04\uFA54\uF9D3\uF973\uF923\uF8E3\uF8A2\uF873\uF833\u04E9\u04E9\u05CB\u05BC\u05E8\u058E\u05D9\u057E\u05BB\u05D8\u058D\u05E6\u046E\u046E\u04C9\u04C9\u05BA\u05AB\u055E\u057D\u04E4\u04E4\u054E\u05C8\u048C\u048C\u04E3\u04E3\u04D6\u04D6\u056D\u05B9\uFA81\u041E\u044D\uFA71\u04B7\uFA61\u033E\u033E\u04E0\u040E\u04D5\u045D\u04C7\u047C\u04D4\u04B8\u019B\u01AA\u018B\u019A\u017B\u010D\u04A9\u04C6\u046C\u04D3\u04C5\u045C\u03D0\u03D0\u04A8\u048A\u0499\u04C4\u046B\u04A7\u03C3\u03C3\uF991\u03C1\u030C\uF981\u022E\u022E\u03E2\u03E1\u01B5\u0198\u0189\u0197\u033D\u03D2\u032D\u031D\u03B3\uF931\u02D1\u02D1\u0179\u0188\u034C\u03B6\u033C\u037A\u02C2\u02C2\u032C\u035B\u031C\u03C0\u03B4\u034B\u03A6\u036A\u023B\u023B\uF881\u02B2\u022B\u02B1\u01A5\u015A\u021B\u021B\u03B0\u030B\u0396\u0369\u03A4\u034A\u0387\u0378\u023A\u023A\u03A3\u0395\u02A2\u02A2\uF5F1\u061A\uF5E1\u0649\uF5D1\u0676\u052A\u052A\u05A1\u05A1\u06A0\u060A\u0693\u0639\u0685\u0658\u0592\u0592\u0529\u0529\u0667\u0690\u0591\u0591\u0519\u0519\u0609\u0684\u0648\u0657\u0683\u0638\u0666\u0682\u0528\u0528\u0674\u0647\u0581\u0581\u0518\u0518\u0508\u0508\u0680\u0665\u0573\u0573\u0537\u0537\u0656\u0664\u0572\u0572\u0527\u0527\u0646\u0655\u0570\u0570\u0471\u0471\u0471\u0471\u0159\u0186\u0168\u0177\u0194\u0175\u0417\uF541\uF531\uF521\u0426\u0461\u0416\uF511\u0435\uF501\u0452\u0425\u0315\u0315\u0451\u0450\u0107\u0163\u0136\u0154\u0145\u0162\u0160\u0106\u0153\u0144\u0443\u0434\u0405\u0442\u0424\u0433\u0341\u0341\u0314\u0314\u0440\u0404\u0332\u0332\u0323\u0323\u0231\u0231\u0213\u0213\u0330\u0303\u0222\u0222\u0121\u0112\u0120\u0102\uFF03\uFEC3\uFE83\uFE42\uFE22\uFE03\u04FF\u04FF\uFCD5\uFB65\uFA55\uF924\uF894\uF814\uF773\uF733\uF6E3\uF692\uF673\uF631\uF622\u0521\u0512\uF601\u0411\u0411\u0410\u0410\u0401\u0401\u0400\u0400\u03FE\u03EF\u03FD\u03DF\u03FC\u03CF\u03FB\u03BF\u02AF\u02AF\u03FA\u03F9\u029F\u029F\u028F\u028F\u03F8\u03F7\u027F\u027F\u02F6\u02F6\u026F\u026F\u02F5\u025F\u02F4\u024F\u02F3\u023F\u02F2\u022F\u021F\u021F\u03F1\u030F\uFDC1\uFD93\uFD53\uFD13\u01F0\uFDB2\u02EE\u02ED\u02DE\u02EC\u03CE\u03DD\u03EB\u03BE\u03DC\u03CD\u03EA\u03AE\u03DB\u03BD\u03CC\u03E9\u039E\u03DA\u03AD\u03CB\u03BC\u03E8\u038E\u03D9\u039D\u03E7\u037E\u03CA\uFBD1\uFBC1\uFBB2\u056E\uFB91\u059C\u05E5\u05AB\u055E\uFB81\u057D\u054E\u05C8\u058C\uFB71\u05E3\u05D6\u056D\u053E\u05B9\u059B\u05AA\u052E\u05E1\u051E\u05D5\u055D\u05C7\u057C\u05D4\u05B8\u058B\u01AC\u01BB\u01D8\u018D\u02E0\u020E\u01D0\u01D0\u01E6\u01C9\u01BA\u01D7\u01E4\u01E2\u054D\u05A9\u059A\u05C6\u056C\u05D3\u053D\u05D2\u052D\u05D1\u05B7\u057B\u051D\u05C5\u055C\u05A8\u058A\u0599\u05C4\u054C\u05B6\u056B\uFA61\u05C3\u053C\u05A7\u057A\u05C2\u052C\u05B5\u055B\u05C1\u010D\u01C0\u0598\u0589\u051C\u05B4\uF951\u05B3\uF941\u05A1\u044B\u044B\u05A6\u056A\u0597\u0579\uF931\u0509\u043B\u043B\u0488\u0488\u05B2\u05A5\u042B\u042B\u055A\u05B1\u051B\u0596\u0469\u0469\u044A\u044A\u010C\u01B0\u010B\u01A0\u010A\u0190\uF8A1\u0478\u04A3\u043A\u0495\u0459\u04A2\u042A\u041A\u0486\u0468\u0477\u0494\u0449\u0493\u0439\u01A4\u0187\u0485\u0458\u0492\u0476\u0467\u0429\u0491\u0419\u0484\u0448\u0475\u0457\u0483\u0438\u0466\u0482\u0428\u0481\u0474\u0447\u0418\uF791\u0465\u0456\u0471\uF781\u0337\u0337\u0473\u0472\u0327\u0327\u0180\u0108\u0170\u0107\u0364\u0346\u0355\u0317\u0363\u0336\u0354\u0345\u0362\u0326\u0361\u0316\uF6F1\u0353\u0335\u0344\u0160\u0106\u0352\u0325\u0351\uF6A1\u0215\u0215\u0343\u0334\u0150\u0105\u0242\u0224\u0233\u0241\u0214\u0214\u0340\u0304\u0232\u0232\u0223\u0223\u0131\u0113\u0230\u0203\u0122\u0122\u0120\u0102');
    this.h62_1 = arrayOfUByte$default(this, '\x82\xA2\xC1\xD1,\x1CL\x8C\t\t\t\t\t\t\t\t\xBE\xFE\xDE\xEE~^\x9D\x9Dm=\xAD\xCD');
    this.i62_1 = arrayOfUByte$default(this, '\xFC\xEC\xDC\xCC\xBC\xAC\x9C\x8C|l\\L<,\x1C\f');
    this.j62_1 = arrayOfShort$default(this, '\x00 @b\x00\x84\xB4\xDA\u0124\u016C\u01AA\u021A\u0288\u02EA\x00\u0466\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u05B4\u0732\u0732\u0732\u0732\u0732\u0732\u0732\u0732');
    this.k62_1 = arrayOfUByte$default(this, '\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x01\x02\x03\x04\x06\b\n\r\x04\x05\x06\x07\b\t\x0B\r');
    this.l62_1 = arrayOfUByte$default(this, '\x00\x11\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x00\x11\x12\x03\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x10\x00\x11\x12\x03\x13\x04\x05\x10\x00\x11\x12\x10\x00\x11\x12\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x00\x11\x12\x03\x13\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x00\x02\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10');
    var tmp_13 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_13.m62_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\f\f\f\f\f\f\x10\x14\x18\x1C (08@LZ\x02\x02\x02\x02\x02\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x12\x16\x1A &.6>FL$\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x06\x06\x06\x06\x06\x06\b\n\f\x0E\x10\x14\x18\x1C &.4<D:6\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\b\b\n\f\x10\x14\x18\x1C"*26L\x9E\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\n\f\x10\x12\x16\x1C"(.66\xC0\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x06\x06\b\n\f\x10\x14\x18\x1E&.8DTf\x1A\x00'))];
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.n62_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\b\b\b\b\b\b\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x18\x18\x18\x1C\x1C\x1C$$$\x02\x02\x02\x02\x02\x02\x02\x02\x02\x1A\x1A\x1A\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\x0E\x0E\x0E\x12\x12\x12\x1A\x1A\x1A   ***\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18   ,,,\f\f\f\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x16\x16\x16\x1E\x1E\x1E888\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\x06\x06\x06\n\n\n\f\f\f\x0E\x0E\x0E\x10\x10\x10\x14\x14\x14\x1A\x1A\x1ABBB\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x04\x06\x06\x06\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x1A\x1A\x1A"""***\f\f\f\x00'))];
    var tmp_15 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_15.o62_1 = [new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte$default(this, '\f\f\f\x04\x04\x04\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x18\x18\x18\x1C\x1C\x1C$$$\x02\x02\x02\x02\x02\x02\x02\x02\x02\x1A\x1A\x1A\x00')), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\x0E\x0E\x0E\x12\x12\x12\x1A\x1A\x1A   ***\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18   ,,,\f\f\f\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x06\x06\x06\x06\x06\x06\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x18\x18\x18\x1E\x1E\x1E(((\x12\x12\x12\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\b\b\b\n\n\n\f\f\f\x0E\x0E\x0E\x12\x12\x12\x16\x16\x16\x1E\x1E\x1E888\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\x06\x06\x06\n\n\n\f\f\f\x0E\x0E\x0E\x10\x10\x10\x14\x14\x14\x1A\x1A\x1ABBB\x00', 40)), new UByteArrayInt(arrayOfUByte(this, '\x04\x04\x04\x04\x04\x04\x06\x06\x04\x04\x04\x06\x06\x06\b\b\b\f\f\f\x10\x10\x10\x14\x14\x14\x1A\x1A\x1A"""***\f\f\f\x00', 40))];
    var tmp_16 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_16.p62_1 = [new UByteArrayInt(arrayOfUByte$default(this, '\x06\x05\x05\x05\x06\x05\x05\x05\x06\x05\x07\x03\x0B\n\x00\x00\x07\x07\x07\x00\x06\x06\x06\x03\b\b\x05\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\b\t\x06\f\x06\t\t\t\x06\t\f\x06\x0F\x12\x00\x00\x06\x0F\f\x00\x06\f\t\x06\x06\x12\t\x00')), new UByteArrayInt(arrayOfUByte$default(this, '\t\t\x06\f\t\t\t\t\t\t\f\x06\x12\x12\x00\x00\f\f\f\x00\f\t\t\x06\x0F\f\t\x00'))];
    var tmp_17 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_17.q62_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(76), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(32))];
    var tmp_18 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_18.r62_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(60), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(4)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(7)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(2), _UByte___init__impl__g9hnc4(19))];
    var tmp_19 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_19.s62_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(0), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(3)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(16), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(8)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(32), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(12)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(40), _UByte___init__impl__g9hnc4(2), _UByte___init__impl__g9hnc4(7))];
    var tmp_20 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_20.t62_1 = [new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(4), _UByte___init__impl__g9hnc4(2)), new L12_subband_alloc_tStruct(_UByte___init__impl__g9hnc4(44), _UByte___init__impl__g9hnc4(3), _UByte___init__impl__g9hnc4(10))];
    var tmp_21 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_21.u62_1 = new Float32Array([0.0, -1.0, -2.519842, -4.326749, -6.349604, -8.54988, -10.902724, -13.390518, -16.0, -18.720755, -21.544348, -24.463781, -27.473143, -30.56735, -33.741993, -36.99318, 0.0, 1.0, 2.519842, 4.326749, 6.349604, 8.54988, 10.902724, 13.390518, 16.0, 18.720755, 21.544348, 24.463781, 27.473143, 30.56735, 33.741993, 36.99318, 40.317474, 43.71179, 47.173344, 50.69963, 54.288353, 57.93741, 61.644863, 65.40894, 69.22798, 73.10044, 77.024895, 81.0, 85.02449, 89.09719, 93.21697, 97.3828, 101.593666, 105.84863, 110.146805, 114.48732, 118.869385, 123.292206, 127.755066, 132.25725, 136.79808, 141.3769, 145.99312, 150.64612, 155.33533, 160.0602, 164.8202, 169.61482, 174.44357, 179.30598, 184.20157, 189.12991, 194.09058, 199.08315, 204.10721, 209.16238, 214.24829, 219.36456, 224.51085, 229.68678, 234.89206, 240.12633, 245.38928, 250.6806, 256.0, 261.34717, 266.72183, 272.12372, 277.55255, 283.00806, 288.48996, 293.99805, 299.53207, 305.09177, 310.6769, 316.28726, 321.92258, 327.5827, 333.26736, 338.97638, 344.70956, 350.46664, 356.24747, 362.05188, 367.8796, 373.73053, 379.60443, 385.50113, 391.4205, 397.3623, 403.32642, 409.31268, 415.3209, 421.3509, 427.4026, 433.47574, 439.57028, 445.68597, 451.82275, 457.98044, 464.15887, 470.35797, 476.57755, 482.81744, 489.0776, 495.35788, 501.65808, 507.97815, 514.31793, 520.6773, 527.0562, 533.4544, 539.8719, 546.3085, 552.76404, 559.2386, 565.7319, 572.2439, 578.7744, 585.3235, 591.89087, 598.47656, 605.08044, 611.70233, 618.3422, 625.0, 631.67554, 638.3688, 645.0796]);
  }
}
class L12_subband_alloc_tStruct {
  constructor(tab_offset, code_tab_width, band_count) {
    this.v62_1 = tab_offset;
    this.w62_1 = code_tab_width;
    this.x62_1 = band_count;
  }
  toString() {
    return 'L12_subband_alloc_tStruct(tab_offset=' + new UByte(this.v62_1) + ', code_tab_width=' + new UByte(this.w62_1) + ', band_count=' + new UByte(this.x62_1) + ')';
  }
  hashCode() {
    var result = UByte__hashCode_impl_mmczcb(this.v62_1);
    result = imul(result, 31) + UByte__hashCode_impl_mmczcb(this.w62_1) | 0;
    result = imul(result, 31) + UByte__hashCode_impl_mmczcb(this.x62_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof L12_subband_alloc_tStruct))
      return false;
    var tmp0_other_with_cast = other instanceof L12_subband_alloc_tStruct ? other : THROW_CCE();
    if (!(this.v62_1 === tmp0_other_with_cast.v62_1))
      return false;
    if (!(this.w62_1 === tmp0_other_with_cast.w62_1))
      return false;
    if (!(this.x62_1 === tmp0_other_with_cast.x62_1))
      return false;
    return true;
  }
}
class Mp3Dec {
  static y62(mdct_overlap, qmf_state, reserv, free_format_bytes_array, header, reserv_buf) {
    var $this = createThis(this);
    $this.x5w_1 = mdct_overlap;
    $this.y5w_1 = qmf_state;
    $this.z5w_1 = reserv;
    $this.a5x_1 = free_format_bytes_array;
    $this.b5x_1 = header;
    $this.c5x_1 = reserv_buf;
    return $this;
  }
  static d5x() {
    var tmp = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_0 = fillArrayVal(Array(2), null);
    while (tmp < 2) {
      tmp_0[tmp] = new Float32Array(288);
      tmp = tmp + 1 | 0;
    }
    return this.y62(tmp_0, new Float32Array(960), 0, new Int32Array(1), _UByteArrayInt___init__impl__xif7bu_1(4), _UByteArrayInt___init__impl__xif7bu_1(511));
  }
}
class Bs {
  constructor(buf, pos, limit) {
    buf = buf === VOID ? new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(0)) : buf;
    pos = pos === VOID ? 0 : pos;
    limit = limit === VOID ? 0 : limit;
    this.z62_1 = buf;
    this.a63_1 = pos;
    this.b63_1 = limit;
  }
}
class Mp3Scratch {
  static j63(bs, maindata, gr_info, grbuf, scf, syn, ist_pos) {
    var $this = createThis(this);
    $this.c63_1 = bs;
    $this.d63_1 = maindata;
    $this.e63_1 = gr_info;
    $this.f63_1 = grbuf;
    $this.g63_1 = scf;
    $this.h63_1 = syn;
    $this.i63_1 = ist_pos;
    return $this;
  }
  static k63() {
    var tmp = new Bs();
    var tmp_0 = new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(2815));
    var tmp_1 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(4), null);
    while (tmp_1 < 4) {
      tmp_2[tmp_1] = new GrInfo();
      tmp_1 = tmp_1 + 1 | 0;
    }
    var tmp_3 = new ArrayPtr(tmp_2, 0);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.Mp3Scratch.<init>.<anonymous>' call
    var CSIZE = 576;
    var data = new Float32Array(imul(2, CSIZE));
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(2), null);
    while (tmp_4 < 2) {
      var tmp_6 = tmp_4;
      tmp_5[tmp_6] = new FloatArrayPtr(data, imul(CSIZE, tmp_6));
      tmp_4 = tmp_4 + 1 | 0;
    }
    var tmp_7 = tmp_5;
    var tmp_8 = new FloatArrayPtr(new Float32Array(40));
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.audio.format.Mp3Scratch.<init>.<anonymous>' call
    var CSIZE_0 = 64;
    var data_0 = new Float32Array(imul(33, CSIZE_0));
    var tmp_9 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_10 = fillArrayVal(Array(33), null);
    while (tmp_9 < 33) {
      var tmp_11 = tmp_9;
      tmp_10[tmp_11] = new FloatArrayPtr(data_0, imul(CSIZE_0, tmp_11));
      tmp_9 = tmp_9 + 1 | 0;
    }
    var tmp_12 = tmp_10;
    var tmp_13 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(2), null);
    while (tmp_13 < 2) {
      var tmp_15 = tmp_13;
      var tmp$ret$11 = _UByteArrayInt___init__impl__xif7bu_1(39);
      tmp_14[tmp_15] = new UByteArrayInt(tmp$ret$11);
      tmp_13 = tmp_13 + 1 | 0;
    }
    return this.j63(tmp, tmp_0, tmp_3, tmp_7, tmp_8, tmp_12, tmp_14);
  }
}
class Mp3FrameInfo {
  constructor(frame_bytes, frame_offset, channels, hz, layer, bitrate_kbps) {
    frame_bytes = frame_bytes === VOID ? 0 : frame_bytes;
    frame_offset = frame_offset === VOID ? 0 : frame_offset;
    channels = channels === VOID ? 0 : channels;
    hz = hz === VOID ? 0 : hz;
    layer = layer === VOID ? 0 : layer;
    bitrate_kbps = bitrate_kbps === VOID ? 0 : bitrate_kbps;
    this.e5y_1 = frame_bytes;
    this.f5y_1 = frame_offset;
    this.g5y_1 = channels;
    this.h5y_1 = hz;
    this.i5y_1 = layer;
    this.j5y_1 = bitrate_kbps;
  }
  n1() {
    return this;
  }
}
class ArrayPtr {
  constructor(array, pos) {
    this.l63_1 = array;
    this.m63_1 = pos;
  }
  n1() {
    return this.l63_1[this.m63_1];
  }
  d1(index) {
    return this.l63_1[this.m63_1 + index | 0];
  }
  v3() {
    return new ArrayPtr(this.l63_1, this.m63_1 + 1 | 0);
  }
  n63(other) {
    return new ArrayPtr(this.l63_1, this.m63_1 + other | 0);
  }
}
class UByteArrayIntPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.o63_1 = array;
    this.p63_1 = pos;
  }
  n1() {
    return UByteArrayInt__get_impl_px6q8a(this.o63_1, this.p63_1);
  }
  d1(index) {
    return UByteArrayInt__get_impl_px6q8a(this.o63_1, this.p63_1 + index | 0);
  }
  e2o(index, value) {
    UByteArrayInt__set_impl_gn4532(this.o63_1, this.p63_1 + index | 0, value);
  }
  v3() {
    return new UByteArrayIntPtr(this.o63_1, this.p63_1 + 1 | 0);
  }
  n63(other) {
    return new UByteArrayIntPtr(this.o63_1, this.p63_1 + other | 0);
  }
  q63(other) {
    return this.p63_1 - other.p63_1 | 0;
  }
  r63(value, from, to) {
    var tmp = _UByteArrayInt___get_bytes__impl__pj0ilc(this.o63_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    fill(tmp, tmp$ret$0, this.p63_1 + from | 0, this.p63_1 + to | 0);
  }
}
class FloatArrayPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.s63_1 = array;
    this.t63_1 = pos;
  }
  u63(value) {
    this.s63_1[this.t63_1] = value;
  }
  n1() {
    return this.s63_1[this.t63_1];
  }
  d1(index) {
    return this.s63_1[this.t63_1 + index | 0];
  }
  v63(index, value) {
    this.s63_1[this.t63_1 + index | 0] = value;
  }
  v3() {
    return new FloatArrayPtr(this.s63_1, this.t63_1 + 1 | 0);
  }
  n63(other) {
    return new FloatArrayPtr(this.s63_1, this.t63_1 + other | 0);
  }
  w63(other) {
    return this.t63_1 - other.t63_1 | 0;
  }
  x63(value, from, to) {
    fill_0(this.s63_1, value, this.t63_1 + from | 0, this.t63_1 + to | 0);
  }
}
class ShortArrayPtr {
  constructor(array, pos) {
    pos = pos === VOID ? 0 : pos;
    this.y63_1 = array;
    this.z63_1 = pos;
  }
  a64(index, value) {
    this.y63_1[this.z63_1 + index | 0] = value;
  }
  n63(other) {
    return new ShortArrayPtr(this.y63_1, this.z63_1 + other | 0);
  }
}
class GrInfo {
  constructor(sfbtab, part_23_length, big_values, scalefac_compress, global_gain, block_type, mixed_block_flag, n_long_sfb, n_short_sfb, table_select, region_count, subblock_gain, preflag, scalefac_scale, count1_table, scfsi) {
    sfbtab = sfbtab === VOID ? new UByteArrayIntPtr(_UByteArrayInt___init__impl__xif7bu_1(0)) : sfbtab;
    part_23_length = part_23_length === VOID ? 0 : part_23_length;
    big_values = big_values === VOID ? 0 : big_values;
    scalefac_compress = scalefac_compress === VOID ? 0 : scalefac_compress;
    global_gain = global_gain === VOID ? 0 : global_gain;
    block_type = block_type === VOID ? 0 : block_type;
    mixed_block_flag = mixed_block_flag === VOID ? 0 : mixed_block_flag;
    n_long_sfb = n_long_sfb === VOID ? 0 : n_long_sfb;
    n_short_sfb = n_short_sfb === VOID ? 0 : n_short_sfb;
    table_select = table_select === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : table_select;
    region_count = region_count === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : region_count;
    subblock_gain = subblock_gain === VOID ? _UByteArrayInt___init__impl__xif7bu_1(3) : subblock_gain;
    preflag = preflag === VOID ? 0 : preflag;
    scalefac_scale = scalefac_scale === VOID ? 0 : scalefac_scale;
    count1_table = count1_table === VOID ? 0 : count1_table;
    scfsi = scfsi === VOID ? 0 : scfsi;
    this.b64_1 = sfbtab;
    this.c64_1 = part_23_length;
    this.d64_1 = big_values;
    this.e64_1 = scalefac_compress;
    this.f64_1 = global_gain;
    this.g64_1 = block_type;
    this.h64_1 = mixed_block_flag;
    this.i64_1 = n_long_sfb;
    this.j64_1 = n_short_sfb;
    this.k64_1 = table_select;
    this.l64_1 = region_count;
    this.m64_1 = subblock_gain;
    this.n64_1 = preflag;
    this.o64_1 = scalefac_scale;
    this.p64_1 = count1_table;
    this.q64_1 = scfsi;
  }
}
class ScaleInfo {
  constructor(scf, total_bands, stereo_bands, bitalloc, scfcod) {
    scf = scf === VOID ? new Float32Array(192) : scf;
    total_bands = total_bands === VOID ? 0 : total_bands;
    stereo_bands = stereo_bands === VOID ? 0 : stereo_bands;
    bitalloc = bitalloc === VOID ? _UByteArrayInt___init__impl__xif7bu_1(64) : bitalloc;
    scfcod = scfcod === VOID ? _UByteArrayInt___init__impl__xif7bu_1(64) : scfcod;
    this.r64_1 = scf;
    this.s64_1 = total_bands;
    this.t64_1 = stereo_bands;
    this.u64_1 = bitalloc;
    this.v64_1 = scfcod;
  }
}
class WAV extends AudioFormat {
  constructor() {
    Companion_getInstance_11();
    super(['wav']);
  }
  f5u(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_tryReadInfo__rowfdh_1.bind(VOID, this, data, props), $completion);
  }
  k5u(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeStreamInternal__hls877_0.bind(VOID, this, data, props), $completion);
  }
  v65(data, handle, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_parse__tgo4f5.bind(VOID, this, data, handle), $completion);
  }
  w65(data, handler, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_riff__qieez3.bind(VOID, this, data, handler), $completion);
  }
}
class Companion_7 extends WAV {
  constructor() {
    Companion_instance_8 = null;
    super();
    Companion_instance_8 = this;
  }
}
class Chunk {
  constructor(type, data) {
    this.k65_1 = type;
    this.l65_1 = data;
  }
  il() {
    return this.k65_1;
  }
  jl() {
    return this.l65_1;
  }
  toString() {
    return 'Chunk(type=' + this.k65_1 + ', data=' + this.l65_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.k65_1);
    result = imul(result, 31) + hashCode(this.l65_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Chunk))
      return false;
    var tmp0_other_with_cast = other instanceof Chunk ? other : THROW_CCE();
    if (!(this.k65_1 === tmp0_other_with_cast.k65_1))
      return false;
    if (!equals(this.l65_1, tmp0_other_with_cast.l65_1))
      return false;
    return true;
  }
}
class ProcessedChunk {
  constructor(type, data, extra) {
    this.x65_1 = type;
    this.y65_1 = data;
    this.z65_1 = extra;
  }
  toString() {
    return 'ProcessedChunk(type=' + this.x65_1 + ', data=' + this.y65_1.toString() + ', extra=' + toString(this.z65_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.x65_1);
    result = imul(result, 31) + hashCode(this.y65_1) | 0;
    result = imul(result, 31) + hashCode(this.z65_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ProcessedChunk))
      return false;
    var tmp0_other_with_cast = other instanceof ProcessedChunk ? other : THROW_CCE();
    if (!(this.x65_1 === tmp0_other_with_cast.x65_1))
      return false;
    if (!equals(this.y65_1, tmp0_other_with_cast.y65_1))
      return false;
    if (!equals(this.z65_1, tmp0_other_with_cast.z65_1))
      return false;
    return true;
  }
}
class WavAudioStream extends AudioStream {
  constructor(fmt, buffer, bufferLength, data, props) {
    super(fmt.r65_1, fmt.q65_1);
    this.c65_1 = fmt;
    this.d65_1 = buffer;
    this.e65_1 = bufferLength;
    this.f65_1 = data;
    this.g65_1 = props;
    this.h65_1 = this.c65_1.a66();
    this.i65_1 = false;
  }
  k61() {
    return this.i65_1;
  }
  l61() {
    // Inline function 'kotlin.Long.div' call
    var this_0 = this.e65_1;
    var other = this.h65_1;
    return this_0.t3(toLong(other));
  }
  m61(position, $completion) {
    this.i65_1 = false;
    var tmp = this.d65_1;
    // Inline function 'kotlin.Long.times' call
    var this_0 = this.c61(position);
    var other = this.h65_1;
    tmp.d1u_1 = this_0.s3(toLong(other));
  }
  n61(out, offset, length, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_read__qih2oe_0.bind(VOID, this, out, offset, length), $completion);
  }
  o61($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_clone__nh2r5j.bind(VOID, this), $completion);
  }
}
class Fmt {
  constructor(formatTag, channels, samplesPerSec, avgBytesPerSec, blockAlign, bitsPerSample) {
    formatTag = formatTag === VOID ? -1 : formatTag;
    channels = channels === VOID ? 2 : channels;
    samplesPerSec = samplesPerSec === VOID ? 44100 : samplesPerSec;
    avgBytesPerSec = avgBytesPerSec === VOID ? new Long(0, 0) : avgBytesPerSec;
    blockAlign = blockAlign === VOID ? 0 : blockAlign;
    bitsPerSample = bitsPerSample === VOID ? 0 : bitsPerSample;
    this.p65_1 = formatTag;
    this.q65_1 = channels;
    this.r65_1 = samplesPerSec;
    this.s65_1 = avgBytesPerSec;
    this.t65_1 = blockAlign;
    this.u65_1 = bitsPerSample;
  }
  a66() {
    return this.u65_1 / 8 | 0;
  }
  toString() {
    return 'Fmt(formatTag=' + this.p65_1 + ', channels=' + this.q65_1 + ', samplesPerSec=' + this.r65_1 + ', avgBytesPerSec=' + this.s65_1.toString() + ', blockAlign=' + this.t65_1 + ', bitsPerSample=' + this.u65_1 + ')';
  }
  hashCode() {
    var result = this.p65_1;
    result = imul(result, 31) + this.q65_1 | 0;
    result = imul(result, 31) + this.r65_1 | 0;
    result = imul(result, 31) + this.s65_1.hashCode() | 0;
    result = imul(result, 31) + this.t65_1 | 0;
    result = imul(result, 31) + this.u65_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Fmt))
      return false;
    var tmp0_other_with_cast = other instanceof Fmt ? other : THROW_CCE();
    if (!(this.p65_1 === tmp0_other_with_cast.p65_1))
      return false;
    if (!(this.q65_1 === tmp0_other_with_cast.q65_1))
      return false;
    if (!(this.r65_1 === tmp0_other_with_cast.r65_1))
      return false;
    if (!this.s65_1.equals(tmp0_other_with_cast.s65_1))
      return false;
    if (!(this.t65_1 === tmp0_other_with_cast.t65_1))
      return false;
    if (!(this.u65_1 === tmp0_other_with_cast.u65_1))
      return false;
    return true;
  }
}
class WAV$parse$slambda {
  constructor($fmt, $dataSize, $handle) {
    this.m65_1 = $fmt;
    this.n65_1 = $dataSize;
    this.o65_1 = $handle;
  }
  b66($this$riff, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$riff), $completion);
  }
  wd(p1, $completion) {
    return this.b66(p1 instanceof Chunk ? p1 : THROW_CCE(), $completion);
  }
}
class Companion_8 {}
class AudioSamplesDeque {
  constructor(channels) {
    this.d61_1 = channels;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.d61_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = new ShortArrayDeque();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.e61_1 = tmp_2;
  }
  w14() {
    var tmp34_safe_receiver = getOrNull_0(this.e61_1, 0);
    var tmp0_elvis_lhs = tmp34_safe_receiver == null ? null : tmp34_safe_receiver.w14();
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  c66() {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var this_0 = this.e61_1;
      // Inline function 'kotlin.collections.isEmpty' call
      if (this_0.length === 0) {
        tmp$ret$1 = null;
        break $l$block;
      }
      // Inline function 'korlibs.audio.sound.AudioSamplesDeque.<get-availableReadMax>.<anonymous>' call
      var maxValue = this_0[0].w14();
      var inductionVariable = 1;
      var last = get_lastIndex(this_0);
      if (inductionVariable <= last)
        do {
          var i = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          // Inline function 'korlibs.audio.sound.AudioSamplesDeque.<get-availableReadMax>.<anonymous>' call
          var v = this_0[i].w14();
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }
         while (!(i === last));
      tmp$ret$1 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  d66(channel) {
    return _AudioSample___init__impl__s54gd5(this.e61_1[channel].e2n());
  }
  e66(channel, sample) {
    this.e61_1[channel].f2n(_AudioSample___get_short__impl__uk8ygu(sample));
  }
  f66(samples, offset, len) {
    var inductionVariable = 0;
    var last = this.d61_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.g66(channel, samples.a5t(channel % samples.h5r_1 | 0), offset, len);
      }
       while (inductionVariable < last);
  }
  g66(channel, data, offset, len) {
    this.e61_1[channel].d2n(AudioSampleArray__asShortArray_impl_iyd0md(data), offset, len);
  }
  h66(data, offset, len, channels) {
    switch (channels) {
      case 1:
        var inductionVariable = 0;
        var last = this.d61_1;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.e61_1[n].d2n(AudioSampleArray__asShortArray_impl_iyd0md(data), offset, len);
          }
           while (inductionVariable < last);
        break;
      case 2:
        var inductionVariable_0 = 0;
        var last_0 = len / 2 | 0;
        if (inductionVariable_0 < last_0)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.e66(0, AudioSampleArray__get_impl_w0l0xc(data, imul(n_0, 2) + 0 | 0));
          }
           while (inductionVariable_0 < last_0);
        var inductionVariable_1 = 0;
        var last_1 = len / 2 | 0;
        if (inductionVariable_1 < last_1)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            this.e66(1, AudioSampleArray__get_impl_w0l0xc(data, imul(n_1, 2) + 1 | 0));
          }
           while (inductionVariable_1 < last_1);
        break;
      default:
        var inductionVariable_2 = 0;
        if (inductionVariable_2 < channels)
          do {
            var c = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var inductionVariable_3 = 0;
            var last_2 = len / channels | 0;
            if (inductionVariable_3 < last_2)
              do {
                var n_2 = inductionVariable_3;
                inductionVariable_3 = inductionVariable_3 + 1 | 0;
                this.e66(c, AudioSampleArray__get_impl_w0l0xc(data, imul(n_2, channels) + c | 0));
              }
               while (inductionVariable_3 < last_2);
          }
           while (inductionVariable_2 < channels);
        break;
    }
  }
  j61(data, offset, len, channels, $super) {
    len = len === VOID ? _AudioSampleArray___get_size__impl__8l8tm8(data) - offset | 0 : len;
    channels = channels === VOID ? this.d61_1 : channels;
    var tmp;
    if ($super === VOID) {
      this.h66(data, offset, len, channels);
      tmp = Unit_instance;
    } else {
      tmp = $super.h66.call(this, new AudioSampleArray(data), offset, len, channels);
    }
    return tmp;
  }
  f61(out, offset, len) {
    // Inline function 'kotlin.math.min' call
    var b = this.w14();
    var rlen = Math.min(len, b);
    var inductionVariable = 0;
    var last = out.h5r_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.e61_1[channel % this.d61_1 | 0].c2n(AudioSampleArray__asShortArray_impl_iyd0md(out.a5t(channel)), offset, rlen);
      }
       while (inductionVariable < last);
    return rlen;
  }
  i66(out, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? out.i5r_1 - offset | 0 : len;
    return $super === VOID ? this.f61(out, offset, len) : $super.f61.call(this, out, offset, len);
  }
  j66(out, offset, len) {
    // Inline function 'kotlin.math.min' call
    var b = this.w14();
    var rlen = Math.min(len, b);
    var channels = this.d61_1;
    var inductionVariable = 0;
    var last = out.h5s_1;
    if (inductionVariable < last)
      do {
        var channel = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inChannel = channel % channels | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < rlen)
          do {
            var n = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.b5t(channel, offset + n | 0, this.d66(inChannel));
          }
           while (inductionVariable_0 < rlen);
      }
       while (inductionVariable < last);
    return rlen;
  }
  k66(out, offset, len, $super) {
    offset = offset === VOID ? 0 : offset;
    len = len === VOID ? out.i5s_1 - offset | 0 : len;
    return $super === VOID ? this.j66(out, offset, len) : $super.j66.call(this, out, offset, len);
  }
  e3() {
    var inductionVariable = 0;
    var last = this.e61_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var c = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.e61_1[c].e3();
      }
       while (inductionVariable <= last);
  }
  toString() {
    return 'AudioSamplesDeque(channels=' + this.d61_1 + ', availableRead=' + this.w14() + ')';
  }
}
class Companion_9 {}
class createSound$slambda {
  constructor($stream) {
    this.l66_1 = $stream;
  }
  vd($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_11 = this;
    this.m66_1 = _PlaybackTimes___init__impl__rt6rw2(0);
    this.n66_1 = _PlaybackTimes___init__impl__rt6rw2(1);
    this.o66_1 = _PlaybackTimes___init__impl__rt6rw2(-1);
  }
}
class PlaybackTimes {
  constructor(count) {
    Companion_getInstance_14();
    this.p66_1 = count;
  }
  toString() {
    return PlaybackTimes__toString_impl_l4chjq(this.p66_1);
  }
  hashCode() {
    return PlaybackTimes__hashCode_impl_mtf95(this.p66_1);
  }
  equals(other) {
    return PlaybackTimes__equals_impl_suah7n(this.p66_1, other);
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_12 = this;
    var tmp = this;
    // Inline function 'korlibs.audio.sound.playbackTimes' call
    var tmp_0 = _PlaybackTimes___init__impl__rt6rw2(1);
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$2 = toDuration(0, DurationUnit_SECONDS_getInstance());
    tmp.q66_1 = new PlaybackParameters(tmp_0, tmp$ret$2);
  }
}
class PlaybackParameters {
  constructor(times, startTime, bufferTime, volume, pitch, panning, position, onCancel, onFinish) {
    Companion_getInstance_15();
    var tmp;
    if (times === VOID) {
      // Inline function 'korlibs.audio.sound.playbackTimes' call
      tmp = _PlaybackTimes___init__impl__rt6rw2(1);
    } else {
      tmp = times;
    }
    times = tmp;
    var tmp_0;
    if (startTime === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp_0 = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_0 = startTime;
    }
    startTime = tmp_0;
    var tmp_1;
    if (bufferTime === VOID) {
      // Inline function 'korlibs.time.seconds' call
      tmp_1 = toDuration(0.25, DurationUnit_SECONDS_getInstance());
    } else {
      tmp_1 = bufferTime;
    }
    bufferTime = tmp_1;
    volume = volume === VOID ? 1.0 : volume;
    pitch = pitch === VOID ? 1.0 : pitch;
    panning = panning === VOID ? 0.0 : panning;
    position = position === VOID ? Companion_getInstance_2().t2k_1 : position;
    onCancel = onCancel === VOID ? null : onCancel;
    onFinish = onFinish === VOID ? null : onFinish;
    this.r66_1 = times;
    this.s66_1 = startTime;
    this.t66_1 = bufferTime;
    this.u66_1 = volume;
    this.v66_1 = pitch;
    this.w66_1 = panning;
    this.x66_1 = position;
    this.y66_1 = onCancel;
    this.z66_1 = onFinish;
  }
  m5s() {
    return this.u66_1;
  }
  t5s() {
    return this.v66_1;
  }
  o5s() {
    return this.w66_1;
  }
  e1r() {
    return this.x66_1;
  }
  toString() {
    return 'PlaybackParameters(times=' + PlaybackTimes__toString_impl_l4chjq(this.r66_1) + ', startTime=' + Duration__toString_impl_8d916b(this.s66_1) + ', bufferTime=' + Duration__toString_impl_8d916b(this.t66_1) + ', volume=' + this.u66_1 + ', pitch=' + this.v66_1 + ', panning=' + this.w66_1 + ', position=' + this.x66_1.toString() + ', onCancel=' + toString_0(this.y66_1) + ', onFinish=' + toString_0(this.z66_1) + ')';
  }
  hashCode() {
    var result = PlaybackTimes__hashCode_impl_mtf95(this.r66_1);
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.s66_1) | 0;
    result = imul(result, 31) + Duration__hashCode_impl_u4exz6(this.t66_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u66_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v66_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w66_1) | 0;
    result = imul(result, 31) + this.x66_1.hashCode() | 0;
    result = imul(result, 31) + (this.y66_1 == null ? 0 : hashCode(this.y66_1)) | 0;
    result = imul(result, 31) + (this.z66_1 == null ? 0 : hashCode(this.z66_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlaybackParameters))
      return false;
    var tmp0_other_with_cast = other instanceof PlaybackParameters ? other : THROW_CCE();
    if (!(this.r66_1 === tmp0_other_with_cast.r66_1))
      return false;
    if (!equals(this.s66_1, tmp0_other_with_cast.s66_1))
      return false;
    if (!equals(this.t66_1, tmp0_other_with_cast.t66_1))
      return false;
    if (!equals(this.u66_1, tmp0_other_with_cast.u66_1))
      return false;
    if (!equals(this.v66_1, tmp0_other_with_cast.v66_1))
      return false;
    if (!equals(this.w66_1, tmp0_other_with_cast.w66_1))
      return false;
    if (!this.x66_1.equals(tmp0_other_with_cast.x66_1))
      return false;
    if (!equals(this.y66_1, tmp0_other_with_cast.y66_1))
      return false;
    if (!equals(this.z66_1, tmp0_other_with_cast.z66_1))
      return false;
    return true;
  }
}
class SoundPlay {}
function play$default(coroutineContext, params, $super) {
  params = params === VOID ? Companion_getInstance_15().q66_1 : params;
  return $super === VOID ? this.k67(coroutineContext, params) : $super.k67.call(this, coroutineContext, params);
}
class Sound {
  constructor(creationCoroutineContext) {
    this.a67_1 = new Mixin();
    this.b67_1 = creationCoroutineContext;
    this.c67_1 = this.b67_1;
    this.d67_1 = 'UnknownNativeSound';
    this.e67_1 = 1.0;
    this.f67_1 = 0.0;
    this.g67_1 = 1.0;
    this.h67_1 = Companion_getInstance_2().t2k_1;
    var tmp = this;
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    tmp.i67_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
  }
  cz(_set____db54di) {
    this.a67_1.cz(_set____db54di);
  }
  dz() {
    return this.a67_1.dz();
  }
  l3() {
    return this.d67_1;
  }
  l5s(_set____db54di) {
    this.e67_1 = _set____db54di;
  }
  m5s() {
    return this.e67_1;
  }
  n5s(_set____db54di) {
    this.f67_1 = _set____db54di;
  }
  o5s() {
    return this.f67_1;
  }
  s5s(_set____db54di) {
    this.g67_1 = _set____db54di;
  }
  t5s() {
    return this.g67_1;
  }
  e1r() {
    return this.h67_1;
  }
  j67() {
    return this.i67_1;
  }
  k67(coroutineContext, params) {
    throw NotImplementedError.ud();
  }
  toString() {
    return "NativeSound('" + this.l3() + "')";
  }
}
class SoundChannel {
  constructor(sound, $box) {
    boxApply(this, $box);
    this.m67_1 = new Mixin();
    this.n67_1 = sound;
    this.o67_1 = Companion_getInstance_0().p1w();
    this.p67_1 = 1.0;
    this.q67_1 = 1.0;
    this.r67_1 = 0.0;
    this.s67_1 = Companion_getInstance_2().t2k_1;
  }
  cz(_set____db54di) {
    this.m67_1.cz(_set____db54di);
  }
  dz() {
    return this.m67_1.dz();
  }
  l5s(_set____db54di) {
    this.p67_1 = _set____db54di;
  }
  m5s() {
    return this.p67_1;
  }
  s5s(_set____db54di) {
    this.q67_1 = _set____db54di;
  }
  t5s() {
    return this.q67_1;
  }
  n5s(_set____db54di) {
    this.r67_1 = _set____db54di;
  }
  o5s() {
    return this.r67_1;
  }
  e1r() {
    return this.s67_1;
  }
}
class SoundAudioData$play$4 extends SoundChannel {
  constructor($nas, this$0, $pos, $box) {
    if ($box === VOID)
      $box = {};
    $box.p68_1 = $nas;
    $box.q68_1 = this$0;
    $box.r68_1 = $pos;
    super(this$0, $box);
    var tmp = this;
    var tmp_0;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_0 = $nas._v;
    }
    tmp.m68_1 = volume$factory(tmp_0);
    var tmp_1 = this;
    var tmp_2;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_2 = $nas._v;
    }
    tmp_1.n68_1 = pitch$factory(tmp_2);
    var tmp_3 = this;
    var tmp_4;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_4 = $nas._v;
    }
    tmp_3.o68_1 = panning$factory(tmp_4);
  }
  l5s(_set____db54di) {
    var this_0 = this.m68_1;
    volume$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  m5s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m68_1;
    volume$factory_1();
    return this_0.get();
  }
  s5s(_set____db54di) {
    var this_0 = this.n68_1;
    pitch$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  t5s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.n68_1;
    pitch$factory_1();
    return this_0.get();
  }
  n5s(_set____db54di) {
    var this_0 = this.o68_1;
    panning$factory_0();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  o5s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o68_1;
    panning$factory_1();
    return this_0.get();
  }
  r5s() {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (this.p68_1._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp = this.p68_1._v;
    }
    tmp.r5s();
    return Unit_instance;
  }
}
class SoundAudioData extends Sound {
  constructor(coroutineContext, audioData, soundProvider, name) {
    var tmp;
    if (name === VOID) {
      var tmp0_elvis_lhs = audioData.f5r_1;
      tmp = tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
    } else {
      tmp = name;
    }
    name = tmp;
    super(coroutineContext);
    this.c68_1 = audioData;
    this.d68_1 = soundProvider;
    this.e68_1 = name;
  }
  l3() {
    return this.e68_1;
  }
  k67(coroutineContext, params) {
    var pos = {_v: 0};
    var times = {_v: new PlaybackTimes(params.r66_1)};
    var nas = {_v: null};
    var tmp = this.d68_1;
    var tmp_0 = this.c68_1.g5r();
    nas._v = tmp.j5t(tmp_0, this.c68_1.d5r_1, SoundAudioData$play$lambda(times, pos, this, nas));
    var tmp_1;
    if (nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_1 = nas._v;
    }
    copySoundPropsFromCombined(tmp_1, params, this);
    var tmp_2;
    if (nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp_2 = nas._v;
    }
    tmp_2.q5s();
    var tmp_3 = SoundAudioData$play$lambda_0(nas);
    onCancel(coroutineContext, tmp_3, SoundAudioData$play$lambda_1(nas));
    return new SoundAudioData$play$4(nas, this, pos);
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    tmp.t69_1 = ConcurrentPool.p2t(VOID, VOID, SoundAudioStream$Companion$ID_POOL$lambda);
  }
}
class SoundAudioStream$play$slambda {
  constructor(this$0, $newStream, $params, $playing, $times, $nas, $currentPositionRequest, $dequeLock, $deque, $BUFFER_SAMPLES, $flushing, $channelId) {
    this.h69_1 = this$0;
    this.i69_1 = $newStream;
    this.j69_1 = $params;
    this.k69_1 = $playing;
    this.l69_1 = $times;
    this.m69_1 = $nas;
    this.n69_1 = $currentPositionRequest;
    this.o69_1 = $dequeLock;
    this.p69_1 = $deque;
    this.q69_1 = $BUFFER_SAMPLES;
    this.r69_1 = $flushing;
    this.s69_1 = $channelId;
  }
  h1p($this$launch, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$launch), $completion);
  }
  wd(p1, $completion) {
    return this.h1p((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  }
}
class SoundAudioStream$play$1 extends SoundChannel {
  constructor($nas, this$0, $currentPositionRequest, $newStream, $playing, $job, $box) {
    if ($box === VOID)
      $box = {};
    $box.e6a_1 = $nas;
    $box.f6a_1 = this$0;
    $box.g6a_1 = $currentPositionRequest;
    $box.h6a_1 = $newStream;
    $box.i6a_1 = $playing;
    $box.j6a_1 = $job;
    super(this$0.g69_1, $box);
    this.b6a_1 = volume$factory_2($nas);
    this.c6a_1 = pitch$factory_2($nas);
    this.d6a_1 = panning$factory_2($nas);
  }
  l5s(_set____db54di) {
    var this_0 = this.b6a_1;
    volume$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  m5s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b6a_1;
    volume$factory_4();
    return this_0.get();
  }
  s5s(_set____db54di) {
    var this_0 = this.c6a_1;
    pitch$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  t5s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c6a_1;
    pitch$factory_4();
    return this_0.get();
  }
  n5s(_set____db54di) {
    var this_0 = this.d6a_1;
    panning$factory_3();
    this_0.set(_set____db54di);
    return Unit_instance;
  }
  o5s() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d6a_1;
    panning$factory_4();
    return this_0.get();
  }
  r5s() {
    return play$close(this.j6a_1);
  }
}
class SoundAudioStream extends Sound {
  constructor(coroutineContext, stream, soundProvider, closeStream, name, onComplete) {
    Companion_getInstance_16();
    closeStream = closeStream === VOID ? false : closeStream;
    var tmp;
    if (name === VOID) {
      var tmp0_elvis_lhs = stream.y60_1;
      tmp = tmp0_elvis_lhs == null ? 'Unknown' : tmp0_elvis_lhs;
    } else {
      tmp = name;
    }
    name = tmp;
    onComplete = onComplete === VOID ? null : onComplete;
    super(coroutineContext);
    this.b69_1 = stream;
    this.c69_1 = soundProvider;
    this.d69_1 = closeStream;
    this.e69_1 = name;
    this.f69_1 = onComplete;
    this.g69_1 = this;
  }
  l3() {
    return this.e69_1;
  }
  j67() {
    return this.b69_1.p61();
  }
  k6a() {
    return this.b69_1.x60_1;
  }
  k67(coroutineContext, params) {
    var dequeLock = new Lock();
    var deque = new AudioSamplesDeque(this.k6a());
    var playing = {_v: true};
    var flushing = {_v: false};
    var newStream = {_v: null};
    var channelId = Companion_getInstance_16().t69_1.f2t();
    var dispatcherName = 'SoundChannel-SoundAudioStream-' + channelId;
    var times = {_v: new PlaybackTimes(params.r66_1)};
    var BUFFER_SAMPLES = nextMultipleOf(numberToInt(this.b69_1.w60_1 * get_seconds(params.t66_1)), Companion_instance.o5r_1);
    var tmp = this.c69_1;
    var tmp_0 = this.k6a();
    var nas = tmp.j5t(tmp_0, this.b69_1.w60_1, SoundAudioStream$play$lambda(dequeLock, flushing, deque, BUFFER_SAMPLES));
    copySoundPropsFromCombined(nas, params, this);
    var currentPositionRequest = {_v: null};
    var tmp_1 = CoroutineScope_0(coroutineContext);
    var job = launch(tmp_1, coroutineContext, VOID, SoundAudioStream$play$slambda_0(this, newStream, params, playing, times, nas, currentPositionRequest, dequeLock, deque, BUFFER_SAMPLES, flushing, channelId));
    return new SoundAudioStream$play$1(nas, this, currentPositionRequest, newStream, playing, job);
  }
}
//endregion
function get_defaultAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  // Inline function 'kotlin.getValue' call
  var this_0 = defaultAudioFormats$delegate;
  defaultAudioFormats$factory();
  return this_0.n1();
}
var defaultAudioFormats$delegate;
var Companion_instance_0;
function Companion_getInstance_3() {
  return Companion_instance_0;
}
function invalidate($this) {
  $this.c5u_1 = null;
  return $this;
}
function *_generator_tryReadInfo__rowfdh($this, data, props, $completion) {
  var _iterator__ex2g4s = $this.b5u_1.a1();
  $l$loop: while (_iterator__ex2g4s.b1()) {
    var format = _iterator__ex2g4s.c1();
    try {
      var tmp = format.f5u(data.b1v(), props, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var tmp0_elvis_lhs = tmp;
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      return tmp_0;
    } catch ($p) {
      if ($p instanceof CancellationException) {
        var e = $p;
        throw e;
      } else {
        if ($p instanceof Error) {
          var e_0 = $p;
          printStackTrace(e_0);
        } else {
          throw $p;
        }
      }
    }
  }
  return null;
}
function *_generator_decodeStreamInternal__hls877($this, data, props, $completion) {
  var _iterator__ex2g4s = $this.b5u_1.a1();
  $l$loop_0: while (_iterator__ex2g4s.b1()) {
    var format = _iterator__ex2g4s.c1();
    try {
      var tmp = format.f5u(data.b1v(), Companion_getInstance_4().h5u_1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      if (tmp == null)
        continue $l$loop_0;
      var tmp_0 = format.i5u(data.b1v(), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var tmp0_elvis_lhs = tmp_0;
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      return tmp_1;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  return null;
}
function standardAudioFormats() {
  _init_properties_AudioFormat_kt__9os7np();
  return Companion_instance_0.z5t([Companion_getInstance_11(), Companion_getInstance_8()]);
}
function *_generator_decodeStream__ydjika($this, data, props, $completion) {
  var tmp;
  if (!(props.w5u_1 == null)) {
    var tmp_0 = withContext(props.w5u_1, AudioFormat$decodeStream$slambda_0($this, data, props), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } else {
    var tmp_1 = $this.k5u(data, props, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp = tmp_1;
  }
  return tmp;
}
function *_generator_decodeStreamOrError__s0emn1($this, data, props, $completion) {
  var tmp = $this.i5u(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    var tmp_1 = $this.toString();
    var tmp_2 = readBytesUpTo(data.b1v(), 8, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var message = "Can't decode audio stream [" + tmp_1 + '] ' + toHexString(tmp_2);
    throw IllegalStateException.a5(toString(message));
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function AudioFormat$decodeStream$slambda_0(this$0, $data, $props) {
  var i = new AudioFormat$decodeStream$slambda(this$0, $data, $props);
  var l = function ($this$withContext, $completion) {
    return i.h1p($this$withContext, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_1;
function Companion_getInstance_4() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
function invalidAudioFormat(message) {
  message = message === VOID ? 'invalid audio format' : message;
  _init_properties_AudioFormat_kt__9os7np();
  throw InvalidAudioFormatException.d5v(message);
}
function defaultAudioFormats$delegate$lambda() {
  _init_properties_AudioFormat_kt__9os7np();
  return standardAudioFormats();
}
function defaultAudioFormats$factory() {
  return getPropertyCallableRef('defaultAudioFormats', 0, KProperty0, function () {
    return get_defaultAudioFormats();
  }, null);
}
var properties_initialized_AudioFormat_kt_2wpbb7;
function _init_properties_AudioFormat_kt__9os7np() {
  if (!properties_initialized_AudioFormat_kt_2wpbb7) {
    properties_initialized_AudioFormat_kt_2wpbb7 = true;
    defaultAudioFormats$delegate = lazy(defaultAudioFormats$delegate$lambda);
  }
}
var Companion_instance_2;
function Companion_getInstance_5() {
  if (Companion_instance_2 === VOID)
    new Companion_1();
  return Companion_instance_2;
}
var ChannelMode_STEREO_instance;
var ChannelMode_JOINT_STEREO_instance;
var ChannelMode_DUAL_CHANNEL_instance;
var ChannelMode_SINGLE_CHANNEL_instance;
var Companion_instance_3;
function Companion_getInstance_6() {
  ChannelMode_initEntries();
  if (Companion_instance_3 === VOID)
    new Companion_2();
  return Companion_instance_3;
}
function values() {
  return [ChannelMode_STEREO_getInstance(), ChannelMode_JOINT_STEREO_getInstance(), ChannelMode_DUAL_CHANNEL_getInstance(), ChannelMode_SINGLE_CHANNEL_getInstance()];
}
var ChannelMode_entriesInitialized;
function ChannelMode_initEntries() {
  if (ChannelMode_entriesInitialized)
    return Unit_instance;
  ChannelMode_entriesInitialized = true;
  ChannelMode_STEREO_instance = new ChannelMode('STEREO', 0, 0, 2);
  ChannelMode_JOINT_STEREO_instance = new ChannelMode('JOINT_STEREO', 1, 1, 1);
  ChannelMode_DUAL_CHANNEL_instance = new ChannelMode('DUAL_CHANNEL', 2, 2, 2);
  ChannelMode_SINGLE_CHANNEL_instance = new ChannelMode('SINGLE_CHANNEL', 3, 3, 1);
  Companion_getInstance_6();
}
function framesize($this, layer, bitrate, sample_rate, padding_bit) {
  if (sample_rate === 0) {
    // Inline function 'kotlin.error' call
    var message = 'division by 0';
    throw IllegalStateException.a5(toString(message));
  }
  var tmp;
  if (layer === 1) {
    tmp = imul((imul(imul(12, bitrate), 1000) / sample_rate | 0) + padding_bit | 0, 4);
  } else {
    tmp = (imul(imul(144, bitrate), 1000) / sample_rate | 0) + padding_bit | 0;
  }
  return tmp;
}
function ChannelMode_STEREO_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_STEREO_instance;
}
function ChannelMode_JOINT_STEREO_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_JOINT_STEREO_instance;
}
function ChannelMode_DUAL_CHANNEL_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_DUAL_CHANNEL_instance;
}
function ChannelMode_SINGLE_CHANNEL_getInstance() {
  ChannelMode_initEntries();
  return ChannelMode_SINGLE_CHANNEL_instance;
}
function *_generator_getSeekingTable__ywx4sa($this, $completion) {
  var times = DoubleArrayList.n2o();
  var filePositions = DoubleArrayList.n2o();
  var tmp = _getDuration($this, false, MP3Base$Parser$getSeekingTable$lambda(times, filePositions), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  tmp.nj_1;
  return new SeekingTable(times, filePositions);
}
function *_generator__getDuration__467r4t($this, use_cbr_estimate, emit, $completion) {
  $this.r5v_1.d1u_1 = new Long(0, 0);
  var fd = $this.r5v_1.b1v();
  var tmp = fd.i1t($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var len = tmp;
  var durationMicroseconds = 0.0;
  var tmp_0 = readStream(fd, 100, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = skipID3v2Tag($this, tmp_0, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var offset = tmp_1;
  var pos = offset;
  var info = null;
  var nframes = 0;
  var block2 = _UByteArrayInt___init__impl__xif7bu(new Int8Array(10));
  var fdbase = fd.c1u_1;
  var fdsync = toSyncOrNull(fdbase);
  var nreads = 0;
  var nskips = 0;
  var nasync = 0;
  try {
    $l$loop: while (pos.s1(len) < 0) {
      var tmp_2;
      if (!(fdsync == null)) {
        tmp_2 = fdsync.s1s(pos, _UByteArrayInt___get_bytes__impl__pj0ilc(block2), 0, 10);
      } else {
        nasync = nasync + 1 | 0;
        fd.d1u_1 = pos;
        var tmp_3 = readBytesUpTo_0(fd, _UByteArrayInt___get_bytes__impl__pj0ilc(block2), 0, 10, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        tmp_2 = tmp_3;
      }
      var block2Size = tmp_2;
      nreads = nreads + 1 | 0;
      if (block2Size < 10)
        break $l$loop;
      // Inline function 'kotlin.Long.plus' call
      pos = pos.r3(toLong(block2Size));
      if (UByteArrayInt__get_impl_px6q8a(block2, 0) === 255 && !((UByteArrayInt__get_impl_px6q8a(block2, 1) & 224) === 0)) {
        info = Companion_getInstance_7().z5v(block2);
        if (emit == null)
          null;
        else
          emit(pos, durationMicroseconds, info);
        nframes = nframes + 1 | 0;
        $this.t5v_1 = info;
        if (info.p5v_1 === 0) {
          // Inline function 'korlibs.time.microseconds' call
          var this_0 = durationMicroseconds;
          var tmp$ret$1 = toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
          return new Duration(tmp$ret$1);
        }
        // Inline function 'kotlin.Long.plus' call
        var this_1 = pos;
        var other = info.p5v_1 - 10 | 0;
        pos = this_1.r3(toLong(other));
        var tmp_4 = durationMicroseconds;
        // Inline function 'kotlin.Long.div' call
        var this_2 = numberToLong(info.q5v_1).s3(new Long(1000000, 0));
        var other_0 = info.n5v_1;
        durationMicroseconds = tmp_4 + this_2.t3(toLong(other_0)).g4();
      } else if (readString(openSync(_UByteArrayInt___get_bytes__impl__pj0ilc(block2)), 3) === 'TAG') {
        // Inline function 'kotlin.Long.plus' call
        pos = pos.r3(toLong(118));
      } else {
        // Inline function 'kotlin.Long.minus' call
        pos = pos.t1(toLong(9));
        nskips = nskips + 1 | 0;
      }
      if (!(info == null) && use_cbr_estimate) {
        // Inline function 'korlibs.time.microseconds' call
        var tmp_5 = estimateDuration($this, info.m5v_1, info.o5v_1.i5v_1, offset.e2(), $completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        var this_3 = tmp_5;
        var tmp$ret$6 = toDuration_0(this_3, DurationUnit_MICROSECONDS_getInstance());
        return new Duration(tmp$ret$6);
      }
    }
  }finally {
  }
  // Inline function 'korlibs.time.microseconds' call
  var this_4 = durationMicroseconds;
  var tmp$ret$7 = toDuration(this_4, DurationUnit_MICROSECONDS_getInstance());
  return new Duration(tmp$ret$7);
}
function _getDuration($this, use_cbr_estimate, emit, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator__getDuration__467r4t.bind(VOID, $this, use_cbr_estimate, emit), $completion);
}
function _getDuration$default($this, use_cbr_estimate, emit, $completion, $super) {
  emit = emit === VOID ? null : emit;
  return _getDuration($this, use_cbr_estimate, emit, $completion);
}
function estimateDuration($this, bitrate, channels, offset, $completion) {
  var kbps = imul(bitrate, 1000) / 8 | 0;
  // Inline function 'kotlin.Long.minus' call
  var dataSize = $this.s5v_1.t1(toLong(offset));
  // Inline function 'kotlin.Long.div' call
  // Inline function 'kotlin.Long.times' call
  var other = 2 / channels | 0;
  return dataSize.s3(toLong(other)).s3(new Long(1000000, 0)).t3(toLong(kbps));
}
function *_generator_skipID3v2Tag__vewobn($this, block, $completion) {
  var b = block.b1v();
  var tmp = readString_0(b, 3, Charsets_instance.ax(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp === 'ID3') {
    var tmp_0 = readBytesExact(b, 7, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var bb = tmp_0;
    var id3v2_major_version = getU8(bb, 0);
    var id3v2_minor_version = getU8(bb, 1);
    var id3v2_flags = getU8(bb, 2);
    var z0 = getU8(bb, 3);
    var z1 = getU8(bb, 4);
    var z2 = getU8(bb, 5);
    var z3 = getU8(bb, 6);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_unsynchronisation = !(((id3v2_flags >>> 7 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_extended_header = !(((id3v2_flags >>> 6 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_experimental_ind = !(((id3v2_flags >>> 5 | 0) & 1) === 0);
    // Inline function 'korlibs.memory.extract' call
    // Inline function 'korlibs.memory.extract1' call
    var flag_footer_present = !(((id3v2_flags >>> 4 | 0) & 1) === 0);
    if ((z0 & 128) === 0 && (z1 & 128) === 0 && (z2 & 128) === 0 && (z3 & 128) === 0) {
      var header_size = 10;
      var tag_size = ((imul(z0 & 127, 2097152) + imul(z1 & 127, 16384) | 0) + imul(z2 & 127, 128) | 0) + (z3 & 127) | 0;
      var footer_size = flag_footer_present ? 10 : 0;
      return toLong((header_size + tag_size | 0) + footer_size | 0);
    }
  }
  return new Long(0, 0);
}
function skipID3v2Tag($this, block, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_skipID3v2Tag__vewobn.bind(VOID, $this, block), $completion);
}
var Companion_instance_4;
function Companion_getInstance_7() {
  if (Companion_instance_4 === VOID)
    new Companion_3();
  return Companion_instance_4;
}
function MP3Base$Parser$getSeekingTable$lambda($times, $filePositions) {
  return function (filePos, totalMicro, info) {
    $times.u10(totalMicro);
    $filePositions.u10(filePos.g4());
    return Unit_instance;
  };
}
function *_generator_tryReadInfo__rowfdh_0($this, data, props, $completion) {
  try {
    var tmp = readBytesExact(data, 4, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var header = tmp;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = header.slice();
    var tmp$ret$2 = _UByteArray___init__impl__ip4y9n(tmp$ret$1);
    var this_0 = UByteArray__get_impl_t5f3hv(tmp$ret$2, 0);
    var h0 = _UByte___get_data__impl__jof9qr(this_0) & 255;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = header.slice();
    var tmp$ret$6 = _UByteArray___init__impl__ip4y9n(tmp$ret$5);
    var this_1 = UByteArray__get_impl_t5f3hv(tmp$ret$6, 1);
    var h1 = _UByte___get_data__impl__jof9qr(this_1) & 255;
    // Inline function 'kotlin.UByte.toInt' call
    // Inline function 'kotlin.collections.toUByteArray' call
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$9 = header.slice();
    var tmp$ret$10 = _UByteArray___init__impl__ip4y9n(tmp$ret$9);
    var this_2 = UByteArray__get_impl_t5f3hv(tmp$ret$10, 2);
    var h2 = _UByte___get_data__impl__jof9qr(this_2) & 255;
    var isId3 = readStringz(header, 0, 3) === 'ID3';
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (h0 === 255 && ((h1 & 240) === 240 || (h1 & 254) === 226)) {
      // Inline function 'korlibs.memory.extract2' call
      tmp_2 = !(((h1 >>> 1 | 0) & 3) === 0);
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      // Inline function 'korlibs.memory.extract4' call
      tmp_1 = !(((h2 >>> 4 | 0) & 15) === 15);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'korlibs.memory.extract2' call
      tmp_0 = !(((h2 >>> 2 | 0) & 3) === 3);
    } else {
      tmp_0 = false;
    }
    var isSync = tmp_0;
    if (!isId3 && !isSync)
      return null;
    var tmp_3 = data.i1t($completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var parser = new Parser(data, tmp_3);
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.hj();
    // Inline function 'korlibs.audio.format.MP3Base.tryReadInfo.<anonymous>' call
    var tmp_4;
    switch (props.s5u_1) {
      case null:
        var tmp_5 = parser.b5w($completion);
        if (tmp_5 === get_COROUTINE_SUSPENDED())
          tmp_5 = yield tmp_5;
        tmp_4 = tmp_5.nj_1;
        break;
      case true:
        var tmp_6 = parser.b5w($completion);
        if (tmp_6 === get_COROUTINE_SUSPENDED())
          tmp_6 = yield tmp_6;
        tmp_4 = tmp_6.nj_1;
        break;
      default:
        var tmp_7 = parser.c5w($completion);
        if (tmp_7 === get_COROUTINE_SUSPENDED())
          tmp_7 = yield tmp_7;
        tmp_4 = tmp_7.nj_1;
        break;
    }
    var result = new Duration(tmp_4);
    var _destruct__k2r9zo = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    var duration = _destruct__k2r9zo.il().nj_1;
    var decodingTime = _destruct__k2r9zo.ir();
    var tmp3_safe_receiver = parser.t5v_1;
    var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.o5v_1;
    var tmp0_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.i5v_1;
    return new Info(duration, tmp0_elvis_lhs == null ? 2 : tmp0_elvis_lhs, decodingTime);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      return null;
    } else {
      throw $p;
    }
  }
}
var Companion_instance_5;
function Companion_getInstance_8() {
  if (Companion_instance_5 === VOID)
    new Companion_4();
  return Companion_instance_5;
}
var Minimp3AudioFormat_instance;
function Minimp3AudioFormat_getInstance() {
  if (Minimp3AudioFormat_instance === VOID)
    new Minimp3AudioFormat();
  return Minimp3AudioFormat_instance;
}
function *_generator_seek__qhx6y8($this, position, $completion) {
  $this.m60_1 = false;
  // Inline function 'korlibs.time.seconds' call
  var tmp$ret$0 = toDuration(0.0, DurationUnit_SECONDS_getInstance());
  if (equals(position, tmp$ret$0)) {
    $this.r60_1.d1u_1 = new Long(0, 0);
    $this.o60_1 = new Long(0, 0);
  } else {
    if ($this.q60_1._v == null) {
      var tmp0_elvis_lhs = $this.s60_1;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        var tmp_0;
        var tmp_1 = $this.r60_1.j1t($completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        if (tmp_1) {
          var tmp_2 = $this.r60_1.i1t($completion);
          if (tmp_2 === get_COROUTINE_SUSPENDED())
            tmp_2 = yield tmp_2;
          var tmp_3 = (new Parser($this.r60_1, tmp_2)).i5w($completion);
          if (tmp_3 === get_COROUTINE_SUSPENDED())
            tmp_3 = yield tmp_3;
          tmp_0 = tmp_3;
        } else {
          tmp_0 = null;
        }
        tmp = tmp_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      $this.q60_1._v = tmp;
    }
    if (!($this.q60_1._v == null)) {
      var offset = ensureNotNull($this.q60_1._v).h5w(position);
      $this.r60_1.d1u_1 = offset;
      $this.o60_1 = $this.c61(position);
    } else {
      println("Couldn't create mp3SeekingTable");
    }
  }
  $this.p60_1.m5x().v2t();
  return Unit_instance;
}
function *_generator_read__qih2oe($this, out, offset, length, $completion) {
  var noMoreSamples = false;
  $l$loop: while (ensureNotNull($this.p60_1.m5x().q5x_1).w14() < length) {
    var tmp = createDecoderStream$readMoreSamples($this.p60_1, $this.r60_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (!tmp) {
      noMoreSamples = true;
      break $l$loop;
    }
  }
  // Inline function 'kotlin.also' call
  var tmp_0;
  if (noMoreSamples && ensureNotNull($this.p60_1.m5x().q5x_1).w14() === 0) {
    $this.m60_1 = true;
    tmp_0 = 0;
  } else {
    tmp_0 = ensureNotNull($this.p60_1.m5x().q5x_1).f61(out, offset, length);
  }
  var this_0 = tmp_0;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.audio.format.<no name provided>.read.<anonymous>' call
  var tmp_1 = $this;
  // Inline function 'kotlin.Long.plus' call
  tmp_1.o60_1 = $this.o60_1.r3(toLong(this_0));
  return this_0;
}
function *_generator_createDecoderStream__oszsb8($this, data, props, table, $completion) {
  var dataStartPosition = data.d1u_1;
  var decoder = $this.f60();
  decoder.m5x().v2t();
  var tmp;
  if (props.s5u_1 === true) {
    var tmp_0;
    if (table == null) {
      var tmp_1;
      var tmp_2 = data.j1t($completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      if (tmp_2) {
        var tmp_3 = data.i1t($completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        var tmp_4 = (new Parser(data, tmp_3)).i5w($completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        tmp_1 = tmp_4;
      } else {
        tmp_1 = null;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = table;
    }
    tmp = tmp_0;
  } else {
    tmp = null;
  }
  var mp3SeekingTable = {_v: tmp};
  var tmp_5 = createDecoderStream$readMoreSamples(decoder, data, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return new BaseMinimp3AudioFormat$createDecoderStream$2(decoder, mp3SeekingTable, data, table, $this, dataStartPosition, props);
}
function createDecoderStream($this, data, props, table, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createDecoderStream__oszsb8.bind(VOID, $this, data, props, table), $completion);
}
var Companion_instance_6;
function Companion_getInstance_9() {
  if (Companion_instance_6 === VOID)
    new Companion_5();
  return Companion_instance_6;
}
function *_generator_createDecoderStream$readMoreSamples__md5fam(decoder, $data, $completion) {
  $l$loop: while (true) {
    var tmp;
    if (decoder.m5x().p5x_1.w14() < decoder.m5x().o5x_1.length) {
      var tmp_0 = $data.z1u($completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    if (tmp) {
      var tmp_1 = decoder.m5x().p5x_1;
      var tmp_2 = readBytesUpTo($data, 4096, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1.n2m(tmp_2);
    }
    var result = decoder.m5x().g61(decoder);
    if (decoder.m5x().r5x_1 === 0 || decoder.m5x().t5x_1 === 0)
      continue $l$loop;
    return result;
  }
}
function createDecoderStream$readMoreSamples(decoder, $data, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createDecoderStream$readMoreSamples__md5fam.bind(VOID, decoder, $data), $completion);
}
function arrayOfUByte($this, values, size) {
  return _UByteArrayInt___init__impl__xif7bu_0(size, MiniMp3Program$Companion$arrayOfUByte$lambda(values));
}
function arrayOfUByte$default($this, values, size, $super) {
  size = size === VOID ? values.length : size;
  return arrayOfUByte($this, values, size);
}
function arrayOfShort($this, values, size) {
  var tmp = 0;
  var tmp_0 = new Int16Array(size);
  while (tmp < size) {
    var tmp_1 = tmp;
    // Inline function 'kotlin.code' call
    // Inline function 'kotlin.text.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_2;
    if (0 <= tmp_1 ? tmp_1 <= (charSequenceLength(values) - 1 | 0) : false) {
      tmp_2 = charSequenceGet(values, tmp_1);
    } else {
      // Inline function 'korlibs.audio.format.Companion.arrayOfShort.<anonymous>' call
      tmp_2 = _Char___init__impl__6a9atx(0);
    }
    var this_0 = tmp_2;
    var tmp$ret$2 = Char__toInt_impl_vasixd(this_0);
    tmp_0[tmp_1] = toShort(tmp$ret$2);
    tmp = tmp + 1 | 0;
  }
  return tmp_0;
}
function arrayOfShort$default($this, values, size, $super) {
  size = size === VOID ? values.length : size;
  return arrayOfShort($this, values, size);
}
function MiniMp3Program$Companion$arrayOfUByte$lambda($values) {
  return function (it) {
    // Inline function 'kotlin.code' call
    // Inline function 'kotlin.text.getOrElse' call
    var this_0 = $values;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= it ? it <= (charSequenceLength(this_0) - 1 | 0) : false) {
      tmp = charSequenceGet(this_0, it);
    } else {
      // Inline function 'korlibs.audio.format.Companion.arrayOfUByte.<anonymous>.<anonymous>' call
      tmp = _Char___init__impl__6a9atx(0);
    }
    var this_1 = tmp;
    return Char__toInt_impl_vasixd(this_1);
  };
}
var Companion_instance_7;
function Companion_getInstance_10() {
  if (Companion_instance_7 === VOID)
    new Companion_6();
  return Companion_instance_7;
}
function toInt_0(_this__u8e3s4, $this) {
  return _this__u8e3s4 ? 1 : 0;
}
function *_generator_read__qih2oe_0($this, out, offset, length, $completion) {
  var tmp = readBytesUpTo($this.d65_1, imul(imul(length, $this.h65_1), $this.x60_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var bytes = tmp;
  var tmp_0 = $this;
  var tmp_1 = $this.d65_1.c1v($completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  tmp_0.i65_1 = tmp_1;
  var availableSamples = (bytes.length / $this.h65_1 | 0) / $this.x60_1 | 0;
  var inductionVariable = 0;
  var last = $this.x60_1;
  if (inductionVariable < last)
    do {
      var channel = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      switch ($this.h65_1) {
        case 1:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_11();
          var channels = $this.x60_1;
          var bytesPerSample = $this.h65_1;
          var increment = imul(channels, bytesPerSample);
          var index = imul(channel, bytesPerSample);
          var outc = out.a5t(channel);
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < availableSamples)
            do {
              var n = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var tmp_2 = offset + n | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it = index;
              var tmp$ret$0 = _AudioSample___init__impl__s54gd5(toShortClamped(imul(getU8(bytes, it) - 128 | 0, 255)));
              AudioSampleArray__set_impl_tqgfwk(outc, tmp_2, tmp$ret$0);
              index = index + increment | 0;
            }
             while (inductionVariable_0 < availableSamples);
          break;
        case 2:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_11();
          var channels_0 = $this.x60_1;
          var bytesPerSample_0 = $this.h65_1;
          var increment_0 = imul(channels_0, bytesPerSample_0);
          var index_0 = imul(channel, bytesPerSample_0);
          var outc_0 = out.a5t(channel);
          var inductionVariable_1 = 0;
          if (inductionVariable_1 < availableSamples)
            do {
              var n_0 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var tmp_3 = offset + n_0 | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it_0 = index_0;
              var tmp$ret$1 = _AudioSample___init__impl__s54gd5(toShort(getS16LE(bytes, it_0)));
              AudioSampleArray__set_impl_tqgfwk(outc_0, tmp_3, tmp$ret$1);
              index_0 = index_0 + increment_0 | 0;
            }
             while (inductionVariable_1 < availableSamples);
          break;
        case 3:
          // Inline function 'korlibs.audio.format.WAV.readBlock' call

          Companion_getInstance_11();
          var channels_1 = $this.x60_1;
          var bytesPerSample_1 = $this.h65_1;
          var increment_1 = imul(channels_1, bytesPerSample_1);
          var index_1 = imul(channel, bytesPerSample_1);
          var outc_1 = out.a5t(channel);
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < availableSamples)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var tmp_4 = offset + n_1 | 0;
              // Inline function 'korlibs.audio.format.WavAudioStream.read.<anonymous>' call
              var it_1 = index_1;
              var tmp$ret$2 = _AudioSample___init__impl__s54gd5(toShort(getS24LE(bytes, it_1) >>> 8 | 0));
              AudioSampleArray__set_impl_tqgfwk(outc_1, tmp_4, tmp$ret$2);
              index_1 = index_1 + increment_1 | 0;
            }
             while (inductionVariable_2 < availableSamples);
          break;
        default:
          invalidOp('Unsupported bytesPerSample=' + $this.h65_1);
          break;
      }
    }
     while (inductionVariable < last);
  return availableSamples;
}
function *_generator_clone__nh2r5j($this, $completion) {
  var tmp = (new WAV()).k5u($this.f65_1.b1v(), $this.g65_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return ensureNotNull(tmp);
}
function *_generator_invoke__zhh2q8($this, $this$riff, $completion) {
  var type = $this$riff.il();
  var d2 = $this$riff.jl();
  var d = d2.b1v();
  var cdata = Unit_instance;
  switch (type) {
    case 'fmt ':
      var tmp = $this.m65_1;
      var tmp_0 = readS16LE(d, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp.p65_1 = tmp_0;
      var tmp_1 = $this.m65_1;
      var tmp_2 = readS16LE(d, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_1.q65_1 = tmp_2;
      var tmp_3 = $this.m65_1;
      var tmp_4 = readS32LE(d, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp_3.r65_1 = tmp_4;
      var tmp_5 = $this.m65_1;
      var tmp_6 = readU32LE(d, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      tmp_5.s65_1 = tmp_6;
      var tmp_7 = $this.m65_1;
      var tmp_8 = readS16LE(d, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      tmp_7.t65_1 = tmp_8;
      var tmp_9 = $this.m65_1;
      var tmp_10 = readS16LE(d, $completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
      tmp_9.u65_1 = tmp_10;
      cdata = $this.m65_1;
      break;
    case 'data':
      var tmp_11 = $this.n65_1._v;
      var tmp_12 = d.i1t($completion);
      if (tmp_12 === get_COROUTINE_SUSPENDED())
        tmp_12 = yield tmp_12;
      $this.n65_1._v = tmp_11.r3(tmp_12);
      cdata = d;
      break;
    default:
      break;
  }
  $this.o65_1(new ProcessedChunk($this$riff.k65_1, $this$riff.l65_1, cdata));
  return Unit_instance;
}
var Companion_instance_8;
function Companion_getInstance_11() {
  if (Companion_instance_8 === VOID)
    new Companion_7();
  return Companion_instance_8;
}
function *_generator_tryReadInfo__rowfdh_1($this, data, props, $completion) {
  var tmp;
  try {
    var tmp_0 = $this.v65(data, WAV$tryReadInfo$lambda, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof CancellationException) {
      var e = $p;
      throw e;
    } else {
      if ($p instanceof Error) {
        var e_0 = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
    }
    tmp = tmp_1;
  }
  return tmp;
}
function *_generator_decodeStreamInternal__hls877_0($this, data, props, $completion) {
  var fmt = {_v: new Fmt()};
  var buffer = {_v: toAsync(MemorySyncStream())};
  var tmp = $this.v65(data, WAV$decodeStreamInternal$lambda(fmt, buffer), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = fmt._v;
  var tmp_1 = buffer._v;
  var tmp_2 = buffer._v.i1t($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return new WavAudioStream(tmp_0, tmp_1, tmp_2, data, props);
}
function *_generator_parse__tgo4f5($this, data, handle, $completion) {
  var fmt = new Fmt();
  var dataSize = {_v: new Long(0, 0)};
  var tmp = $this.w65(data, WAV$parse$slambda_0(fmt, dataSize, handle), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (fmt.p65_1 < 0) {
    invalidOp("Couldn't find RIFF 'fmt ' chunk");
  }
  // Inline function 'korlibs.time.microseconds' call
  // Inline function 'kotlin.Long.times' call
  // Inline function 'kotlin.Long.times' call
  var this_0 = dataSize._v.s3(toLong(1000)).s3(toLong(1000)).t3(fmt.s65_1);
  var tmp$ret$2 = toDuration_0(this_0, DurationUnit_MICROSECONDS_getInstance());
  return new Info(tmp$ret$2, fmt.q65_1);
}
function *_generator_riff__qieez3($this, data, handler, $completion) {
  var s2 = data.b1v();
  var tmp = s2.a1v($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (tmp.s1(new Long(12, 0)) < 0) {
    // Inline function 'kotlin.error' call
    var message = 'Not enough data for a RIFF file';
    throw IllegalStateException.a5(toString(message));
  }
  var tmp_0 = readString_0(s2, 4, VOID, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var magic = tmp_0;
  var tmp_1 = readS32LE(s2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var length = tmp_1;
  var tmp_2 = readString_0(s2, 4, VOID, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var magic2 = tmp_2;
  if (!(magic === 'RIFF')) {
    invalidAudioFormat("Not a RIFF file but '" + magic + "'");
  }
  if (!(magic2 === 'WAVE')) {
    invalidAudioFormat('Not a RIFF + WAVE file');
  }
  var tmp_3 = readStream(s2, length - 4 | 0, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var s = tmp_3;
  $l$loop_1: while (true) {
    var tmp_4 = s.c1v($completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    if (!!tmp_4) {
      break $l$loop_1;
    }
    var tmp_5 = s.a1v($completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    if (tmp_5.s1(new Long(8, 0)) < 0)
      break $l$loop_1;
    var tmp_6 = readString_0(s, 4, VOID, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var type = tmp_6;
    var tmp_7 = readS32LE(s, $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    var size = tmp_7;
    var tmp_8 = s.a1v($completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    if (tmp_8.s1(toLong(size)) < 0)
      break $l$loop_1;
    var tmp_9 = readStream(s, size, $completion);
    if (tmp_9 === get_COROUTINE_SUSPENDED())
      tmp_9 = yield tmp_9;
    var d = tmp_9;
    var tmp_10 = handler(new Chunk(type, d), $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
  }
  return Unit_instance;
}
function WAV$tryReadInfo$lambda(it) {
  return Unit_instance;
}
function WAV$decodeStreamInternal$lambda($fmt, $buffer) {
  return function (it) {
    var extra = it.z65_1;
    var tmp;
    if (extra instanceof Fmt) {
      $fmt._v = extra;
      tmp = Unit_instance;
    }
    var tmp_0;
    if (it.x65_1 === 'data') {
      $buffer._v = it.y65_1;
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function WAV$parse$slambda_0($fmt, $dataSize, $handle) {
  var i = new WAV$parse$slambda($fmt, $dataSize, $handle);
  var l = function ($this$riff, $completion) {
    return i.b66($this$riff, $completion);
  };
  l.$arity = 1;
  return l;
}
var Companion_instance_9;
function Companion_getInstance_12() {
  return Companion_instance_9;
}
var DEFAULT_MAX_SAMPLES;
var Companion_instance_10;
function Companion_getInstance_13() {
  return Companion_instance_10;
}
function *_generator_toData__gg6t99(_this__u8e3s4, maxSamples, $completion) {
  maxSamples = maxSamples === VOID ? DEFAULT_MAX_SAMPLES : maxSamples;
  var out = new AudioSamplesDeque(_this__u8e3s4.x60_1);
  // Inline function 'kotlin.math.min' call
  var tmp$ret$0 = Math.min(maxSamples, 65536);
  var buffer = new AudioSamples(_this__u8e3s4.x60_1, tmp$ret$0);
  try {
    $l$loop_0: while (!_this__u8e3s4.k61()) {
      // Inline function 'kotlin.math.min' call
      var a = maxSamples - out.w14() | 0;
      var b = buffer.i5r_1;
      var tmp$ret$1 = Math.min(a, b);
      var tmp = _this__u8e3s4.n61(buffer, 0, tmp$ret$1, $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
      var read = tmp;
      if (read <= 0)
        break $l$loop_0;
      // Inline function 'kotlin.math.min' call
      var b_0 = maxSamples - out.w14() | 0;
      var mread = Math.min(read, b_0);
      out.f66(buffer, 0, mread);
      if (out.w14() >= maxSamples)
        break $l$loop_0;
    }
  }finally {
    _this__u8e3s4.g6();
  }
  var maxOutSamples = out.c66();
  // Inline function 'kotlin.apply' call
  var this_0 = new AudioSamples(_this__u8e3s4.x60_1, maxOutSamples);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.audio.sound.toData.<anonymous>' call
  out.i66(this_0);
  return new AudioData(_this__u8e3s4.w60_1, this_0);
}
function toData(_this__u8e3s4, maxSamples, $completion) {
  maxSamples = maxSamples === VOID ? DEFAULT_MAX_SAMPLES : maxSamples;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_toData__gg6t99.bind(VOID, _this__u8e3s4, maxSamples), $completion);
}
function get_audioFormats(_this__u8e3s4) {
  _init_properties_NativeSoundProviderExt_kt__owf0qw();
  // Inline function 'kotlin.getValue' call
  var this_0 = audioFormats$delegate;
  audioFormats$factory();
  return this_0.n1();
}
var audioFormats$delegate;
function *_generator_createSound__kkt3xd(_this__u8e3s4, file, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().g5u_1 : props;
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = createSound_0(_this__u8e3s4, tmp, streaming, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function createSound(_this__u8e3s4, file, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().g5u_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd.bind(VOID, _this__u8e3s4, file, streaming, props), $completion);
}
function createSound_0(_this__u8e3s4, file, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().g5u_1 : props;
  return createSound_1(_this__u8e3s4, file.a25(), file.g25(), streaming, props, $completion);
}
function *_generator_createSound__kkt3xd_0(_this__u8e3s4, vfs, path, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().g5u_1 : props;
  var tmp;
  if (streaming) {
    var vfsFile = vfs.w26(path);
    var tmp_0;
    if (props.t5u_1) {
      var tmp_1 = vfsFile.k27($completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = openAsync(tmp_1);
    } else {
      var tmp_2 = vfsFile.i27(VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp_2;
    }
    var stream = tmp_0;
    var tmp0_elvis_lhs = props.u5u_1;
    var tmp_3 = (tmp0_elvis_lhs == null ? get_audioFormats(_this__u8e3s4) : tmp0_elvis_lhs).l5u(stream, props, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    var tmp_4 = get_baseName(vfsFile);
    var tmp_5 = createStreamingSound(_this__u8e3s4, tmp_3, VOID, tmp_4, createSound$slambda_0(stream), $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    tmp = tmp_5;
  } else {
    var tmp_6 = vfs.w26(path).g27($completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var tmp_7 = createSound_2(_this__u8e3s4, tmp_6, streaming, props, get_baseName(vfs.ei(path)), $completion);
    if (tmp_7 === get_COROUTINE_SUSPENDED())
      tmp_7 = yield tmp_7;
    tmp = tmp_7;
  }
  return tmp;
}
function createSound_1(_this__u8e3s4, vfs, path, streaming, props, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().g5u_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd_0.bind(VOID, _this__u8e3s4, vfs, path, streaming, props), $completion);
}
function createStreamingSound(_this__u8e3s4, stream, closeStream, name, onComplete, $completion) {
  closeStream = closeStream === VOID ? false : closeStream;
  name = name === VOID ? 'Unknown' : name;
  onComplete = onComplete === VOID ? null : onComplete;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.sc();
  return new SoundAudioStream(tmp$ret$0, stream, _this__u8e3s4, closeStream, name, onComplete);
}
function *_generator_createSound__kkt3xd_1(_this__u8e3s4, data, streaming, props, name, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().g5u_1 : props;
  name = name === VOID ? 'Unknown' : name;
  var tmp0_elvis_lhs = props.u5u_1;
  var format = tmp0_elvis_lhs == null ? get_audioFormats(_this__u8e3s4) : tmp0_elvis_lhs;
  var tmp = format.l5u(openAsync(data), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var stream = tmp;
  var tmp_0;
  if (streaming) {
    var tmp_1 = createStreamingSound(_this__u8e3s4, stream, true, name, VOID, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else {
    var tmp_2 = toData(stream, VOID, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp_3 = createNonStreamingSound(_this__u8e3s4, tmp_2, name, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  }
  return tmp_0;
}
function createSound_2(_this__u8e3s4, data, streaming, props, name, $completion) {
  streaming = streaming === VOID ? false : streaming;
  props = props === VOID ? Companion_getInstance_4().g5u_1 : props;
  name = name === VOID ? 'Unknown' : name;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_createSound__kkt3xd_1.bind(VOID, _this__u8e3s4, data, streaming, props, name), $completion);
}
function createNonStreamingSound(_this__u8e3s4, data, name, $completion) {
  name = name === VOID ? 'Unknown' : name;
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp = $completion.sc();
  var tmp0_elvis_lhs = data.f5r_1;
  return new SoundAudioData(tmp, data, _this__u8e3s4, tmp0_elvis_lhs == null ? name : tmp0_elvis_lhs);
}
function audioFormats$delegate$lambda() {
  _init_properties_NativeSoundProviderExt_kt__owf0qw();
  return get_defaultAudioFormats();
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.l66_1.t1q($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function createSound$slambda_0($stream) {
  var i = new createSound$slambda($stream);
  var l = function ($completion) {
    return i.vd($completion);
  };
  l.$arity = 0;
  return l;
}
function audioFormats$factory() {
  return getPropertyCallableRef('audioFormats', 1, KProperty1, function (receiver) {
    return get_audioFormats(receiver);
  }, null);
}
var properties_initialized_NativeSoundProviderExt_kt_zegpk6;
function _init_properties_NativeSoundProviderExt_kt__owf0qw() {
  if (!properties_initialized_NativeSoundProviderExt_kt_zegpk6) {
    properties_initialized_NativeSoundProviderExt_kt_zegpk6 = true;
    audioFormats$delegate = lazy(audioFormats$delegate$lambda);
  }
}
function _PlaybackTimes___init__impl__rt6rw2(count) {
  return count;
}
function _PlaybackTimes___get_count__impl__ll6dcs($this) {
  return $this;
}
var Companion_instance_11;
function Companion_getInstance_14() {
  if (Companion_instance_11 === VOID)
    new Companion_10();
  return Companion_instance_11;
}
function _PlaybackTimes___get_hasMore__impl__ei8boc($this) {
  return !($this === Companion_getInstance_14().m66_1);
}
function _PlaybackTimes___get_oneLess__impl__ea0jl8($this) {
  return $this === Companion_getInstance_14().o66_1 ? Companion_getInstance_14().o66_1 : _PlaybackTimes___init__impl__rt6rw2(_PlaybackTimes___get_count__impl__ll6dcs($this) - 1 | 0);
}
function PlaybackTimes__toString_impl_l4chjq($this) {
  return _PlaybackTimes___get_count__impl__ll6dcs($this) >= 0 ? '' + _PlaybackTimes___get_count__impl__ll6dcs($this) + ' times' : 'Infinite times';
}
function PlaybackTimes__hashCode_impl_mtf95($this) {
  return $this;
}
function PlaybackTimes__equals_impl_suah7n($this, other) {
  if (!(other instanceof PlaybackTimes))
    return false;
  if (!($this === (other instanceof PlaybackTimes ? other.p66_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_12;
function Companion_getInstance_15() {
  if (Companion_instance_12 === VOID)
    new Companion_11();
  return Companion_instance_12;
}
function readSound(_this__u8e3s4, props, streaming, $completion) {
  props = props === VOID ? Companion_getInstance_4().g5u_1 : props;
  streaming = streaming === VOID ? false : streaming;
  return createSound(get_nativeSoundProvider(), _this__u8e3s4, streaming, props, $completion);
}
function readMusic(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_4().g5u_1 : props;
  return readSound(_this__u8e3s4, props, true, $completion);
}
function copySoundPropsFromCombined(_this__u8e3s4, l, r) {
  _this__u8e3s4.l5s(l.m5s() * r.m5s());
  _this__u8e3s4.s5s(l.t5s() * r.t5s());
  _this__u8e3s4.n5s(r.o5s());
}
function SoundAudioData$play$lambda($times, $pos, this$0, $nas) {
  return function (buffer) {
    var tmp;
    if ($times._v.equals(new PlaybackTimes(Companion_getInstance_14().m66_1))) {
      return Unit_instance;
    }
    var inductionVariable = 0;
    var last = buffer.i5s_1;
    var tmp_0;
    if (inductionVariable < last) {
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var _unary__edvuaz = $pos._v;
        $pos._v = _unary__edvuaz + 1 | 0;
        var audioDataPos = _unary__edvuaz;
        if (audioDataPos >= this$0.c68_1.k5r() || $times._v.equals(new PlaybackTimes(Companion_getInstance_14().m66_1))) {
          $pos._v = 0;
          audioDataPos = 0;
          $times._v = new PlaybackTimes(_PlaybackTimes___get_oneLess__impl__ea0jl8($times._v.p66_1));
          if ($times._v.equals(new PlaybackTimes(Companion_getInstance_14().m66_1))) {
            var tmp_1;
            if ($nas._v == null) {
              throwUninitializedPropertyAccessException('nas');
            } else {
              tmp_1 = $nas._v;
            }
            tmp_1.r5s();
            break $l$loop;
          }
        }
        var inductionVariable_0 = 0;
        var last_0 = buffer.h5s_1;
        if (inductionVariable_0 < last_0)
          do {
            var ch = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var sample = audioDataPos < this$0.c68_1.k5r() ? this$0.c68_1.l5r(ch, audioDataPos) : Companion_getInstance_1().k5s_1;
            buffer.b5t(ch, n, sample);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
      tmp_0 = Unit_instance;
    }
    return Unit_instance;
  };
}
function SoundAudioData$play$lambda_0($nas) {
  return function () {
    var tmp;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp = $nas._v;
    }
    return tmp.b5s_1;
  };
}
function SoundAudioData$play$lambda_1($nas) {
  return function (it) {
    var tmp;
    if ($nas._v == null) {
      throwUninitializedPropertyAccessException('nas');
    } else {
      tmp = $nas._v;
    }
    tmp.r5s();
    return Unit_instance;
  };
}
function volume$factory($b0) {
  return getPropertyCallableRef('volume', 0, KMutableProperty0, function () {
    return $b0.y5r_1;
  }, function (value) {
    $b0.y5r_1 = value;
    return Unit_instance;
  });
}
function pitch$factory($b0) {
  return getPropertyCallableRef('pitch', 0, KMutableProperty0, function () {
    return $b0.t5s();
  }, function (value) {
    return $b0.s5s(value);
  });
}
function panning$factory($b0) {
  return getPropertyCallableRef('panning', 0, KMutableProperty0, function () {
    return $b0.z5r_1;
  }, function (value) {
    $b0.z5r_1 = value;
    return Unit_instance;
  });
}
function volume$factory_0() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.m5s();
  }, function (receiver, value) {
    return receiver.l5s(value);
  });
}
function volume$factory_1() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.m5s();
  }, function (receiver, value) {
    return receiver.l5s(value);
  });
}
function pitch$factory_0() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.t5s();
  }, function (receiver, value) {
    return receiver.s5s(value);
  });
}
function pitch$factory_1() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.t5s();
  }, function (receiver, value) {
    return receiver.s5s(value);
  });
}
function panning$factory_0() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.o5s();
  }, function (receiver, value) {
    return receiver.n5s(value);
  });
}
function panning$factory_1() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.o5s();
  }, function (receiver, value) {
    return receiver.n5s(value);
  });
}
function SoundAudioStream$Companion$ID_POOL$lambda(it) {
  return it;
}
function *_generator_invoke__zhh2q8_1($this, $this$launch, $completion) {
  var tmp = $this.h69_1.b69_1.o61($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var stream = tmp;
  $this.i69_1._v = stream;
  var tmp_0 = stream.m61($this.j69_1.s66_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  $this.k69_1._v = true;
  try {
    var temp = new AudioSamples(stream.x60_1, 2048);
    var started = false;
    while (_PlaybackTimes___get_hasMore__impl__ei8boc($this.l69_1._v.p66_1)) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      var tmp$ret$1 = toDuration(0, DurationUnit_SECONDS_getInstance());
      var tmp_1 = stream.m61(tmp$ret$1, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      $l$loop: while (true) {
        while ($this.m69_1.w5r_1) {
          // Inline function 'korlibs.time.milliseconds' call
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$3 = toDuration(2, DurationUnit_MILLISECONDS_getInstance());
          var tmp_2 = delay(tmp$ret$3, $completion);
          if (tmp_2 === get_COROUTINE_SUSPENDED())
            tmp_2 = yield tmp_2;
        }
        if (!($this.n69_1._v == null)) {
          // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
          var this_0 = $this.o69_1;
          $l$block: {
            // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
            this_0.f1x();
            try {
              $this.p69_1.e3();
              break $l$block;
            }finally {
              this_0.h1x();
            }
          }
          var tmp_3 = stream.m61(ensureNotNull($this.n69_1._v).nj_1, $completion);
          if (tmp_3 === get_COROUTINE_SUSPENDED())
            tmp_3 = yield tmp_3;
          $this.n69_1._v = null;
        }
        var tmp_4 = stream.n61(temp, 0, temp.i5r_1, $completion);
        if (tmp_4 === get_COROUTINE_SUSPENDED())
          tmp_4 = yield tmp_4;
        var read = tmp_4;
        // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
        var this_1 = $this.o69_1;
        $l$block_0: {
          // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
          this_1.f1x();
          try {
            $this.p69_1.f66(temp, 0, read);
            break $l$block_0;
          }finally {
            this_1.h1x();
          }
        }
        if (stream.k61() || $this.p69_1.w14() >= $this.q69_1) {
          if (!started) {
            started = true;
            $this.m69_1.q5s();
          } else if ($this.p69_1.w14() >= imul($this.q69_1, 2)) {
            while ($this.p69_1.w14() >= $this.q69_1) {
              // Inline function 'korlibs.time.milliseconds' call
              // Inline function 'kotlin.time.Companion.milliseconds' call
              Companion_getInstance();
              var tmp$ret$9 = toDuration(1, DurationUnit_MILLISECONDS_getInstance());
              var tmp_5 = delay(tmp$ret$9, $completion);
              if (tmp_5 === get_COROUTINE_SUSPENDED())
                tmp_5 = yield tmp_5;
            }
          }
        }
        var tmp_6 = yield_0($completion);
        if (tmp_6 === get_COROUTINE_SUSPENDED())
          tmp_6 = yield tmp_6;
        if (stream.k61())
          break $l$loop;
      }
      var tmp_7 = yield_0($completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
      $this.l69_1._v = new PlaybackTimes(_PlaybackTimes___get_oneLess__impl__ea0jl8($this.l69_1._v.p66_1));
    }
    $this.r69_1._v = true;
    var n = 0;
    $l$loop_0: while (true) {
      var tmp_8;
      if ($this.m69_1.b5s_1 && $this.p69_1.w14() > 0) {
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        tmp_8 = _unary__edvuaz < 8;
      } else {
        tmp_8 = false;
      }
      if (!tmp_8) {
        break $l$loop_0;
      }
      var tmp_9 = delay_0(new Long(10, 0), $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
    }
  } catch ($p) {
    if ($p instanceof CancellationException) {
      var e = $p;
      var tmp42_safe_receiver = $this.j69_1.y66_1;
      if (tmp42_safe_receiver == null)
        null;
      else
        tmp42_safe_receiver();
    } else {
      throw $p;
    }
  }
  finally {
    $this.m69_1.r5s();
    if ($this.h69_1.d69_1) {
      stream.g6();
    }
    $this.k69_1._v = false;
    Companion_getInstance_16().t69_1.g2t($this.s69_1);
    var tmp43_safe_receiver = $this.j69_1.z66_1;
    if (tmp43_safe_receiver == null)
      null;
    else
      tmp43_safe_receiver();
    var tmp44_safe_receiver = $this.h69_1.f69_1;
    if (tmp44_safe_receiver == null)
      null;
    else {
      var tmp_10 = tmp44_safe_receiver($completion);
      if (tmp_10 === get_COROUTINE_SUSPENDED())
        tmp_10 = yield tmp_10;
    }
  }
  return Unit_instance;
}
var Companion_instance_13;
function Companion_getInstance_16() {
  if (Companion_instance_13 === VOID)
    new Companion_12();
  return Companion_instance_13;
}
function play$close(job) {
  job.j17();
}
function SoundAudioStream$play$lambda($dequeLock, $flushing, $deque, $BUFFER_SAMPLES) {
  return function (it) {
    AudioSampleArray__fill$default_impl_gh9lh0(it.j5s_1, Companion_getInstance_1().k5s_1);
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = $dequeLock;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.f1x();
      try {
        if ($flushing._v || $deque.w14() >= $BUFFER_SAMPLES) {
          $deque.k66(it);
        }
        break $l$block;
      }finally {
        this_0.h1x();
      }
    }
    return Unit_instance;
  };
}
function SoundAudioStream$play$slambda_0(this$0, $newStream, $params, $playing, $times, $nas, $currentPositionRequest, $dequeLock, $deque, $BUFFER_SAMPLES, $flushing, $channelId) {
  var i = new SoundAudioStream$play$slambda(this$0, $newStream, $params, $playing, $times, $nas, $currentPositionRequest, $dequeLock, $deque, $BUFFER_SAMPLES, $flushing, $channelId);
  var l = function ($this$launch, $completion) {
    return i.h1p($this$launch, $completion);
  };
  l.$arity = 1;
  return l;
}
function volume$factory_2($b0) {
  return getPropertyCallableRef('volume', 0, KMutableProperty0, function () {
    return $b0.y5r_1;
  }, function (value) {
    $b0.y5r_1 = value;
    return Unit_instance;
  });
}
function pitch$factory_2($b0) {
  return getPropertyCallableRef('pitch', 0, KMutableProperty0, function () {
    return $b0.t5s();
  }, function (value) {
    return $b0.s5s(value);
  });
}
function panning$factory_2($b0) {
  return getPropertyCallableRef('panning', 0, KMutableProperty0, function () {
    return $b0.z5r_1;
  }, function (value) {
    $b0.z5r_1 = value;
    return Unit_instance;
  });
}
function volume$factory_3() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.m5s();
  }, function (receiver, value) {
    return receiver.l5s(value);
  });
}
function volume$factory_4() {
  return getPropertyCallableRef('volume', 1, KMutableProperty1, function (receiver) {
    return receiver.m5s();
  }, function (receiver, value) {
    return receiver.l5s(value);
  });
}
function pitch$factory_3() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.t5s();
  }, function (receiver, value) {
    return receiver.s5s(value);
  });
}
function pitch$factory_4() {
  return getPropertyCallableRef('pitch', 1, KMutableProperty1, function (receiver) {
    return receiver.t5s();
  }, function (receiver, value) {
    return receiver.s5s(value);
  });
}
function panning$factory_3() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.o5s();
  }, function (receiver, value) {
    return receiver.n5s(value);
  });
}
function panning$factory_4() {
  return getPropertyCallableRef('panning', 1, KMutableProperty1, function (receiver) {
    return receiver.o5s();
  }, function (receiver, value) {
    return receiver.n5s(value);
  });
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(AudioFormat, 'AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(AudioFormats, 'AudioFormats', AudioFormats, VOID, VOID, [2, 4]);
initMetadataForClass(Info, 'Info', Info);
initMetadataForLambda(AudioFormat$decodeStream$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(AudioDecodingProps, 'AudioDecodingProps', AudioDecodingProps);
initMetadataForClass(InvalidAudioFormatException, 'InvalidAudioFormatException');
initMetadataForClass(MP3Base, 'MP3Base', MP3Base, VOID, VOID, [2, 4]);
initMetadataForClass(MP3, 'MP3', MP3, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_1, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(ChannelMode, 'ChannelMode');
initMetadataForClass(Mp3Info, 'Mp3Info');
initMetadataForCompanion(Companion_3, VOID, VOID, [1]);
initMetadataForClass(SeekingTable, 'SeekingTable');
initMetadataForClass(Parser, 'Parser', VOID, VOID, VOID, [0, 2, 3, 1]);
initMetadataForClass(MP3Decoder, 'MP3Decoder', MP3Decoder, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_4, VOID, VOID, [2, 4]);
initMetadataForClass(MiniMp3Program, 'MiniMp3Program', MiniMp3Program);
initMetadataForClass(Minimp3Decoder, 'Minimp3Decoder', Minimp3Decoder, VOID, [MiniMp3Program, AutoCloseable]);
initMetadataForClass(BaseMinimp3AudioFormat, 'BaseMinimp3AudioFormat', VOID, VOID, VOID, [2, 3, 4]);
initMetadataForObject(Minimp3AudioFormat, 'Minimp3AudioFormat', VOID, VOID, VOID, [2, 4]);
initMetadataForClass(BaseMp3DecoderInfo, 'BaseMp3DecoderInfo', BaseMp3DecoderInfo);
initMetadataForCompanion(Companion_5);
initMetadataForClass(AudioStream, 'AudioStream', VOID, VOID, [AutoCloseable], [1, 3, 0]);
initMetadataForClass(BaseMinimp3AudioFormat$createDecoderStream$2, VOID, VOID, VOID, VOID, [1, 3, 0]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(L12_subband_alloc_tStruct, 'L12_subband_alloc_tStruct');
initMetadataForClass(Mp3Dec, 'Mp3Dec', Mp3Dec.d5x);
initMetadataForClass(Bs, 'Bs', Bs);
initMetadataForClass(Mp3Scratch, 'Mp3Scratch', Mp3Scratch.k63);
initMetadataForClass(Mp3FrameInfo, 'Mp3FrameInfo', Mp3FrameInfo);
initMetadataForClass(ArrayPtr, 'ArrayPtr');
initMetadataForClass(UByteArrayIntPtr, 'UByteArrayIntPtr');
initMetadataForClass(FloatArrayPtr, 'FloatArrayPtr');
initMetadataForClass(ShortArrayPtr, 'ShortArrayPtr');
initMetadataForClass(GrInfo, 'GrInfo', GrInfo);
initMetadataForClass(ScaleInfo, 'ScaleInfo', ScaleInfo);
initMetadataForClass(WAV, 'WAV', WAV, VOID, VOID, [2, 4]);
initMetadataForCompanion(Companion_7, VOID, VOID, [2, 4]);
initMetadataForClass(Chunk, 'Chunk');
initMetadataForClass(ProcessedChunk, 'ProcessedChunk');
initMetadataForClass(WavAudioStream, 'WavAudioStream', VOID, VOID, VOID, [1, 3, 0]);
initMetadataForClass(Fmt, 'Fmt', Fmt);
initMetadataForLambda(WAV$parse$slambda, VOID, VOID, [1]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(AudioSamplesDeque, 'AudioSamplesDeque');
initMetadataForCompanion(Companion_9);
initMetadataForLambda(createSound$slambda, VOID, VOID, [0]);
initMetadataForCompanion(Companion_10);
initMetadataForClass(PlaybackTimes, 'PlaybackTimes');
initMetadataForCompanion(Companion_11);
initMetadataForClass(PlaybackParameters, 'PlaybackParameters', PlaybackParameters, VOID, [ReadonlySoundProps]);
initMetadataForInterface(SoundPlay, 'SoundPlay', VOID, VOID, VOID, [1, 2, 3]);
protoOf(Sound).l67 = play$default;
initMetadataForClass(Sound, 'Sound', VOID, VOID, [SoundProps, SoundPlay], [1, 0, 2, 3]);
initMetadataForClass(SoundChannel, 'SoundChannel', VOID, VOID, [SoundProps]);
initMetadataForClass(SoundAudioData$play$4);
initMetadataForClass(SoundAudioData, 'SoundAudioData', VOID, VOID, VOID, [1, 2, 0, 3]);
initMetadataForCompanion(Companion_12);
initMetadataForLambda(SoundAudioStream$play$slambda, VOID, VOID, [1]);
initMetadataForClass(SoundAudioStream$play$1);
initMetadataForClass(SoundAudioStream, 'SoundAudioStream', VOID, VOID, VOID, [1, 0, 2, 3]);
//endregion
//region block: init
Companion_instance_0 = new Companion();
Companion_instance_9 = new Companion_8();
DEFAULT_MAX_SAMPLES = 39690000;
Companion_instance_10 = new Companion_9();
//endregion
//region block: exports
export {
  readMusic as readMusic27z8rq3uu0hc8,
};
//endregion
